<template>
  <div
    class="draw-part"
    ref="drawPartRef"
    @click="handleCanvasContainer"
    :style="isNotShowTitle ? drawClass : notDrawClass"
  >
    <div class="category-sticky" ref="topInfoRef">
      <div class="bigpart-category flex">
        <div>
          <div
            class="fold-canvas bigpart-info-title inline-block mr10"
            @click="isShowPaiban = !isShowPaiban"
          >
            <m-folder-btn
              size="16px"
              :class="{ 'unfolder-btn': isShowPaiban }"
            ></m-folder-btn>
          </div>
          <span
            class="bigpart-info-title"
            @click="isShowPaiban = !isShowPaiban"
          >
            <span class="fs16 color-o-9">{{ bigPlankInfo }}</span>
          </span>
          <div v-if="isScaleTop && isFolderInfo" class="inline-block">
            <a-button
              type="link"
              class="flex flex-cross--center"
              @click="isFolderInfo = !isFolderInfo"
            >
              <m-folder-btn
                type="primary"
                size="16px"
                class="ml3"
                :class="{ 'right-btn': isFolderInfo }"
              ></m-folder-btn>
            </a-button>
          </div>
          <div v-if="isScaleTop && !isFolderInfo" class="inline-block">
            <a-button
              type="link"
              class="flex flex-cross--center"
              @click="isFolderInfo = !isFolderInfo"
              >{{ $t('common.moreInfo') }}
              <m-folder-btn
                type="primary"
                size="16px"
                class="ml3"
                :class="{ 'left-btn': !isFolderInfo }"
              ></m-folder-btn>
            </a-button>
          </div>
          <div
            v-else
            class="inline-block"
            @click="isShowPaiban = !isShowPaiban"
          >
            <span class="bigpart-info-title"
              >{{ $t('arrangedPage.plankCount') }}：<span class="bigpart-info">
                {{ drawData.counts }}</span
              ></span
            >
            <span class="bigpart-info-title"
              >{{ $t('arrangedPage.rollCount') }}：<span class="bigpart-info">{{
                drawData.fanbanCount
              }}</span></span
            >
            <span class="bigpart-info-title"
              >{{ $t('common.rate') }}：<span class="bigpart-info">{{
                drawData.usedRate
                  ? drawData.usedRate >= 1
                    ? `${(100).toFixed(2)}%`
                    : `${(drawData.usedRate * 100).toFixed(2)}%`
                  : '0%'
              }}</span></span
            >
            <span class="bigpart-info-title"
              >{{ $t('arrangedPage.useArea') }}：<span class="bigpart-info"
                >{{
                  drawData.usedArea
                    ? (Number(drawData.usedArea.toString()) / 1000000).toFixed(
                        2
                      )
                    : 0
                }}m²</span
              ></span
            >
            <!-- <span v-if="isScaleTop" class="">jhhkfhjkah</span> -->
            <span v-show="isHighPlank" class="high-plank mr15">{{
              matchHighlightBoardName(restoreOriginalMatcode(drawData.matCode))
            }}</span>
            <a-tooltip :title="`混排颜色：(${mixPaibanTexture.join('、')})`">
              <span v-if="mixPaibanTexture.length" class="mix-plan mr15">{{
                $translateLang('混排')
              }}</span>
            </a-tooltip>
          </div>
        </div>
        <div
          v-if="
            ((drawData.counts > 10 && !isOnlyShowSurplus) ||
              filterList.length > 10) &&
            isShowPaiban
          "
          class="pageable"
        >
          <a-select
            v-model="countPerPage"
            dropdownMatchSelectWidth
            dropdownClassName="tex-dir-select"
            :getPopupContainer="
              (triggerNode) => {
                return triggerNode.parentNode
              }
            "
            @change="handleChangePerPage"
          >
            <a-select-option
              v-for="line in perPageList"
              :key="line.value"
              :value="line.value"
            >
              {{ line.label }}
            </a-select-option>
          </a-select>
          <a-button
            class="pre-btn mh6"
            @click="handlePrePage"
            :disabled="currentPape == 1"
          >
            <span
              class="iconfont icon-arrow"
              style="transform: rotate(-90deg)"
            ></span>
          </a-button>
          <a-select
            v-model="currentPape"
            :dropdownMatchSelectWidth="false"
            :getPopupContainer="
              (triggerNode) => {
                return triggerNode.parentNode
              }
            "
            @change="handleChangeCurrentPage"
          >
            <a-select-option
              v-for="page in totalPage"
              :key="page"
              :value="page"
              popper-class="current-page"
            >
              {{ page }}/{{ totalPage }}
            </a-select-option>
          </a-select>
          <a-button
            class="next-btn ml6"
            @click="handleNextPage"
            :disabled="currentPape == totalPage"
          >
            <span
              class="iconfont icon-arrow"
              style="transform: rotate(90deg)"
            ></span>
          </a-button>
        </div>
      </div>
    </div>
    <div class="canvas-box" v-show="isShowPaiban">
      <canvas
        :id="`canvas${canvasKey}`"
        :ref="`canvas${canvasKey}`"
        @mousedown="clickCanvas"
        @mouseup="clickUpCanvasFn"
        @mousemove="movePlank"
        @mousewheel="wheelScale"
        @contextmenu.prevent
        @dblclick="gotoSubtle"
      ></canvas>
    </div>
    <div
      :style="`top: ${canvasBtn.top}px; left: ${canvasBtn.left}px`"
      v-if="canvasBtn.data && isShowPaiban"
      class="bigpart-operation"
    >
      <a-tooltip v-if="canUseLayoutReuse" placement="top">
        <template slot="title">
          {{
            activeBigpart?._isReused
              ? $translateLang('点击清除复用关系')
              : $translateLang('快速复刻大板排版布局，板件变动自动解除复用关系')
          }}
        </template>
        <div
          @click="handleLayoutReuse()"
          class="w100"
          :title="
            activeBigpart?._isReused
              ? $translateLang('已被复用')
              : $translateLang('布局复用')
          "
          v-bp="'layout:plank_reuse'"
        >
          <a-icon
            type="copy"
            style="margin: 0 9px"
            :style="activeBigpart?._isReused ? { color: '#18a8c7' } : {}"
          />
          <span
            style="width: 80%"
            class="inline-block ellipsis"
            :style="activeBigpart?._isReused ? { color: '#18a8c7' } : {}"
          >
            {{
              activeBigpart?._isReused
                ? $translateLang('已被复用')
                : $translateLang('布局复用')
            }}
          </span>
        </div>
      </a-tooltip>
      <div
        @click="useSurplus()"
        class="w100"
        :title="translateLang('arrangedPage.useSurplus.title')"
      >
        <span class="iconfont icon-yuliao"></span>
        <span style="width: 80%" class="inline-block ellipsis">{{
          $t('arrangedPage.useSurplus.title')
        }}</span>
      </div>
      <div
        @click="gotoSubtleByBtn()"
        class="w100"
        :title="translateLang('arrangedPage.subtleArrange')"
      >
        <span class="iconfont icon-check"></span>
        <span style="width: 80%" class="inline-block ellipsis">{{
          $t('arrangedPage.subtleArrange')
        }}</span>
      </div>
      <!-- 旋转大板 -->
      <a-popover placement="right">
        <template slot="content">
          <a-button
            @click="handleRotateBigPlank(activeBigpart, 90)"
            icon="sync"
            style="display: block; color: #000"
            type="link"
            v-bp="'layout:bigPlankRotate'"
            >{{ $translateLang('旋转{angle}', { angle: 90 }) }}</a-button
          >
          <a-button
            @click="handleRotateBigPlank(activeBigpart, 180)"
            icon="sync"
            style="display: block; color: #000"
            type="link"
            v-bp="'layout:bigPlankRotate'"
            >{{ $translateLang('旋转{angle}', { angle: 180 }) }}</a-button
          >
          <a-button
            @click="handleRotateBigPlank(activeBigpart, 270)"
            icon="sync"
            style="display: block; color: #000"
            type="link"
            v-bp="'layout:bigPlankRotate'"
            >{{ $translateLang('旋转{angle}', { angle: 270 }) }}</a-button
          >
        </template>
        <div
          class="w100"
          :title="
            $translateLang('旋转{angle}', { angle: $translateLang('板件') })
          "
        >
          <span class="iconfont icon-recover"></span>
          <span style="width: 80%" class="inline-block ellipsis">
            {{
              $translateLang('旋转{angle}', { angle: $translateLang('板件') })
            }}
          </span>
        </div>
      </a-popover>
      <div
        @click="handleEditPlankSize()"
        class="w100"
        :title="$translateLang('修改尺寸')"
        v-if="
          activeBigpart &&
          !isBrandBigPlank &&
          (!activeBigpart.surplusInfo || !activeBigpart.surplusInfo.is_plus)
        "
      >
        <span class="iconfont el-icon-edit"></span>
        <span style="width: 80%" class="inline-block ellipsis">{{
          $translateLang('修改尺寸')
        }}</span>
      </div>
      <div
        @click="addNewBigpart()"
        class="w100"
        :title="translateLang('arrangedPage.addPlank')"
      >
        <span class="iconfont icon-add"></span>
        <span style="width: 80%" class="inline-block ellipsis">{{
          $t('arrangedPage.addPlank')
        }}</span>
      </div>
      <div
        @click="deleteBigpart()"
        class="w100"
        :title="translateLang('arrangedPage.deletePlank')"
      >
        <span class="iconfont el-icon-delete"></span>
        <span style="width: 80%" class="inline-block ellipsis">{{
          $t('arrangedPage.deletePlank')
        }}</span>
      </div>
    </div>
    <div
      class="fixed p10 bg-dark color-f br4"
      v-show="lockHoverInfo.isShow"
      :style="{
        top: `${lockHoverInfo.top}px`,
        left: `${lockHoverInfo.left}px`,
      }"
    >
      <span v-if="lockHoverInfo.isLocked">
        {{ $t('arrangedPage.lockTip1') }}<br />{{ $t('arrangedPage.lockTip2') }}
      </span>
      <span v-else>
        {{ $t('arrangedPage.unlockTip1') }}<br />{{
          $t('arrangedPage.unlockTip2')
        }}
      </span>
    </div>
    <a-modal
      :visible="crossMaterialConfirm.visible"
      :maskClosable="false"
      :closable="false"
      @ok="confirmCrossMaterial"
      @cancel="cancelCrossMaterial"
    >
      <template slot="title">
        <span style="color: red">{{ $translateLang('注意') }}</span>
      </template>
      <p
        v-html="
          $translateLang(
            '您目前正在跨不同材质或颜色挪动小板，{highlight}，是否继续完成挪动？',
            {
              highlight: `<span style=\'color: red\'>${$translateLang(
                '挪动后生产出的小板可能和拆单的小板材质颜色不一致'
              )}</span>`,
            }
          )
        "
      ></p>
      <a-checkbox v-model="crossMaterialConfirm.dontShowAgain">{{
        $translateLang('本次排版不再提示')
      }}</a-checkbox>
    </a-modal>
  </div>
</template>

<script>
// import LockedImg from '@/assets/jiesuo.png'
// import UnLockedImg from '@/assets/suoding.png'
import { DrawPlankColorJs } from '@/data/plank'
import store from '@/store'
import { isSawPaiban } from '@/util/LayoutFuncs'
import { getSawKnife } from '@/util/LayoutFuncs'
import { rolloverPlank } from '@/util/LayoutFuncs.js'
import { dealPlankExpandKnife } from '@/util/LayoutFuncs.js'
import {
  addPropForPart,
  dealExpandSlot,
  matchLayeredCutForPalnkThick,
  rotate180Part,
  rotatePart,
} from '@/util/LayoutTool.js'
import EventBus, { EventBusKey } from '@/util/bus'
import {
  BigPlankDrawer,
  initBigPlanksPositionToCanvas,
} from '@/util/canvas/drawBigPlank'
import { Plank } from '@/util/canvas/drawPlank'
import {
  dealHighlightMatCode,
  isHighBigPlank,
  matchHighlightBoardName,
  restoreOriginalMatcode,
  translate,
} from '@/util/commonFun'
import {
  calcClosePlank,
  calcPlankSize,
  isSamePart,
} from '@/util/commonFuncs.js'
import { buryPointApi, compareTowNum } from '@/util/commonFuncs.js'
import {
  checkOneBigpart,
  checkOnePlank,
  checkPlankHoleSlot,
  dealBigPlank,
  dealPlankPoly,
  getPlateKnifeDiameter,
} from '@/util/dealPaibanData.js'
import { expandPath } from '@/util/dealPlankDataFuncs'
import {
  dealCurrentPointDistance,
  drawActivePlankOtherInfo,
  drawMarkRectTip,
  drawPlankEmptyDistance,
  drawPlankHSDetailInfo,
} from '@/util/dealPlankExtraDraw'
import { plankDrawFactory } from '@/util/drawPlank'
import {
  calcBigpartArea,
  checkPointInRect,
  circleText,
} from '@/util/drawPlankFuncs'
import { judgeRectIntersect } from '@/util/graphCalc'
import {
  getSameGroupParts,
  isTextureAlignmentPlank,
  showTextureConfirmModal,
} from '@/util/plankAlignTexture'
import {
  PlankControl,
  clearPlankToBigPlank,
  dealPathToBasePoint,
  getPathMinMaxPoint,
  getPlankMatCode,
  isExistPriority,
  isPlankTypeSame,
  mousePointISInElement,
  partIsConflict,
  rotateBigPlank,
  supplementBigPlankParam,
} from '@/util/plankCommonFuncs'
import { polyContain } from '@/util/polygonRelation.js'
import { replayTransform } from '@/util/recordTransform'
import { updateBlueAreaSurplusPart } from '@/util/tailorSurplus'
import { toUpperCasePoint } from '@/util/transform/graph'
import { transformData } from '@/views/newPaiban/util/transformData'
import { mapMutations, mapState } from 'vuex'

import { checkPrelayoutSettingChanged } from '../materialsList/util/preLayoutDeal'
import mFolderBtn from './component/m-folder-btn'
import mMenu from './component/m-menu/index.vue'
import {
  genAwaitStoreData,
  getPlankImage,
} from './component/m-paiban-store/utlis'
import { checkCurrentDragPlankDataIsLoad } from './component/m-paiban-store/utlis'
import edgeCenterStripMixin from './mixins/edgeCenterStripMixin'
import { getPlankMaxIndexByFinalDrawData } from './util'
import { buildClampHandInfoForPlank } from './util/checkClampHand'
import {
  compareMap,
  getBrandDragErrorTipKey,
  getOriginalPartForCrossMaterialExpand,
  isBrandBigPlank,
  isNormalPlankPart,
  isPaibanLock,
  isReuseBoard,
  isReuseChild,
  isReuseParent,
  isSurplusBigPlank,
  layoutReuse,
} from './util/layoutDataDeal'
import { getCachedRawPlank } from './util/renderUrlCache'

// 默认缩放比例
// const defaultScale = 1
const defaultScale = 6
// 大板和大板边框的默认偏移值
const defaultDeviation = 5
// 下刀顺序距边的默认距离
const defaultTextWidth = 3
// 记录大板之间的间距
const defaultPadding = 65
// 下刀点距边的默认距离
const defaultDotWidth = 5
// 小板件的线宽
const partLineWidth = 1
// 用于防抖
let _debounceTime = null

export default {
  components: {
    mFolderBtn,
    mMenu,
  },
  mixins: [edgeCenterStripMixin],
  props: {
    isShowPartSize: {
      type: Boolean,
    },
    drawData: {
      type: [Object, Array],
    },
    canvasKey: {
      type: Number,
    },
    canvasMaxWidth: {
      type: Number,
    },
    canvasMaxHeight: {
      type: Number,
    },
    isCuttingOrder: {
      type: Boolean,
    },
    activePlankID: {
      type: Number,
    },
    activePlankIndex: {
      type: Number,
    },
    startNum: {
      type: Number,
      default: 1,
    },
    clearConflict: {
      type: Function,
    },
    isOnlyShowSurplus: {
      type: Boolean,
      default: false,
    },
    isBatchBujian: {
      type: Boolean,
      default: false,
    },
    batchBujianList: {
      type: Array,
      default: () => [],
    },
    isBatchTagging: {
      type: Boolean,
      default: false,
    },
    currentStoreType: {
      type: String,
      default: 'awaitStore',
    },
    batchTaggingList: {
      type: Array,
      default: () => [],
    },
    /** 计算统计翻板数以及当前大板翻板数 */
    calcFanbanCount: {
      type: Function,
    },
    /** 重新计算下刀点个顺序 */
    calcCutPositionOrder: {
      type: Function,
    },
    /** 是否显示删除按钮，默认展示 */
    isShowDelete: {
      type: Boolean,
      default: true,
    },
    /** 余料不参与利用率计算 */
    isUnuseSurplus: {
      type: Boolean,
      default: true,
    },
    /** 停用板件吸附 */
    isUsePlankAdsorption: {
      type: Boolean,
      default: false,
    },
    /** 排版页 数据默认收起 */
    isDrawPartCollapsed: {
      type: Boolean,
      default: false,
    },
    /** 添加/删除板件时触发 */
    onPartChange: {
      type: Function,
      default: () => null,
    },
    // 当前大板是否满足大板板厚分层切割条件
    isMatchedLayeredForPartThick: {
      type: Boolean,
      default: false,
    },
    isMarkModifiedSmallBoards: {
      type: Boolean,
      default: false,
    },
    /** 开启后键盘移动使用 moveStep，并在选中板件时显示四边中心与其它板件/大板边的距离 */
    isShowMoveStep: {
      type: Boolean,
      default: false,
    },
    moveStep: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      filterList: [],
      isTextureConfirming: false,
      drawClass: {
        height: '0px',
        marginBottom: '0px',
        overflow: 'hidden',
      },
      notDrawClass: {},
      isNotShowTitle: false,
      // 是否显示锁定logo
      isShowLock: false,
      // UnLockedImgInstance: null,
      // LockedImgInstance: null,
      // 锁定的hoverInfo
      lockHoverInfo: {
        isShow: false,
        top: 0,
        left: 0,
        isLocked: false,
      },
      isFirst: true,
      // LockedImg,
      // UnLockedImg,
      // 是否显示绘制区域 默认不显示
      isShowPaiban: true,
      // 记录canvas的dom元素
      canvasDom: {},
      // 记录canvas绘制上下文
      ctx: {},
      // 记录选择的板件
      activePlank: null,
      // 记录激活的大板
      activeBigpart: null,
      // 记录点击时激活板件的起始点
      plankStartPoint: null,
      // 是否正在移动板件
      isMovingPlank: false,
      // 记录绘制时的起始点
      startLeft: 0,
      startTop: 0,
      // 是否处于缩放状态
      isScaling: false,
      // 缩放比例
      oriScale: 6,
      scale: defaultScale,
      // 相对于默认缩放比例的比例
      scalePercent: 1,
      // 上次的缩放比例
      lastScale: 1,
      // 大板和大板边框的偏移值
      deviation: 5,
      // 下刀点距边的距离
      dotWidth: 5,
      // 下刀顺序距边的距离
      textWidth: 3,
      // 记录大板之间的间距
      padding: 65,
      // 记录大板长宽
      plankWidth: 0,
      plankHeight: 0,
      // 记录绘制时的大板长宽
      scaleWidth: 0,
      scaleHeight: 0,
      // 记录当前绘制每一行绘制几个大板
      perNum: 0,
      // 记录右键拖拽板件时, 鼠标偏移量
      canvasOffset: null,
      // 记录是否在拖拽画布
      isMovingCavnas: false,
      // 记录右键点击的位置
      canvasRightDrag: {},
      // 键盘按下事件
      keyDownEvent: null,
      /** 四边中心到障碍物距离（源坐标 mm），仅 isShowMoveStep 时使用 */
      edgeCenterDistances: null,
      /** 当前帧选中大板容器起点，供距离标尺最后叠画（避免被 drawPlankEmptyDistance 等盖住） */
      edgeOverlayCanvasOrigin: null,
      // 键盘松开事件
      keyUpEvent: null,
      // 鼠标滚轮事件
      mouseWheelEvent: null,
      // 鼠标松开事件
      mouseupEvent: null,
      activePlankOff: null,
      // 记录鼠标移动时鼠标的位置
      dragPosition: null,
      plankRealOff: null,
      canvasBtn: {
        left: 0,
        top: 0,
        data: null,
      },
      // 用于键盘控制时判断是否在获取选中板件的线段
      isActivePlankLine: false,
      plankMapImg: {}, // 板件映射img
      imageTempMousedownFlag: false, // 生成图片是否被鼠标点击的标记
      mousePointOffsetImage: {}, // 记录点击到图片的鼠标距离图片左上角的距离
      isDrawImage: false, // 是否把选中项绘制成图片
      isUseImage: true, // 是否使用点击生成图片的模式（用于测试，测试通过后可以只取代码中为true的逻辑）
      hasMoved: false, // 点击生成的图片是否已经移动过
      // 记录canvasKey
      refKey: null,
      // 用于canvas尺寸防抖
      canvasTime: null,
      // 每页张数选择列表
      perPageList: [
        {
          label: `10${translate('common.unit')}`,
          value: 10,
        },
        {
          label: `20${translate('common.unit')}`,
          value: 20,
        },
        {
          label: `30${translate('common.unit')}`,
          value: 30,
        },
        {
          label: `50${translate('common.unit')}`,
          value: 50,
        },
      ],
      // 用于保存每页多少张大板
      countPerPage: 20,
      // 用于保存当前页数
      currentPape: 1,
      // 保存总共多少页
      totalPage: 1,
      // 保存当前绘制大板
      sliceDrawData: [],
      // 记录板件空白位置距离
      emptyDistance: false,
      // 记录点击的位置
      mousePoint: null,
      // 记录孔槽详细信息
      hsDetailInfoList: [],
      // 记录孔槽详细绘制后是否再需要重新绘制一次,防止过多的重绘
      isRenderHSDetail: false,
      // 操作板件
      plankControl: null,
      // 点击点的offsetX和offsetY信息
      clickPointOffset: {},
      p1: {
        x: 0,
        y: 0,
      },
      p2: {
        x: 0,
        y: 0,
      },
      // 重叠部分的点位数组
      intersect: [],
      bujianList: [],
      // 余料库tooltip
      surStoreTooltip: [],
      isRenderSSTooltip: false,
      isScaleTop: false,
      isFolderInfo: true,
      activePartUniqueId: '',
      // 记录标记位置
      needMarkRectArr: [],
      // 绘制单面板提示用信息
      markRectTip: null,
      // 当前标记类型
      markRect: null,
      pointPosition: {
        x: 0,
        y: 0,
      },
      mMenuRef: null,
      menuList: [],
      taggingList: [],
      mouseOnBlueArea: {},
      blueAreaSurplusCaches: [], // 蓝色区域余料暂存区
      // 跨材质放置确认
      crossMaterialConfirm: {
        visible: false,
        bigpart: null,
        oriBigpart: null,
        dontShowAgain: false,
      },
      // 跨材质时保存的原始板件材质数据
      crossMaterialBackup: null,
    }
  },
  computed: {
    ...mapState([
      'ncSetting',
      'userInfo',
      'hasLblAuth',
      'isDragingPlank',
      // 'beDraggedPlank',
      'tempStorage',
      'tempImgPos',
      'surplusParams',
      'offsetPointbetweenCacheImage',
      'highlightFlip',
      'isHistoryStatus',
      'historyOrder',
      'selectStandardPlank',
      'preLayoutData',
      'oriLayoutSetting',
      'preLayoutSetting',
      'skipCrossMaterialConfirm',
    ]),
    showHighGlossTipType() {
      if (this.isHistoryStatus && this.isHighPlank) {
        return this.historyOrder.plank_info.highgloss_direction
          ? this.historyOrder.plank_info.highgloss_direction
          : 'back'
      } else if (!this.isHistoryStatus && this.isHighPlank) {
        return this.ncSetting.highgloss_direction
      } else {
        return false
      }
    },
    /** 当前大板是否可以使用板件复用 */
    canUseLayoutReuse() {
      if (!this.activeBigpart) return false
      // 余料大板不支持
      if (isSurplusBigPlank(this.activeBigpart)) return false
      // 子板不支持
      if (this.activeBigpart._reuseParentId) return false
      return true
    },
    bigPlankInfo() {
      const { thick, matCode, texture, brandName, supplierName } = this.drawData
      let name = thick + dealHighlightMatCode(matCode) + texture
      if (brandName && supplierName) {
        name += `-${brandName}-${supplierName}`
      }
      if (
        this.drawData.otherPlate &&
        Object.keys(this.drawData.otherPlate).length > 0
      ) {
        name += `（${translate('common.specialPlank')}）`
      } else {
        name += `（${translate('common.standardPlank')}）`
      }
      return name
    },
    // 是否是高光板
    isHighPlank() {
      const data = this.sliceDrawData
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].parts.length; j++) {
          if (data[i].parts[j]?.is_high_gloss_plank) {
            return true
          }
        }
      }
      return false
    },
    // 是否是品牌大板（品牌大板不支持修改尺寸）
    isBrandBigPlank() {
      return isBrandBigPlank(this.activeBigpart)
    },
    // 该大板采用的混排方案
    mixPaibanTexture() {
      return this.sliceDrawData
        .reduce((prev, cur) => {
          const { oriTextures } = cur
          prev = prev.concat(oriTextures)
          return prev
        }, [])
        .filter((item, index, self) => {
          return item && self.indexOf(item) === index
        })
    },
  },
  methods: {
    ...mapMutations([
      'changeDragingPlank',
      'deleteTempStorage',
      'addTempStorage',
      'changeTempStorage',
      'setSurplusParams',
      'setBatchTaggingList',
      'setSkipCrossMaterialConfirm',
    ]),
    // 单独修改大板尺寸
    handleEditPlankSize() {
      this.$emit('onEditPlankSize', true)
      this.canvasBtn.data = null
    },
    // 判断是否需要保留两位小数
    judgeDecimal(num) {
      const isDecimal = String(num).indexOf('.') + 1
      //小数点的位数
      const decimalPlaces = String(num).length - isDecimal
      if (isDecimal && decimalPlaces > 2) {
        num = num.toFixed(2)
      }
      return num
    },
    /**
     * 更新蓝色区域余料板件的rect相关属性
     * @param {Object} bigpart 大板数据
     */
    updateBlueAreaSurplusPart(bigpart) {
      this.blueAreaSurplusCaches = updateBlueAreaSurplusPart(
        bigpart,
        this.ncSetting,
        this.blueAreaSurplusCaches,
        [this.drawData]
      )
      this.$emit('setHasSavedSurplus')
    },

    /**
     * 绘制小板尺寸
     * @param { Object } part 小板数据
     * @param { Object } rect 小板的绘制属性
     */
    drawPartSize(ctx, part, rect) {
      const realWidth = this.judgeDecimal(part.realRect.width)
      const realHeight = this.judgeDecimal(part.realRect.height)
      const fontSize = 14 * this.scalePercent
      // 宽度的字体宽度
      const widthTextW = ctx.measureText(realWidth).width
      // 高度的字体宽度
      const heightTextW = ctx.measureText(realHeight).width
      // 高度文字的x、y
      const partHeight = {
        x: rect.x + this.textWidth,
        y: rect.y + this.tranlateSizeFromScale(realHeight / 2),
      }
      // 宽度文字的x、y
      const partWidth = {
        x: rect.x + this.tranlateSizeFromScale(realWidth / 2) - widthTextW / 2,
        y: rect.y + this.tranlateSizeFromScale(realHeight),
      }
      const specialPartWidth = {
        x: rect.x + this.tranlateSizeFromScale(realWidth / 2) - widthTextW / 2,
        y: rect.y + this.tranlateSizeFromScale(realHeight / 2) - fontSize / 2,
      }
      const specialPartHeight = {
        x: rect.x + this.tranlateSizeFromScale(realWidth / 2) - heightTextW / 2,
        y: rect.y + this.tranlateSizeFromScale(realHeight / 2) + fontSize,
      }
      // 普通矩形
      if (this.isShowPartSize) {
        if (!part.path) {
          // 绘制宽度文字底色
          this.drawPartSizeBg(
            ctx,
            partWidth.x,
            partWidth.y - fontSize,
            widthTextW,
            fontSize
          )
          // 绘制高度文字底色
          this.drawPartSizeBg(
            ctx,
            partHeight.x,
            partHeight.y - fontSize,
            heightTextW,
            fontSize
          )
          ctx.fillStyle = '#333'
          ctx.font = `bold ${fontSize}px 'PingFangSC-Regular, PingFang SC'`
          ctx.fillText(`${realWidth}`, partWidth.x, partWidth.y)
          ctx.fillText(`${realHeight}`, partHeight.x, partHeight.y)
        } else {
          // 绘制宽度文字底色
          this.drawPartSizeBg(
            ctx,
            specialPartWidth.x,
            specialPartWidth.y - fontSize,
            widthTextW,
            fontSize
          )
          // 绘制高度文字底色
          this.drawPartSizeBg(
            ctx,
            specialPartHeight.x,
            specialPartHeight.y - fontSize,
            heightTextW,
            fontSize
          )
          ctx.fillStyle = '#333'
          ctx.font = `bold ${fontSize}px 'PingFangSC-Regular, PingFang SC'`
          ctx.fillText(`${realWidth}`, specialPartWidth.x, specialPartWidth.y)
          ctx.fillText(
            `${realHeight}`,
            specialPartHeight.x,
            specialPartHeight.y
          )
        }
      }
    },
    // 绘制小板尺寸底色
    drawPartSizeBg(ctx, startX, startY, width, height) {
      ctx.beginPath()
      ctx.fillStyle = '#fff'
      ctx.rect(startX, startY, width, height)
      ctx.fill()
      ctx.closePath()
    },
    // 将size通过scale进行转换
    tranlateSizeFromScale(size) {
      return (size / defaultScale) * this.scalePercent
    },
    /**
     * 大板（使用对象上已维护的 width/height）与可视区域是否相交
     */
    isBigpartOverlappingView(bigpart, vxMin, vyMin, vxMax, vyMax) {
      return judgeRectIntersect(
        {
          x1: bigpart.startX,
          y1: bigpart.startY,
          x2: bigpart.startX + bigpart.width,
          y2: bigpart.startY + bigpart.height,
        },
        {
          x1: vxMin,
          y1: vyMin,
          x2: vxMax,
          y2: vyMax,
        }
      )
    },
    // 把size恢复成没有进行缩放前的值
    restoreScaleSize(scaleSize) {
      return (scaleSize / this.scalePercent) * defaultScale
    },
    handleChangePerPage(item) {
      this.countPerPage = item
      this.currentPape = 1
      this.startDraw()
      this.$emit('handleChangePerPage', item)
    },
    handleChangeCurrentPage(item) {
      this.currentPape = item
    },
    // 上一页
    handlePrePage() {
      this.currentPape -= 1
      this.startDraw()
    },
    // 下一页
    handleNextPage() {
      this.currentPape += 1
      this.startDraw()
    },
    startDraw() {
      if (this.isOnlyShowSurplus) {
        this.filterList = this.drawData.data.filter((item) => {
          return item.surplusInfo && !item.surplusInfo.isNotSurplus
        })
        if (!this.filterList.length) {
          this.isNotShowTitle = true
        } else {
          this.isNotShowTitle = false
        }
      } else {
        this.isNotShowTitle = false
      }
      this.$nextTick(() => {
        this.canvasDom = this.$refs[`canvas${this.canvasKey}`]
        const topInfoRef = this.$refs['topInfoRef']
        this.canvasDom.width =
          topInfoRef.offsetWidth < 988 ? 988 : topInfoRef.offsetWidth
        this.isScaleTop = topInfoRef.offsetWidth <= 988
        this.ctx = this.canvasDom.getContext('2d')
        this.totalPage = Math.ceil(this.drawData.counts / this.countPerPage)

        this.sliceDrawData =
          this.drawData.counts <= 10
            ? this.isOnlyShowSurplus
              ? this.drawData.data.filter((item) => {
                  return item.surplusInfo && !item.surplusInfo.isNotSurplus
                })
              : this.drawData.data
            : (this.isOnlyShowSurplus
                ? this.drawData.data.filter((item) => {
                    return item.surplusInfo && !item.surplusInfo.isNotSurplus
                  })
                : this.drawData.data
              ).slice(
                (this.currentPape - 1) * this.countPerPage,
                this.currentPape * this.countPerPage
              )
        // 初始化板件控制
        this.plankControl = new PlankControl(this, this.sliceDrawData)

        this.drawData.data.forEach((item) => {
          item.usedRate >= 1 ? (item.usedRate = 1) : item.usedRate
        })
        this.draw()
      })
    },
    // 鼠标双击事件, 前往精细排版
    gotoSubtle(e) {
      if (this.ncSetting.isPreLayout) {
        const hasPreLayoutSettingChanged = checkPrelayoutSettingChanged(
          this.oriLayoutSetting.setting_value,
          this.preLayoutSetting.setting_value
        )
        if (hasPreLayoutSettingChanged) {
          this.$emit('onGotoSubtleErr')
          return
        }
      }
      if (this.$props.isBatchBujian) {
        this.$message.warning('请先退出批量补件模式')
        return
      }
      if (this.$props.isBatchTagging) {
        this.$message.warning('请先退出批量补标签模式')
        return
      }
      let arr = this.sliceDrawData.filter(
        (v) => e.offsetX >= v.startX && e.offsetY >= v.startY
      )
      // 判断鼠标位置是否在大板所处的位置
      // 如果点到了第一块大板之前的区域, 是没有大板信息的, 所以直接弹回原位置重新绘制
      if (arr.length == 0) {
        this.activePlank.startX = this.plankStartPoint.x
        this.activePlank.startY = this.plankStartPoint.y
        this.plankRealOff = null

        this.renderAll()
        return
      }
      // 找到原数据中的bigpart
      // 找到当前鼠标位置的最后一个大板
      let targetBigpart = arr[arr.length - 1]
      let bigpart = this.sliceDrawData.find(
        (v) => v.stockKey == targetBigpart.stockKey
      )
      // 如果找到了大板则继续执行后面的逻辑, 否则弹回原位置重新绘制
      if (bigpart) {
        // 如果鼠标位置在大板上, 则继续执行后面的逻辑, 否则弹回原位置重新绘制
        if (
          e.offsetX <= bigpart.startX + bigpart.width + 2 * this.deviation &&
          e.offsetY <=
            bigpart.startY + bigpart.height + this.padding + 2 * this.deviation
        ) {
          this.emptyDistance = false
          this.$emit('gotoSubtle', bigpart)
        }
      }
    },
    // 更多操作里面前往精细排版
    gotoSubtleByBtn() {
      if (this.ncSetting.isPreLayout) {
        const hasPreLayoutSettingChanged = checkPrelayoutSettingChanged(
          this.oriLayoutSetting.setting_value,
          this.preLayoutSetting.setting_value
        )
        if (hasPreLayoutSettingChanged) {
          this.$emit('onGotoSubtleErr')
          return
        }
      }
      if (this.$props.isBatchBujian) {
        this.$message.warning('请先退出批量补件模式')
        return
      }
      if (this.$props.isBatchTagging) {
        this.$message.warning('请先退出批量补标签模式')
        return
      }
      this.emptyDistance = false
      this.$emit('gotoSubtle', this.activeBigpart)
    },
    // 更多操作里面使用余料
    useSurplus() {
      if (
        this.activeBigpart.surplusInfo &&
        Object.keys(this.activeBigpart.surplusInfo).length > 0 &&
        !this.activeBigpart.surplusInfo.isNotSurplus
      ) {
        this.$message({
          type: 'info',
          message: '该大板已经为余料大板, 不可继续替换余料!',
        })
        return
      }
      this.emptyDistance = false
      this.$emit('useSurplus', this.activeBigpart, this.canvasKey)
    },
    /**
     * @description 布局复用：以当前大板为模板，从同材质池中匹配板件组装复用大板
     * @returns {void}
     */
    handleLayoutReuse() {
      this.canvasBtn.data = null
      if (!this.activeBigpart) return
      if (!this.activeBigpart.parts.length) return
      // 如果已复用，清除复用标记
      if (this.activeBigpart._isReused) {
        this.clearReuseMarks(this.activeBigpart)
        return
      }
      // 检查特殊工艺
      if (this.activeBigpart.parts.some((p) => p.isExpanded)) {
        this.$message.warning(
          this.$translateLang('板件存在特殊工艺，不支持此操作')
        )
        return
      }
      // 检查冲突
      if (this.activeBigpart.parts.some((p) => p.plankMerge)) {
        this.$message.warning(this.$translateLang('板件存在冲突，不支持此操作'))
        return
      }
      // 父板只剩余料（含蓝色余料）时无法作为复用模板，否则会导致匹配循环无法收敛
      const hasNormalPart = this.activeBigpart.parts.some((p) =>
        isNormalPlankPart(p)
      )
      if (!hasNormalPart) {
        this.$message.warning(this.$translateLang('没有可用的板件进行复用'))
        return
      }
      const parentBoard = this.activeBigpart
      const parentIsHighGloss = parentBoard.parts.some(
        (p) => p.is_high_gloss_plank
      )
      // 收集所有同材质分组（含超尺板等）中其他大板的小板（排除父板自身，排除特殊工艺小板）
      const pool = this.$store.state.paibanData
        .filter((bigPlank) => {
          // 不是自身
          const isSelf = bigPlank.stockKey !== parentBoard.stockKey
          // 材质颜色厚度匹配
          const isSameType = isPlankTypeSame(bigPlank, parentBoard)
          // 高光
          const isHighGloss =
            bigPlank.parts.some((p) => p.is_high_gloss_plank) ===
            parentIsHighGloss
          // 非复用板
          const isNotReuse = !isReuseBoard(bigPlank)
          // 没有锁定
          const isNotLock = !isPaibanLock(bigPlank)
          return isSameType && isSelf && isHighGloss && isNotReuse && isNotLock
        })
        .flatMap((bigPlank) =>
          bigPlank.parts.filter(
            (part) => !part.isExpanded && isNormalPlankPart(part)
          )
        )
      if (!pool.length) {
        this.$message.warning(this.$translateLang('没有可用的板件进行复用'))
        return
      }
      // 计算所有同材质组的最大 stockNum
      let maxStockNum = 0
      this.$store.state.paibanData.forEach((bigPlank) => {
        if (
          isPlankTypeSame(bigPlank, parentBoard) &&
          bigPlank.parts.some((p) => p.is_high_gloss_plank) ===
            parentIsHighGloss
        ) {
          maxStockNum = Math.max(maxStockNum, bigPlank.stockNum || 0)
        }
      })
      // 父板余料（含蓝色余料）不参与复用匹配，只保留正常板件作为模板
      const parentBoardForReuse = {
        ...parentBoard,
        parts: parentBoard.parts.filter((p) => isNormalPlankPart(p)),
      }
      const { reusedBoards, unusedParts } = layoutReuse(
        parentBoardForReuse,
        pool,
        maxStockNum + 1
      )
      if (!reusedBoards.length) {
        this.$message.warning(this.$translateLang('未找到匹配的板件'))
        return
      }
      // 计算已使用的小板（从池中排除未使用的）
      const usedParts = pool.filter(
        (part) => !unusedParts.some((u) => u.partUniqueId === part.partUniqueId)
      )
      // 标记父板已被复用
      parentBoard._isReused = true
      this.canvasBtn.data = null
      // 记录操作
      this.$emit('onAddDataToOperateArr', {
        key: `复用大板${parentBoard.canvasIndex}`,
        dataArr: [
          {
            type: 'form',
            current: {
              parentBoardId: parentBoard.bigPlankUniqueId,
              parentStockNum: parentBoard.stockNum,
              childBoardIds: reusedBoards
                .map((b) => b.bigPlankUniqueId)
                .join(', '),
              childStockNums: reusedBoards.map((b) => b.stockNum).join(', '),
              reusedCount: reusedBoards.length,
            },
            ori: {
              parentBoardId: '',
              parentStockNum: 0,
              childBoardIds: '',
              childStockNums: '',
              reusedCount: 0,
            },
            compareMsg: [
              {
                title: `复用大板${parentBoard.canvasIndex}`,
                keys: [
                  'parentBoardId',
                  'parentStockNum',
                  'childBoardIds',
                  'childStockNums',
                  'reusedCount',
                ],
              },
            ],
            formTextObj: {
              parentBoardId: '父板唯一ID',
              parentStockNum: '父板序号',
              childBoardIds: '子板唯一ID',
              childStockNums: '子板序号',
              reusedCount: '复用数量',
            },
            formValueObj: {},
          },
        ],
      })
      this.$emit('onLayoutReuse', {
        reusedBoards,
        usedParts,
        unusedParts,
        parentBoard,
      })
    },
    /**
     * @description 清除父板和所有子板上的复用标记
     * @param {IBigPlank} parentBoard - 父板
     * @returns {void}
     */
    clearReuseMarks(parentBoard) {
      delete parentBoard._isReused
      // 清除子板标记
      this.drawData.data.forEach((bigPlank) => {
        if (bigPlank._reuseParentId === parentBoard.bigPlankUniqueId) {
          delete bigPlank._reuseParentId
        }
      })
      this.$emit('clearReuse', { parentBoard, canvasKey: this.canvasKey })
      this.renderAll()
    },
    /**
     * @description 检查大板是否需要清除复用信息，父板清除整组，子板清除自身
     * @param {IBigPlank} board - 大板对象
     * @returns {void}
     */
    emitClearReuseIfNeeded(board) {
      if (!board) return
      if (isReuseParent(board)) {
        this.$emit('clearReuseGroup', board)
      } else if (isReuseChild(board)) {
        this.$emit('clearSingleReuseChild', board)
      }
    },
    // 更多操作里面添加大板
    addNewBigpart() {
      let bigpart = this.activeBigpart
      this.emptyDistance = false
      this.$emit('addNewBigpart', bigpart, this.canvasKey)
      this.startDraw()
    },
    dealNewBigpart() {
      this.canvasDom.height = initBigPlanksPositionToCanvas(
        this.sliceDrawData,
        this.scalePercent,
        this.canvasDom.width
      )
      this.renderAll()
    },
    dealDeleteBigpart() {
      this.canvasBtn.data = null
      this.canvasDom.height = initBigPlanksPositionToCanvas(
        this.sliceDrawData,
        this.scalePercent,
        this.canvasDom.width
      )
      this.renderAll()
    },
    // 更多操作里面删除大板
    deleteBigpart() {
      // 判断是否是当前材质颜色厚度下面的最后一块板件
      let flag = false
      if (this.drawData.data.length <= 1) {
        flag = true // 当前材质颜色厚度下只有一块大板
        // 不允许删除提示 如果最后一张大板上有小板，目前逻辑是不允许删除的
        if (this.drawData.data[0].parts.length > 0) {
          return this.$message.error(
            this.translateLang('common.deleteBigPlankTip')
          )
        }
      }
      this.emptyDistance = false
      let bigpart = this.activeBigpart
      // 为了处理蓝色余料作为了正常余料放入了暂存区问题
      const newBigpart = {
        ...bigpart,
        parts: bigpart.parts.filter((item) => !item.blueAreaSurplus),
      }
      this.$emit(
        'deleteBigpart',
        newBigpart,
        this.canvasKey,
        this.preLayoutData,
        flag
      )
    },
    // 鼠标按下事件
    clickCanvas(e) {
      // this.$refs['mMenuRef'].closeMenu()
      // 手动关闭菜单选项
      this.$emit('leftClick')
      // 保存起始offset信息
      this.clickPointOffset.x = e.offsetX
      this.clickPointOffset.y = e.offsetY
      // 左键
      if (e.button == 0) {
        if (this.isMovingCavnas) return
        // 表明可以把选中项绘制成图片
        this.isDrawImage = true
        this.clickEvent = e
        this.$emit('clearAllActive')
        // 点击大板是这个数据为null
        this.activePlank = this.setActivePlank(e)
        const mousePoint = {
          x: e.offsetX,
          y: e.offsetY,
        }
        const bigPart = this.getCurrentBigPart(mousePoint)
        this.$emit(
          'recordActivePlank',
          this.activePlank,
          this.canvasKey,
          bigPart
        )
        // 获取点击范围是属于哪个大板
        if (!bigPart) return
        // 判断是否点击到锁上
        const result = this.jundgeLocation(mousePoint, bigPart.lockPath)
        if (result && (bigPart.isLocked || bigPart.isActive)) {
          buryPointApi('layout', 'bigpart_locked')
          bigPart.isLocked = this.lockHoverInfo.isLocked = !bigPart.isLocked
          if (!bigPart.isLocked) {
            this.$message.success(translate('lockModal.lockSeccess'))
            this.renderAll()
            this.lockHoverInfo.isShow = false
            bigPart.isActive = false
          } else {
            this.$message.success(translate('lockModal.lockSeccessTip'))
            this.renderAll()
          }
          this.$emit('handleClickLock')
        }
        const onPlank =
          mousePoint.x <= bigPart.startX + bigPart.width + 2 * this.deviation &&
          mousePoint.y <=
            bigPart.startY + bigPart.height + this.padding + 2 * this.deviation
        if (!onPlank) {
          const data = this.drawData.data
          data.forEach((item) => {
            item.isActive = false
          })
        }
        // 点击在小板上面
        if (this.activePlank) {
          // 这个打印不删，用于测试服排查错误
          console.log(JSON.parse(JSON.stringify(this.activePlank)))
          this.$emit('handleChangeRemarksAble', false)
          // 如果激活了板件则记录当前的位置, 以便移动时的使用
          this.isMovingPlank = true
          this.$emit('forbidUserSelect', true)
          // 记录当前板件的起始坐标
          this.plankStartPoint = {
            x: this.activePlank.startX,
            y: this.activePlank.startY,
          }
          // 记录选中板件的起始点和鼠标位置的差距
          this.sliceDrawData.forEach((item) => {
            this.syncStockKey(item)
          })
          const activeBigpart = this.sliceDrawData.find(
            (v) => v.stockKey == this.activePlank.stockKey
          )
          this.setActiveBigPart(activeBigpart)
          this.activePlankOff = {
            x: this.restoreScaleSize(e.offsetX) - this.activePlank.startX,
            y: this.restoreScaleSize(e.offsetY) - this.activePlank.startY,
          }
          // 计算当前点击的位置, 鼠标位置相对于小板的偏移值
          this.plankRealOff = {
            x:
              this.restoreScaleSize(
                e.offsetX - this.activeBigpart.startX - this.deviation
              ) - this.activePlank.startX,
            y:
              this.restoreScaleSize(
                e.offsetY -
                  this.activeBigpart.startY -
                  this.padding -
                  this.deviation
              ) - this.activePlank.startY,
          }
        } else {
          // 如果没有选中小板且未点击在锁上，执行拖动大板操作 判断并未点击到三个点上
          if (!result && !this.canvasBtn.data) {
            this.dragBigPlank(e)
          }
        }
      }
      // 右键
      if (e.button === 2) {
        // 阻止默认行为
        e.preventDefault()
        // 获取选中的大板和小板
        this.setActivePlank(e)
        const mousePoint = {
          x: e.offsetX,
          y: e.offsetY,
        }
        // 获取在鼠标点击位置左侧的大板
        const bigPart = this.getCurrentBigPart(mousePoint)
        // 判断鼠标点击位置是否在大板上
        const onPlank =
          mousePoint.x <=
            bigPart?.startX + bigPart?.width + 2 * this.deviation &&
          mousePoint.y <=
            bigPart?.startY +
              bigPart?.height +
              this.padding +
              2 * this.deviation
        // 暂时注释，看需不需要右键拖动画布
        // if (!bigPart || !onPlank) {
        //   this.dragBigPlank(e)
        //   return
        // }
        // 判断是否点击到三点上
        const isOnThreePoint = this.jundgeLocationOnThreePoint(
          bigPart,
          mousePoint
        )
        // 右键在三点上，就关闭新的菜单，防止与原有菜单冲突
        if (isOnThreePoint) return

        const { clientX, clientY } = e
        const position = {
          x: clientX + 20,
          y: clientY,
        }
        let clickType = ''
        // 选中了小板
        if (this.activePlank && this.activeBigpart) {
          this.$emit(
            'recordActivePlank',
            this.activePlank,
            this.canvasKey,
            this.activeBigpart
          )
          clickType = 'part'
        } else if (this.activeBigpart && !this.activePlank) {
          // 选中了大板 移除之前选中的板件
          this.$emit(
            'recordActivePlank',
            this.activePlank,
            this.canvasKey,
            this.activeBigpart
          )
          clickType = 'plank'
        } else {
          // 空白处点击,没有选中任何板件
          clickType = 'other'
          // 在空白处点击了右键， 需要取消选中当前选中的小板
          this.activePlank = null
          this.renderAll()
          this.$emit(
            'recordActivePlank',
            this.activePlank,
            this.canvasKey,
            bigPart
          )
        }
        this.$emit('rightClick', {
          position,
          clickType,
          canvasKey: this.canvasKey,
        })
      }
    },
    // 拖动大板操作
    dragBigPlank(e) {
      if (this.isMovingPlank) return
      this.emptyDistance = false
      this.canvasBtn.data = null
      this.isMovingCavnas = true
      this.canvasRightDrag = {
        x: e.offsetX,
        y: e.offsetY,
      }
    },
    // 重置板件状态
    resetPlankStatus() {
      this.isMovingPlank = false
      this.dragPosition = null
      this.activePlankOff = null
    },

    // 获取鼠标位置到canvas的偏移量
    getOffsetBetweenPointAndCanvas(e, downEvent, needMagic) {
      // const canvasDom = this.$refs[`canvas${this.canvasKey}`]
      if (downEvent) {
        // 此时说明用初始值e和当前e的差值进行计算（之所以引入这样的计算方法，是因为用e.x - dom.getBoundingClientRect().left这样的算法经常会有1px的误差）

        return {
          offsetX: e.x - downEvent.x + this.clickEvent.offsetX,
          offsetY: e.y - downEvent.y + this.clickEvent.offsetY,
        }
      }

      const canvasDom = document.querySelector(`#canvas${this.canvasKey}`)
      if (!canvasDom) {
        return {}
      }
      const domInfo = canvasDom.getBoundingClientRect()
      let magicNumber = 0
      if (needMagic) {
        magicNumber = 1
      }
      return {
        offsetX: e.x - domInfo.left + magicNumber,
        offsetY: e.y - domInfo.top + magicNumber,
      }
    },
    // 计算小板的startX和startY
    calcuPlankStartPos(bigpart, offsetX, offsetY, offsetObj) {
      let plankRealOff = offsetObj ||
        this.plankRealOff || {
          x: 0,
          y: 0,
        }
      return {
        startX:
          this.restoreScaleSize(offsetX - bigpart.startX - this.deviation) -
          plankRealOff.x,
        startY:
          this.restoreScaleSize(
            offsetY - bigpart.startY - this.padding - this.deviation
          ) - plankRealOff.y,
      }
    },
    // 把板件推到大板里面
    pushActivePlankToParts(bigpart, isCacheToCanvas) {
      // 这儿还是针对从缓存去区拖到canvas的情况
      let index = bigpart.parts.findIndex((item) => {
        return isSamePart(item, this.activePlank)
      })
      if (index !== -1) {
        // 此时说明找到了，直接返回
        return
      }
      this.$emit('clearAllStyle', this.activePlank)
      bigpart.parts.push(this.activePlank)
      calcBigpartArea(bigpart, this.ncSetting, this.$props.isUnuseSurplus)
      // 将对应标识也作相应的更改
      this.activePlank.stockKey = bigpart.stockKey
      this.activePlank.stockNum = bigpart.stockNum
      if (isCacheToCanvas) {
        if (!isExistPriority(this.activePlank)) {
          // 重新计算下刀点
          this.$props.calcCutPositionOrder()
        }
        this.handleStorePlankPlacedSuccess(this.activePlank)
      }
      // 判断大板是否可以进行正反切换
      this.judgeAbleFanban(bigpart)
      this.$props.calcFanbanCount()
      this.onPartChange('add', { partType: 'plank', data: this.activePlank })
      // 拖入板件后，检查是否影响复用关系
      this.emitClearReuseIfNeeded(bigpart)
    },
    handleStorePlankPlacedSuccess(plank) {
      if (plank?._isBujian && plank?._bujianStoreId) {
        // 补件成功落板后只写入全局 participation，不走待排版库的“删除/隐藏”逻辑。
        this.$store.commit(
          'bujianStore/addParticipationBujianPlank',
          plank._bujianStoreId
        )
        this.$store.commit('bujianStore/setCurrentDragBujianPlank', null)
        return
      }
      this.$store.commit(
        'awaitPaibanStore/deleteCurrentDragPlank',
        plank?.partUniqueId
      )
      this.$store.commit('awaitPaibanStore/setCurrentDragPlank', null)
    },
    getCurrentStoreDragPlank() {
      // drawPart 同时承接待排版库和补件库拖拽，这里按当前入口切换上下文，避免两类拖拽串状态。
      if (this.$props.currentStoreType === 'bujianStore') {
        return this.$store.state.bujianStore?.currentDragBujianPlank ?? null
      }
      return this.$store.state.awaitPaibanStore.currentDragPlank
    },

    // 判断板件是否可以吸附 不支持锯切和有额外扩板的小板
    checkPlankAdsorption(plank) {
      return (
        this.$props.isUsePlankAdsorption &&
        !plank.isUseSaw &&
        (!plank.finalExtendDisMap ||
          Object.values(plank.finalExtendDisMap).every((item) => item === 0))
      )
    },

    /**
     * 处理canvas里面plank信息
     * @param {*} options
     * @param {*} isCacheToCanvas 是否是从缓存区到canvas
     */
    dealCanvasPlankMsg(options, isCacheToCanvas) {
      let { offsetX, offsetY, startX, startY } = options
      const oriActivePlank = JSON.parse(JSON.stringify(this.activePlank))
      // 门套切割 暂时也不支持移板
      const useSameWidthPlank =
        this.ncSetting.sawSetting.mentaoji_enable &&
        ((this.ncSetting.sawSetting.sawToLayout &&
          (!this.ncSetting.sawSetting.sawCutOnlyWeld ||
            oriActivePlank.isWeldingPlank)) ||
          this.ncSetting.sawSetting.processType === 'doorFrame')
      if (
        this.ncSetting.glass_setting ||
        useSameWidthPlank ||
        isTextureAlignmentPlank(oriActivePlank)
      ) {
        if (useSameWidthPlank) {
          _debounceTime = setTimeout(() => {
            this.$message.error('开启了锯片排版,板件无法移动')
          }, 100)
        }
        if (isTextureAlignmentPlank(oriActivePlank)) {
          _debounceTime = setTimeout(() => {
            this.$message.error(this.$translateLang('对纹板件无法移动'))
          }, 100)
        }
        return
      }
      // 找到当前点击的位置属于哪一个大板, 找到起始坐标小于当前鼠标位置的所有大板, 取最后一个大板
      let arr = this.sliceDrawData.filter(
        (v) => offsetX >= v.startX && offsetY >= v.startY
      )
      // 判断鼠标位置是否在大板所处的位置
      // 如果点到了第一块大板之前的区域, 是没有大板信息的, 所以直接弹回原位置重新绘制
      if (arr.length == 0) {
        this.plankRealOff = null

        this.showImageTemp(false)
        this.isDrawImage = false
        this.reRenderPlank()

        this.renderAll()
        this.$emit('changePaibanData', false)

        return
      }
      // 找到原数据中的bigpart
      // 找到当前鼠标位置的最后一个大板
      let targetBigpart = arr[arr.length - 1]
      let bigpart = this.sliceDrawData.find(
        (v) => v.stockKey == targetBigpart.stockKey
      )
      const oriBigpart = JSON.parse(JSON.stringify(this.activeBigpart))
      // 如果找到了大板则继续执行后面的逻辑, 否则弹回原位置重新绘制
      if (bigpart) {
        // 如果鼠标位置在大板上, 则继续执行后面的逻辑, 否则弹回原位置重新绘制
        if (bigpart.isLocked) {
          this.$message.error(translate('arrangedPage.plankLockErr'))
          this.plankRealOff = null
          this.showImageTemp(false)
          this.isDrawImage = false
          this.reRenderPlank()
          this.renderAll()
          this.$emit('changePaibanData', false)
          return
        }
        const brandDragErrTipKey = getBrandDragErrorTipKey(
          this.activePlank,
          bigpart
        )
        if (brandDragErrTipKey) {
          this.$message.error(translate(brandDragErrTipKey))
          this.plankRealOff = null
          this.showImageTemp(false)
          this.isDrawImage = false
          this.reRenderPlank()
          this.renderAll()
          this.$emit('changePaibanData', false)
          return
        }
        if (
          offsetX <= bigpart.startX + bigpart.width + 2 * this.deviation &&
          offsetY <=
            bigpart.startY + bigpart.height + this.padding + 2 * this.deviation
        ) {
          if (!startX) {
            let offsetObj = null
            if (isCacheToCanvas) {
              offsetObj = {
                x: this.restoreScaleSize(this.offsetPointbetweenCacheImage.x),
                y: this.restoreScaleSize(this.offsetPointbetweenCacheImage.y),
              }
            }
            let obj = this.calcuPlankStartPos(
              bigpart,
              offsetX,
              offsetY,
              offsetObj
            )
            // 拖动板件(未触发板件吸附) startX/Y保留设置中的小数位数
            startX = Number(obj.startX.toFixed(this.ncSetting.decimal))
            startY = Number(obj.startY.toFixed(this.ncSetting.decimal))
          }

          this.activePlank.startX = startX
          this.activePlank.startY = startY
          // 拖动板件到其他大板后，需要修改对应板件的plankWidth和plankWidth
          this.activePlank.plankHeight = bigpart.plankHeight
          this.activePlank.plankWidth = bigpart.plankWidth
          // 如果当前板件是L形余料，还需要修改surplusInfo字段
          if (bigpart.surplusInfo) {
            this.activePlank.surplusInfo = bigpart.surplusInfo
          } else {
            delete this.activePlank.surplusInfo
          }
          this.hasMoved = false
          this.plankRealOff = null
          // 重新处理选中板件的轮廓路径
          dealPlankPoly(this.activePlank)
          buryPointApi('layout', 'move_plate')
          let flag = false
          let newBigpart = false
          // 判断鼠标点击左键抬起和点击位置是否一样 一样就不需要吸附
          const { x, y } = this.clickPointOffset
          const t = !!(x === offsetX && y === offsetY)
          let idx = 0
          if (isCacheToCanvas) {
            const stock = this.activePlank.stockKey
              .split(':')
              .slice(0, -1)
              .join(':')
            const stockKeys = bigpart.allColors
              .map((color) => `${color}:${bigpart.matCode}`)
              .concat(bigpart.stockKey)
            if (stockKeys.some((key) => key.includes(stock))) {
              if (this.checkPlankAdsorption(this.activePlank)) {
                const result = calcClosePlank(this.activePlank, bigpart)
                if (result && !t) {
                  this.p1 = result.p1
                  this.p2 = result.p2
                  const { x, y } = result
                  this.activePlank.startX = x
                  this.activePlank.startY = y
                  if (result.intersect) {
                    this.intersect = result.intersect
                  }
                  // 重新处理选中板件的轮廓路径
                  dealPlankPoly(this.activePlank)
                }
              }
              flag = checkOnePlank(this.activePlank, bigpart)

              if (flag) {
                this.setActiveBigPart(bigpart)
                this.pushActivePlankToParts(bigpart, isCacheToCanvas)
                this.updateBlueAreaSurplusPart(bigpart)
                this.renderAll()
                return
              } else {
                this.setActivePlankData(null)
                this.$message.info(translate('arrangedPage.areaWarning'))
                this.renderAll()
                return
              }
            } else {
              this.setActivePlankData(null)
              this.$message.info('不符合大板规格，无法放置板件')
              this.renderAll()
              return
            }
          } else {
            // 如果移动后的板件还是在当前选中的大板上, 则直接判断是否冲突
            if (bigpart.stockKey == this.activePlank.stockKey) {
              if (this.checkPlankAdsorption(this.activePlank)) {
                const result = calcClosePlank(this.activePlank, bigpart)
                if (result && !t) {
                  this.p1 = result.p1
                  this.p2 = result.p2
                  const { x, y } = result
                  this.activePlank.startX = x
                  this.activePlank.startY = y
                  if (result.intersect) {
                    this.intersect = result.intersect
                  }
                  // 重新处理选中板件的轮廓路径
                  dealPlankPoly(this.activePlank)
                }
              }

              flag = checkOnePlank(this.activePlank, bigpart)
              if (flag) {
                this.pushActivePlankToParts(bigpart, isCacheToCanvas)
              }
            } else {
              // 大板间移动（同材质）
              if (this.activeBigpart) {
                for (let i = 0; i < this.activeBigpart.parts.length; ++i) {
                  if (
                    isSamePart(this.activeBigpart.parts[i], this.activePlank)
                  ) {
                    this.activeBigpart.parts.splice(i, 1)
                    idx = i
                    this.judgeAbleFanban(this.activeBigpart)
                    this.emitClearReuseIfNeeded(this.activeBigpart)
                    break
                  }
                }
              } else {
                this.setActiveBigPart(bigpart)
              }
              this.pushActivePlankToParts(bigpart, isCacheToCanvas)
              // 如果小板曾跨材质，现在回到了匹配的材质大板，清除跨材质标记
              if (
                this.activePlank._oriMatCode !== undefined &&
                this.activePlank._oriMatCode === bigpart.matCode &&
                this.activePlank._oriTexture === bigpart.texture
              ) {
                delete this.activePlank._isCrossMaterial
                delete this.activePlank._oriMatCode
                delete this.activePlank._oriTexture
              }
              newBigpart = true
            }
            if (this.activeBigpart) {
              if (this.checkPlankAdsorption(this.activePlank)) {
                const result = calcClosePlank(this.activePlank, bigpart)
                if (result && !t) {
                  const { x, y } = result
                  this.activePlank.startX = x
                  this.activePlank.startY = y
                  if (result.intersect) {
                    this.intersect = result.intersect
                  }
                  // 重新处理选中板件的轮廓路径
                  dealPlankPoly(this.activePlank)
                }
              }

              flag = checkOnePlank(this.activePlank, bigpart)
              if (!flag) {
                for (let i = 0; i < bigpart.parts.length; ++i) {
                  if (isSamePart(bigpart.parts[i], this.activePlank)) {
                    bigpart.parts.splice(i, 1)
                    break
                  }
                }
                this.activeBigpart.parts.splice(idx, 0, this.activePlank)
                // 板件移动失败需要重置大板序号避免之前的处理导致板件内部记录的序号错误
                this.activePlank.stockNum = this.activeBigpart.stockNum
                this.activePlank.stockKey = this.activeBigpart.stockKey
                // 如果冲突，重新绘制当前板件
                this.reRenderPlank()
              }
              checkOneBigpart(this.activeBigpart)
              if (newBigpart) {
                checkOneBigpart(bigpart)
                // 重新计算之前的大板优化率
                calcBigpartArea(
                  this.activeBigpart,
                  this.ncSetting,
                  this.$props.isUnuseSurplus
                )
                // 重新判断之前的大板是否可以进行正反切换
                this.judgeAbleFanban(this.activeBigpart)
                this.setActiveBigPart(bigpart)
                // 重新计算新的大板的优化率
                calcBigpartArea(
                  bigpart,
                  this.ncSetting,
                  this.$props.isUnuseSurplus
                )
                // 判断新的大板是否可以进行正反切换
                this.judgeAbleFanban(bigpart)
              }
            }
          }
        } else {
          this.reRenderPlank()
          this.$emit('changePaibanData', false)
        }
      } else {
        this.reRenderPlank()
        this.$emit('changePaibanData', false)
      }
      // 需要遍历大数据进行更新蓝色余料的数据
      this.drawData.data.forEach((item) => {
        this.updateBlueAreaSurplusPart(item)
      })
      // 隐藏图片
      this.showImageTemp(false)
      // 绘制图片设置为false
      this.isDrawImage = false
      // 判断完冲突后, 重新绘制
      this.renderAll()
      // 如果判断移动了小板，记录当前小板，否则不需要记录
      const hasMoved =
        Math.abs(this.activePlank.startX - oriActivePlank.startX) > 0.00001 ||
        Math.abs(this.activePlank.startY - oriActivePlank.startY) > 0.00001 ||
        this.activePlank.canvasIndex !== oriActivePlank.canvasIndex
      if (hasMoved) {
        this.$emit('recordPlankMove', {
          key: '移动小板',
          dataArr: [
            {
              type: 'form',
              current: {
                partName: this.activePlank.partName,
                canvasIndex: bigpart.canvasIndex,
                startX: this.activePlank.startX,
                startY: this.activePlank.startY,
              }, // 当前表单数据
              ori: {
                partName: oriActivePlank.partName,
                canvasIndex: oriBigpart?.canvasIndex,
                startX: oriActivePlank.startX,
                startY: oriActivePlank.startY,
              }, // 原始表单数据
              compareMsg: [
                {
                  title:
                    bigpart.canvasIndex === oriBigpart?.canvasIndex
                      ? `${this.activePlank.partName}-大板序号：${bigpart.canvasIndex}`
                      : this.activePlank.partName,
                  keys: ['canvasIndex', 'startX', 'startY'],
                },
              ], // 要比较的内容
              formTextObj: {
                partName: '板件名称',
                canvasIndex: '大板序号',
                startX: '横坐标',
                startY: '纵坐标',
              }, // key对应的意思
              formValueObj: {}, // value对应的意思
            },
          ],
        })
        // 板件移动后，检查是否影响复用关系
        this.emitClearReuseIfNeeded(bigpart)
      }

      if (!this.$props.isBatchBujian) {
        this.setBatchTaggingList([])
      }
    },
    /**
     * 跨材质完整扩版管线
     * 使用 preLayoutData 或 renderUrl 缓存中的原始板件数据，
     * 以目标大板的材质为基准重新执行完整的扩版逻辑
     * @param {Object} plank 当前拖动的板件
     * @param {Object} bigpart 目标大板
     * @returns {boolean} 扩版后校验是否通过
     */
    runCrossMaterialExpandPipeline(plank, bigpart) {
      // 1. 从预排版/缓存获取原始板件数据
      const ctx = {
        getCachedRawPlank,
      }
      const originPart = getOriginalPartForCrossMaterialExpand(plank, ctx)
      if (!originPart) {
        this.$message.error('未找到板件原始数据，无法进行跨材质扩版')
        return false
      }
      // 2. 深拷贝原始板件用于扩版计算
      const expandPart = JSON.parse(JSON.stringify(originPart))
      // 3. 保留原始板件的 roll 相关属性（从当前 plank 继承）
      expandPart.is_high_gloss_plank = plank.is_high_gloss_plank
      expandPart.high_gloss_side = plank.high_gloss_side
      expandPart.isUseSaw = plank.isUseSaw
      // 保留分层切割设置（跨材质后不应丢失用户设置的分层切割状态）
      if (plank.curve_layered_cutting !== undefined) {
        expandPart._curve_layered_cutting = plank.curve_layered_cutting
      }
      if (plank.curve_layered_cutting_deep !== undefined) {
        expandPart._curve_layered_cutting_deep =
          plank.curve_layered_cutting_deep
      }
      // 4. 赋予目标大板的材质、颜色、厚度
      expandPart.matCode = getPlankMatCode({
        ...expandPart,
        matCode: bigpart.matCode,
        is_high_gloss_plank: !!expandPart.is_high_gloss_plank,
      })
      // 5. 赋予目标大板的尺寸和当前位置
      expandPart.startX = plank.startX
      expandPart.startY = plank.startY
      expandPart.plankHeight = bigpart.plankHeight
      expandPart.plankWidth = bigpart.plankWidth
      expandPart.renderUrl = plank.renderUrl || ''
      expandPart.texture = bigpart.texture
      // oriTexture 必须同步更新，否则 Object.assign(plank, expandRest) 在下方
      // 会将 originPart 的旧 oriTexture 覆盖回 plank，导致 LayoutTool.js
      // 在 line 1497 误判 texture !== oriTexture 为混排。
      expandPart.oriTexture = bigpart.texture
      expandPart.thick = bigpart.thick
      expandPart.stockKey = `${bigpart.texture}:${expandPart.matCode}:${bigpart.thick}`

      // 获取原本的stockKey
      const originalStockKey = `${originPart.texture}:${originPart.matCode}:${originPart.thick}`

      // 6. 构建自定义 ncSetting，注入目标材质对应的刀径
      const knifeDiameter = getPlateKnifeDiameter(
        expandPart.stockKey,
        this.ncSetting
      )
      const originalKnifeDiameter = getPlateKnifeDiameter(
        originalStockKey,
        this.ncSetting
      )

      const customNcSetting = {
        ...this.ncSetting,
        knife: { diameter: Number(knifeDiameter) },
      }
      // 7. 完整扩版管线：先 addPropForPart + 扩版，再用 plank 的追踪记录重放翻面/旋转
      addPropForPart(expandPart, expandPart, customNcSetting)
      const allParts = store.state.paibanData.map((item) => item.parts).flat(1)
      dealPlankExpandKnife(
        expandPart,
        customNcSetting,
        !Object.prototype.hasOwnProperty.call(expandPart, 'path') &&
          allParts.every((p) => p.isUseSaw)
      )
      checkPlankHoleSlot(expandPart)
      const stockKey = `${expandPart.texture}:${expandPart.matCode}:${expandPart.thick}`
      const cutD = expandPart.isUseSaw
        ? getSawKnife(customNcSetting)
        : getPlateKnifeDiameter(stockKey, customNcSetting)
      const expandMap = dealExpandSlot(
        expandPart,
        customNcSetting,
        Number(cutD) / 2
      )
      if (expandMap && Object.values(expandMap).some((item) => Boolean(item))) {
        expandPart.isExpanded = true
      }
      // 重放 plank 的翻面/旋转追踪记录到 expandPart，还原到与 plank 相同的最终状态
      replayTransform(expandPart, plank._transformLog)
      // 8. 将 expandPart 上的扩版结果全量覆盖到 plank
      //    startX/Y 已在 handleCrossMaterialDrop 中正确计算，plankHeight/Width
      //    应保持大板原始尺寸，都不能被扩版管线修改后的值覆盖
      const { startX, startY, plankHeight, plankWidth, ...expandRest } =
        expandPart
      // 过滤 null 值：preLayoutData 中的原始板件可能携带 lineSlots: null 等字段，
      // 若不过滤会覆盖 plank 上已有的有效数据（如已从服务器获取的 lineSlots 数组）
      Object.assign(plank, expandRest)
      dealPlankPoly(plank)
      return true
    },
    /**
     * 处理跨材质板件拖入排版页
     * @param {Object} bigpart 目标大板
     * @param {Object} plank 拖入的板件
     * @param {Number} offsetX 鼠标相对canvas的X偏移
     * @param {Number} offsetY 鼠标相对canvas的Y偏移
     */
    handleCrossMaterialDrop(bigpart, plank, offsetX, offsetY) {
      // 目标大板已锁定则不允许放置
      if (bigpart.isLocked) {
        this.$message.error(translate('arrangedPage.plankLockErr'))
        this.setActivePlankData(null)
        this.changeDragingPlank(false)
        this.renderAll()
        return
      }
      // 玻璃切割机生产线不允许移动板件
      if (this.ncSetting.glass_setting) {
        this.$message.error('生产线为玻璃切割机时，板件无法被移动!')
        this.setActivePlankData(null)
        this.changeDragingPlank(false)
        this.renderAll()
        return
      }
      // 对纹板件不允许移动
      if (isTextureAlignmentPlank(plank)) {
        this.$message.error(this.$translateLang('对纹板件无法移动'))
        this.setActivePlankData(null)
        this.changeDragingPlank(false)
        this.renderAll()
        return
      }
      // 锯片排版不允许移动板件
      const useSameWidthPlank =
        this.ncSetting.sawSetting.mentaoji_enable &&
        ((this.ncSetting.sawSetting.sawToLayout &&
          (!this.ncSetting.sawSetting.sawCutOnlyWeld ||
            plank.isWeldingPlank)) ||
          this.ncSetting.sawSetting.processType === 'doorFrame')
      if (useSameWidthPlank) {
        _debounceTime = setTimeout(() => {
          this.$message.error('开启了锯片排版,板件无法移动')
        }, 100)
        return
      }
      // 保存原始材质数据用于回退
      this.crossMaterialBackup = {
        stockKey: plank.stockKey,
        matCode: plank.matCode,
        texture: plank.texture,
        oriTexture: plank.oriTexture,
        thick: plank.thick,
        path: plank.path ? JSON.parse(JSON.stringify(plank.path)) : null,
        rect: plank.rect ? { ...plank.rect } : null,
        polyArr: plank.polyArr
          ? JSON.parse(JSON.stringify(plank.polyArr))
          : null,
        _plankBoundBox: plank._plankBoundBox
          ? JSON.parse(JSON.stringify(plank._plankBoundBox))
          : null,
        holes: plank.holes ? JSON.parse(JSON.stringify(plank.holes)) : null,
        slots: plank.slots ? JSON.parse(JSON.stringify(plank.slots)) : null,
        lineSlots: plank.lineSlots
          ? JSON.parse(JSON.stringify(plank.lineSlots))
          : null,
        curveHoles: plank.curveHoles
          ? JSON.parse(JSON.stringify(plank.curveHoles))
          : null,
        isExpanded: Reflect.has(plank, 'isExpanded') ? plank.isExpanded : null,
        _flipXCount: plank._flipXCount ?? 0,
        _flipYCount: plank._flipYCount ?? 0,
        _rotateAngle: plank._rotateAngle ?? 0,
        _transformLog: plank._transformLog
          ? JSON.parse(JSON.stringify(plank._transformLog))
          : [],
      }
      // 将目标大板的材质和颜色等数据赋值给板件（中转数据）
      plank.stockKey = bigpart.stockKey
      plank.matCode = bigpart.matCode
      plank.texture = bigpart.texture
      // 同步更新 oriTexture：跨材质拖拽不属于混排，oriTexture 应与 texture 保持一致，
      // 否则重新排版时 LayoutTool.js 会因 texture !== oriTexture 误判为混排
      plank.oriTexture = bigpart.texture
      plank.thick = bigpart.thick
      plank._isCrossMaterial = true
      // 计算板件放置位置
      const offsetObj = {
        x: this.restoreScaleSize(this.offsetPointbetweenCacheImage.x),
        y: this.restoreScaleSize(this.offsetPointbetweenCacheImage.y),
      }
      const obj = this.calcuPlankStartPos(bigpart, offsetX, offsetY, offsetObj)
      plank.startX = Number(obj.startX.toFixed(this.ncSetting.decimal))
      plank.startY = Number(obj.startY.toFixed(this.ncSetting.decimal))
      plank.plankHeight = bigpart.plankHeight
      plank.plankWidth = bigpart.plankWidth
      // L形余料处理
      if (bigpart.surplusInfo) {
        plank.surplusInfo = bigpart.surplusInfo
      } else {
        delete plank.surplusInfo
      }
      this.hasMoved = false
      this.plankRealOff = null
      // 使用完整扩版管线（以原始板件数据 + 目标材质重新扩版）
      const expandOk = this.runCrossMaterialExpandPipeline(plank, bigpart)
      if (!expandOk) {
        this.restoreCrossMaterialPlank()
        this.setActivePlankData(null)
        this.changeDragingPlank(false)
        this.renderAll()
        return
      }
      buryPointApi('layout', 'move_plate')
      // 板件吸附
      if (this.checkPlankAdsorption(plank)) {
        const result = calcClosePlank(plank, bigpart)
        if (result) {
          const { x, y } = result
          plank.startX = x
          plank.startY = y
          if (result.intersect) {
            this.intersect = result.intersect
          }
          dealPlankPoly(plank)
        }
      }
      // 校验板子是否能放到指定位置
      const flag = checkOnePlank(plank, bigpart)
      if (!flag) {
        // 不满足条件则退回
        this.restoreCrossMaterialPlank()
        this.$message.info(translate('arrangedPage.areaWarning'))
        this.setActivePlankData(null)
        this.changeDragingPlank(false)
        this.renderAll()
        return
      }
      // 可以放置则弹窗提示
      this.setActiveBigPart(bigpart)
      plank.stockKey = bigpart.stockKey
      plank.stockNum = bigpart.stockNum
      bigpart.parts.push(plank)
      calcBigpartArea(bigpart, this.ncSetting, this.$props.isUnuseSurplus)
      this.updateBlueAreaSurplusPart(bigpart)
      if (this.skipCrossMaterialConfirm) {
        this.crossMaterialConfirm.bigpart = bigpart
        this.crossMaterialConfirm.oriBigpart = null
        this.confirmCrossMaterial()
        return
      }
      this.crossMaterialConfirm.bigpart = bigpart
      this.crossMaterialConfirm.visible = true
      this.renderAll()
    },
    // 恢复跨材质板件的原始数据
    restoreCrossMaterialPlank() {
      if (!this.crossMaterialBackup || !this.activePlank) return
      const backup = this.crossMaterialBackup
      const p = this.activePlank
      p.stockKey = backup.stockKey
      p.matCode = backup.matCode
      p.texture = backup.texture
      p.oriTexture = backup.oriTexture
      p.thick = backup.thick
      delete p._isCrossMaterial
      // 恢复几何数据（备份为 null 说明原始 plank 上该属性不存在，需 delete 避免残留 null）
      if (backup.path !== undefined) {
        backup.path !== null ? (p.path = backup.path) : delete p.path
      }
      if (backup.rect !== undefined) {
        backup.rect !== null ? (p.rect = backup.rect) : delete p.rect
      }
      if (backup.polyArr !== undefined) {
        backup.polyArr !== null
          ? (p.polyArr = backup.polyArr)
          : delete p.polyArr
      }
      if (backup._plankBoundBox !== undefined) {
        backup._plankBoundBox !== null
          ? (p._plankBoundBox = backup._plankBoundBox)
          : delete p._plankBoundBox
      }
      if (backup.holes !== undefined) {
        backup.holes !== null ? (p.holes = backup.holes) : delete p.holes
      }
      if (backup.slots !== undefined) {
        backup.slots !== null ? (p.slots = backup.slots) : delete p.slots
      }
      if (backup.lineSlots !== undefined) {
        backup.lineSlots !== null
          ? (p.lineSlots = backup.lineSlots)
          : delete p.lineSlots
      }
      if (backup.curveHoles !== undefined) {
        backup.curveHoles !== null
          ? (p.curveHoles = backup.curveHoles)
          : delete p.curveHoles
      }
      if (backup.isExpanded !== undefined) {
        backup.isExpanded !== null
          ? (p.isExpanded = backup.isExpanded)
          : delete p.isExpanded
      }
      // 恢复变换追踪
      if (backup._flipXCount !== undefined) p._flipXCount = backup._flipXCount
      if (backup._flipYCount !== undefined) p._flipYCount = backup._flipYCount
      if (backup._rotateAngle !== undefined)
        p._rotateAngle = backup._rotateAngle
      if (backup._transformLog !== undefined)
        p._transformLog = backup._transformLog
      this.crossMaterialBackup = null
    },
    // 确认跨材质放置
    confirmCrossMaterial() {
      const bigpart = this.crossMaterialConfirm.bigpart
      const oriBigpart = this.crossMaterialConfirm.oriBigpart
      if (bigpart && this.activePlank) {
        // 在小板上记录原始材质颜色，后续拖回原材质大板时不再算跨材质
        if (this.crossMaterialBackup) {
          if (!this.activePlank._oriMatCode) {
            this.activePlank._oriMatCode = this.crossMaterialBackup.matCode
            this.activePlank._oriTexture = this.crossMaterialBackup.oriTexture
          }
        }
        // 回到原始材质颜色时，清除跨材质标记
        if (
          this.activePlank._oriMatCode !== undefined &&
          bigpart.matCode === this.activePlank._oriMatCode &&
          bigpart.texture === this.activePlank._oriTexture
        ) {
          delete this.activePlank._isCrossMaterial
          delete this.activePlank._oriMatCode
          delete this.activePlank._oriTexture
        }
        // 大板间移动时，更新原大板
        if (oriBigpart) {
          checkOneBigpart(oriBigpart)
          calcBigpartArea(
            oriBigpart,
            this.ncSetting,
            this.$props.isUnuseSurplus
          )
          this.judgeAbleFanban(oriBigpart)
        } else {
          // 从待排版库/补件库中移除
          if (!isExistPriority(this.activePlank)) {
            this.$props.calcCutPositionOrder()
          }
          this.handleStorePlankPlacedSuccess(this.activePlank)
        }
        this.judgeAbleFanban(bigpart)
        this.$props.calcFanbanCount()
        this.onPartChange('add', { partType: 'plank', data: this.activePlank })
        if (this.$props.isBatchBujian) {
          this.setBatchTaggingList([])
        }
      }
      this.crossMaterialConfirm.visible = false
      this.crossMaterialConfirm.bigpart = null
      this.crossMaterialConfirm.oriBigpart = null
      if (this.crossMaterialConfirm.dontShowAgain) {
        this.setSkipCrossMaterialConfirm(true)
      }
      this.crossMaterialConfirm.dontShowAgain = false
      this.crossMaterialBackup = null
      this.changeDragingPlank(false)
      this.renderAll()
    },
    // 取消跨材质放置
    cancelCrossMaterial() {
      const bigpart = this.crossMaterialConfirm.bigpart
      const oriBigpart = this.crossMaterialConfirm.oriBigpart
      if (bigpart && this.activePlank) {
        // 从目标大板中移除板件
        for (let i = 0; i < bigpart.parts.length; ++i) {
          if (isSamePart(bigpart.parts[i], this.activePlank)) {
            bigpart.parts.splice(i, 1)
            break
          }
        }
        // 恢复板件原始材质数据
        this.restoreCrossMaterialPlank()
        // 重新计算大板优化率
        calcBigpartArea(bigpart, this.ncSetting, this.$props.isUnuseSurplus)
        // 如果是大板间移动，弹回原位（放回原大板）
        if (oriBigpart) {
          this.activePlank.stockKey = oriBigpart.stockKey
          this.activePlank.stockNum = oriBigpart.stockNum
          oriBigpart.parts.push(this.activePlank)
          calcBigpartArea(
            oriBigpart,
            this.ncSetting,
            this.$props.isUnuseSurplus
          )
          this.judgeAbleFanban(oriBigpart)
          this.setActiveBigPart(oriBigpart)
        }
      }
      this.crossMaterialConfirm.visible = false
      this.crossMaterialConfirm.bigpart = null
      this.crossMaterialConfirm.oriBigpart = null
      this.crossMaterialConfirm.dontShowAgain = false
      this.setActivePlankData(null)
      // 目前不支持 大板之间跨材质移动，所以如果oriBigpart为null
      if (!oriBigpart) {
        this.setActiveBigPart(null)
      }
      this.changeDragingPlank(false)
      this.renderAll()
    },
    clickUpCanvasFn(e) {
      // if (e.button == 0) {
      //   if (!this.isUseImage) {
      //     this.clickUpCanvas(e)
      //   }
      // }
      if (e.button == 2 || e.button == 0) {
        this.clickUpCanvas(e)
      }
    },
    // 鼠标松开事件
    clickUpCanvas(e) {
      // 修改蓝色区域的rect的height。
      // 依然找到最大和最小的startY进行计算，去修改rect的height
      if (e.button == 0) {
        // if(this.isMovingCavnas) return
        if (this.isMovingCavnas) {
          if (this.isMovingPlank) return
          this.isMovingCavnas = false
          this.canvasOffset = null
          return
        }
        // 这个值是准确的
        let { offsetX, offsetY } = this.getOffsetBetweenPointAndCanvas(
          e,
          this.clickEvent
        )
        if (!this.isUseImage) {
          offsetX = e.offsetX
          offsetY = e.offsetY
        }
        this.resetPlankStatus()
        if (this.activePlank && this.activeBigpart) {
          const useSameWidthPlank =
            this.ncSetting.sawSetting.mentaoji_enable &&
            ((this.ncSetting.sawSetting.sawToLayout &&
              (!this.ncSetting.sawSetting.sawCutOnlyWeld ||
                this.activePlank.isWeldingPlank)) ||
              this.ncSetting.sawSetting.processType === 'doorFrame')
          if (
            this.activeBigpart.isLocked ||
            this.ncSetting.glass_setting ||
            this.activePlank.isExpanded ||
            useSameWidthPlank ||
            isTextureAlignmentPlank(this.activePlank)
          )
            return
          // 处理canvas里面的板件信息
          this.dealCanvasPlankMsg({
            offsetX,
            offsetY,
          })
          const data = this.drawData.data
          // 当前激活大板为true其他大板为false
          data.forEach((item) => {
            item.isActive = item.stockKey === this.activeBigpart.stockKey
          })
          // 点了小板显示锁 todo
          // if (this.activeBigpart.isLocked) {
          //   this.loadLockedImg(
          //     this.ctx,
          //     this.activeBigpart.lockStartX,
          //     this.activeBigpart.lockStartY,
          //     this.activeBigpart.isLocked,
          //     this.activeBigpart.lockWidthHeight
          //   )
          // }
        }
      }
      // 右键
      if (e.button == 2) {
        if (this.isMovingPlank) return
        this.isMovingCavnas = false
        this.canvasOffset = null
      }
    },
    // 重新绘制当前板件
    reRenderPlank() {
      if (!this.activePlank) return
      this.activePlank.startX = this.plankStartPoint.x
      this.activePlank.startY = this.plankStartPoint.y
      dealPlankPoly(this.activePlank)
    },
    // 鼠标移动事件
    async movePlank(e) {
      // todo 需要被删除
      const point = {
        x: e.offsetX,
        y: e.offsetY,
      }

      if (!this.activePlank) {
        if (_debounceTime) {
          clearTimeout(_debounceTime)
        }
        _debounceTime = setTimeout(() => {
          const activePart = this.plankControl.getActivePart(e)
          const conflict = partIsConflict(activePart)
          this.$emit(
            'onConflictPart',
            conflict && !this.activePlank ? activePart : null
          )
        }, 200)
      }

      if (this.activePlank && !this.isMovingPlank) {
        if (_debounceTime) {
          clearTimeout(_debounceTime)
        }
        const activePlankTemp = transformData(this.activePlank, store)
        _debounceTime = setTimeout(() => {
          // 绘制孔槽等的详细信息
          // 我知道你会疑惑上面不是判断了this.activePlank有值才会进入，为啥这里又要判断，这一步是因为这里是宏任务，这里的this.activePlank可能存在null的情况
          if (this.activeBigpart && this.activePlank) {
            this.hsDetailInfoList = drawActivePlankOtherInfo(
              this.activeBigpart,
              point,
              activePlankTemp,
              {
                deviation: this.deviation,
                padding: this.padding,
                scalePercent: this.scalePercent,
                defaultScale: defaultScale,
              },
              'paiban'
            )
          }
          if (this.isRenderHSDetail) {
            this.renderAll()
            this.isRenderHSDetail = false
          }
          if (this.hsDetailInfoList.length) {
            this.mousePoint = point
            this.renderAll()
            this.isRenderHSDetail = true
          }
        }, 50)
      } else {
        this.hsDetailInfoList = []
      }
      if (this.isUseImage) {
        this.isMovingPlank = false
      }
      if (this.isMovingPlank) {
        this.$emit('changePaibanData', true)
        if (_debounceTime) {
          clearTimeout(_debounceTime)
        }
        if (this.ncSetting.glass_setting) {
          _debounceTime = setTimeout(() => {
            this.$message.error('生产线为玻璃切割机时，板件无法被移动!')
          }, 100)
          return
        }
        if (isTextureAlignmentPlank(this.activePlank)) {
          _debounceTime = setTimeout(() => {
            this.$message.error(this.$translateLang('对纹板件无法移动'))
          }, 100)
          return
        }
        if (this.activePlank.isExpanded) {
          _debounceTime = setTimeout(() => {
            this.$message.error('板件存在拉槽特殊工艺，不支持编辑操作！')
          }, 100)
          return
        }
        // 相同宽度，是焊接板或者门套切割 => 不让拖 非焊接板 => 能拖
        const sameWidthPlank =
          this.ncSetting.sawSetting.mentaoji_enable &&
          ((this.ncSetting.sawSetting.sawToLayout &&
            (!this.ncSetting.sawSetting.sawCutOnlyWeld ||
              this.activePlank.isWeldingPlank)) ||
            this.ncSetting.sawSetting.processType === 'doorFrame')
        if (sameWidthPlank) {
          _debounceTime = setTimeout(() => {
            this.$message.error('开启了锯片排版,板件无法移动')
          }, 100)
          return
        }
        if (this.activePlank) {
          this.dragPosition = point
          this.renderAll()
        }
      } else {
        const pointInRect = this.needMarkRectArr.find((rect) =>
          checkPointInRect(point, rect)
        )
        if (pointInRect) {
          this.markRect = pointInRect
          this.markRectTip = {
            x: pointInRect.x,
            y:
              pointInRect.y -
              (pointInRect.height * 2 * this.scalePercent) / defaultScale,
          }
          this.mousePoint = {
            x: pointInRect.x,
            y:
              pointInRect.y -
              (pointInRect.height * 2 * this.scalePercent) / defaultScale,
          }
          this.renderAll()
        } else {
          this.markRect = null
          this.markRectTip = null
          if (!this.isDrawImage) {
            this.renderAll()
          }
        }
      }
      if (this.isMovingCavnas) {
        this.canvasOffset = {
          x: e.offsetX - this.canvasRightDrag.x,
          y: e.offsetY - this.canvasRightDrag.y,
        }

        this.renderAll()
        for (let i = 0; i < this.sliceDrawData.length; ++i) {
          let data = this.sliceDrawData[i]
          data.startX += this.canvasOffset.x
          data.startY += this.canvasOffset.y
        }
        this.canvasRightDrag = {
          x: e.offsetX,
          y: e.offsetY,
        }
      }
      const bigPart = this.getCurrentBigPart(point)
      if (!bigPart) return
      // 检查鼠标是否移动到蓝色区域（带blueAreaSurplus字段的小板）
      const blueAreaPart = this.checkMouseOnBlueArea(point)
      this.mouseOnBlueArea = blueAreaPart
      const result = this.jundgeLocation(point, bigPart.lockPath)
      if (bigPart.isLocked || bigPart.isActive) {
        this.changeLockHover(e, bigPart, result)
      }
      _debounceTime = setTimeout(() => {
        if (
          bigPart.surplusInfo &&
          !bigPart.surplusInfo.isNotSurplus &&
          bigPart.surplusInfo?.branch_name
        ) {
          let { startX, startY } = bigPart
          let width = bigPart.width + 2 * this.deviation
          let surStore = bigPart.surplusInfo?.branch_name
          if (
            point.x > startX &&
            point.x <= startX + width &&
            point.y <= startY + this.padding / 2 &&
            this.calcTextSize(surStore) >= width
          ) {
            this.surStoreTooltip = [{ msg: surStore, color: '#fff' }]
            if (this.isRenderSSTooltip) {
              this.renderAll()
              this.isRenderSSTooltip = false
            }
            if (this.surStoreTooltip.length) {
              this.mousePoint = point
              this.renderAll()
              this.isRenderSSTooltip = true
            }
          } else {
            this.surStoreTooltip = []
            this.renderAll()
          }
        }
      }, 50)
    },
    // 鼠标是否在暂存区内
    pointIsInDropArea(e) {
      let areaContentDom = document.querySelector('.temp-area-content')
      const areaContentMsg = areaContentDom.getBoundingClientRect()
      const xmin = areaContentMsg.left
      const xmax = areaContentMsg.left + areaContentMsg.width
      const ymin = areaContentMsg.top
      const ymax = areaContentMsg.top + areaContentMsg.height
      let { x, y } = e
      if (xmin <= x && x <= xmax && ymin <= y && y <= ymax) {
        return true
      }
      return false
    },
    // 页面滚动时重新绘制
    scrollCanvas(canvasInfo) {
      if (!this.imageTempMousedownFlag) {
        // 滚动的时候，隐藏图片，绘制板件
        this.showImageTemp(false)
        this.isDrawImage = false
      }
      this.canvasBtn.data = null
      let scrollOff = {
        x: 0,
        y: 0,
      }
      if (canvasInfo.top < 114) {
        let a = 114 - canvasInfo.y
        scrollOff.y = a
      }
      if (canvasInfo.left < 16) {
        let b = 16 - canvasInfo.left
        scrollOff.x = b
      }
      this.scrollDraw(scrollOff)
      this.startLeft = scrollOff.x
      this.startTop = scrollOff.y
    },
    // 滚轮缩放
    wheelScale(e) {
      if (e.ctrlKey) {
        this.emptyDistance = false
        this.scaleCanvas(e)
      }
    },

    draw() {
      const standardPlank = this.sliceDrawData.find(
        (item) => !item.otherPlate && !item.surplusInfo
      )
      if (
        this.selectStandardPlank &&
        Object.keys(this.selectStandardPlank).length
      ) {
        this.plankWidth = !this.ncSetting.xyReverse
          ? this.selectStandardPlank.plankWidth
          : this.selectStandardPlank.plankHeight
        this.plankHeight = !this.ncSetting.xyReverse
          ? this.selectStandardPlank.plankHeight
          : this.selectStandardPlank.plankWidth
      } else if (standardPlank) {
        this.plankWidth = standardPlank.plankWidth
        this.plankHeight = standardPlank.plankHeight
      } else {
        this.plankWidth =
          this.ncSetting.drawPlankWidth ?? this.ncSetting.panelSize.plankWidth
        this.plankHeight =
          this.ncSetting.drawPlankHeight ?? this.ncSetting.panelSize.plankHeight
      }
      this.scaleWidth = this.plankWidth / defaultScale
      this.scaleHeight = this.plankHeight / defaultScale
      this.canvasDom.height = initBigPlanksPositionToCanvas(
        this.sliceDrawData,
        this.scalePercent,
        this.canvasDom.width
      )
      // 开始绘制
      this.startDrawCanvas()
    },

    startDrawCanvas() {
      for (let i = 0; i < this.sliceDrawData.length; ++i) {
        let data = this.sliceDrawData[i]
        data.canvasIndex =
          this.startNum + (this.currentPape - 1) * this.countPerPage + i + 1
        // 绘制一个大板
        this.drawOneBigpart(data)
      }
    },
    // 绘制一个大板的所有东西
    async drawOneBigpart(bigpart, activePlank) {
      if (this.isOnlyShowSurplus && !bigpart.surplusInfo) return
      if (!Object.keys(bigpart).length) return
      const draw = new BigPlankDrawer(
        bigpart,
        this.ncSetting,
        defaultScale,
        this.scalePercent
      )
      // 如果是活跃大板
      if (
        this.activeBigpart &&
        this.activeBigpart.stockKey == bigpart.stockKey
      ) {
        draw.setActive(true)
      }
      draw.drawMargin(this.ctx)
      draw.drawToggle(this.ctx)
      // 绘制四边修边
      draw.drawFourEdge(this.ctx)
      const trimSide = this.isHistoryStatus
        ? window.sessionStorage.getItem('trimSide')
        : this.ncSetting.trimSide
      draw.drawContainer(this.ctx, { trimSide })
      draw.drawOverSizeArea(this.ctx, { trimSide })
      draw.drawMoreSetting(this.ctx)
      // 绘制复用标记
      if (bigpart._reuseParentId) {
        const parentBoard = this.drawData.data.find(
          (item) => item.bigPlankUniqueId === bigpart._reuseParentId
        )
        if (parentBoard) {
          draw.drawReuseLabel(this.ctx, parentBoard.canvasIndex)
        }
      }
      const lockPath = draw.drawLock(this.ctx).path
      bigpart.lockPath = toUpperCasePoint(lockPath)
      draw.drawTopInfo(this.ctx)
      const { x: newLeft, y: newTop } = draw.getContainerStart()
      // 大板绘制完成后，需要标记的地方
      this.needMarkRectArr = this.needMarkRectArr.concat(draw.needMarkRectArr)
      // 绘制小板
      // 记录是否有激活板件, 激活的板件最后绘制
      let finalPart = null
      // 绘制夹手（未走夹手检测时补全 clampHandInfo，避免多方案切换后丢失）
      this.drawClampHand(this.ctx, bigpart, newLeft, newTop)
      for (let i = 0; i < bigpart.parts.length; ++i) {
        let part = bigpart.parts[i]
        if (this.activePlank && isSamePart(part, this.activePlank)) {
          finalPart = part
          continue
        }
        this.drawParts(this.ctx, part, newLeft, newTop, bigpart, activePlank)
      }

      if (finalPart) {
        try {
          if (this.isUseImage) {
            if (this.isDrawImage) {
              if (_debounceTime) {
                clearTimeout(_debounceTime)
              }
              // 大板锁定状态 || 玻璃切割机生产线 取消生成图片 并且重新绘制所有小板数据
              const isLocked = bigpart.isLocked,
                isGlass = this.ncSetting.glass_setting,
                isExpanded = this.activePlank.isExpanded,
                isWeldingPlank = this.activePlank.isWeldingPlank,
                isTexture = isTextureAlignmentPlank(this.activePlank),
                useSameWidthPlank =
                  this.ncSetting.sawSetting.mentaoji_enable &&
                  ((this.ncSetting.sawSetting.sawToLayout &&
                    (!this.ncSetting.sawSetting.sawCutOnlyWeld ||
                      isWeldingPlank)) ||
                    this.ncSetting.sawSetting.processType === 'doorFrame')
              if (
                isLocked ||
                isGlass ||
                isExpanded ||
                useSameWidthPlank ||
                isTexture
              ) {
                _debounceTime = setTimeout(() => {
                  const msgList = [
                    this.$translateLang('板件被锁定，无法编辑'),
                    this.$translateLang('生产线为玻璃切割机时，板件无法被移动'),
                    this.$translateLang(
                      '板件存在拉槽特殊工艺，不支持编辑操作！'
                    ),
                    this.$translateLang('开启了锯片排版,板件无法移动'),
                    this.$translateLang('对纹板件无法移动'),
                  ]
                  const errorMsg = isLocked
                    ? msgList[0]
                    : isGlass
                    ? msgList[1]
                    : isExpanded
                    ? msgList[2]
                    : useSameWidthPlank
                    ? msgList[3]
                    : msgList[4]

                  this.$message.error(errorMsg)
                }, 100)
                this.drawParts(
                  this.ctx,
                  finalPart,
                  newLeft,
                  newTop,
                  bigpart,
                  activePlank
                )
                return
              }
              // 绘制当前小板的图片
              this.drawOnePartImageForMove(
                this.ctx,
                this.activePlank,
                newLeft,
                newTop,
                bigpart
              )
            } else {
              // 如果绘制了小板的图片，那么当前板件就不需要绘制了
              this.drawParts(
                this.ctx,
                finalPart,
                newLeft,
                newTop,
                bigpart,
                activePlank
              )
            }
          } else {
            this.drawParts(
              this.ctx,
              finalPart,
              newLeft,
              newTop,
              bigpart,
              activePlank
            )
          }
        } finally {
          if (
            finalPart &&
            this.activePlank &&
            bigpart.stockKey === this.activePlank.stockKey
          ) {
            this.edgeOverlayCanvasOrigin = {
              newLeft,
              newTop,
              stockKey: bigpart.stockKey,
            }
          }
        }
      }
    },
    // 获取到鼠标距离图片左上角的距离
    setMousePointOffsetImage(x, y) {
      this.mousePointOffsetImage = {
        x,
        y,
      }
    },
    // 生成点击板件对应的dom
    genClickPlankImageDom() {
      let wrap = document.querySelector(
        `.select-plank-image-wrap-${this.canvasKey}`
      )
      if (wrap) {
        return
      }
      wrap = document.createElement('div')
      wrap.className = `select-plank-image-wrap select-plank-image-wrap-${this.canvasKey}`
      wrap.style.position = 'fixed'
      wrap.style.zIndex = 1000
      let mask = document.createElement('div')
      mask.style.position = 'absolute'
      mask.style.width = '100%'
      mask.style.height = '100%'
      mask.style.left = 0
      mask.style.top = 0
      mask.style.zIndex = 2
      // mask.style.background = 'red'

      wrap.appendChild(mask)
      document.body.appendChild(wrap)
    },
    // 图片模板是否在canvas里面
    imageTempIsInCanvas(imageDom) {
      const canvasDom = document.querySelector(`#canvas${this.canvasKey}`)
      const canvasInfo = canvasDom.getBoundingClientRect()
      let imageDomInfo = {
        x: parseFloat(imageDom.style.left),
        y: parseFloat(imageDom.style.top),
        width: parseFloat(imageDom.offsetWidth),
        height: parseFloat(imageDom.offsetHeight),
      }

      if (
        imageDomInfo.x >= canvasInfo.x &&
        imageDomInfo.y >= canvasInfo.y &&
        imageDomInfo.x + imageDomInfo.width <=
          canvasInfo.x + canvasInfo.width &&
        imageDomInfo.y + imageDomInfo.height <= canvasInfo.y + canvasInfo.height
      ) {
        return true
      }
      return false
    },
    /** 添加板件到暂存库 */
    async handleAddPlankToAwaitStore(activePlank, activeBigPlank) {
      // 清除大板上的指定小板
      const flag = clearPlankToBigPlank(activePlank, activeBigPlank)
      if (!flag) return
      if (activePlank?._isBujian && activePlank?._bujianStoreId) {
        buryPointApi('layout', 'plate_staged')
        this.$emit('recordActivePlank', null)
        calcBigpartArea(
          activeBigPlank,
          this.ncSetting,
          this.$props.isUnuseSurplus
        )
        this.judgeAbleFanban(activeBigPlank)
        this.updateBlueAreaSurplusPart(activeBigPlank)
        this.activePlank = null
        this.setActiveBigPart(null)
        this.$props.calcFanbanCount()
        this.onPartChange('delete', { partType: 'plank', data: activePlank })
        this.renderAll()
        if (!this.$props.isBatchBujian) {
          this.setBatchTaggingList([])
        }
        return
      }
      // 重新生成板件的图片 默认放大3倍
      const imgUrl = getPlankImage(activePlank, false, {
        defaultScale,
        scale: 3,
        plankLineWidth: 1,
      })
      //生成本地暂存库数据并将数据添加到本地暂存库中
      const data = await genAwaitStoreData(
        activePlank,
        this.preLayoutData,
        imgUrl
      )
      this.$store.commit('awaitPaibanStore/setPlankToStore', data)
      // 进行板件处理后的固定操作
      buryPointApi('layout', 'plate_staged')
      this.$emit('recordActivePlank', null)
      // 计算优化率
      calcBigpartArea(
        activeBigPlank,
        this.ncSetting,
        this.$props.isUnuseSurplus
      )
      // 判断是否需要正反面切换
      this.judgeAbleFanban(activeBigPlank)
      // 更新蓝色余料的数据
      this.updateBlueAreaSurplusPart(activeBigPlank)
      this.activePlank = null
      this.setActiveBigPart(null)
      // 重新统计翻板数
      this.$props.calcFanbanCount()
      this.onPartChange('delete', { partType: 'plank', data: activePlank })
      this.renderAll()
      if (!this.$props.isBatchBujian) {
        this.setBatchTaggingList([])
      }
    },
    // 点击生成的图片鼠标松开
    async imageTempMouseUp(e) {
      // 清除暂存区上一次的激活状态样式
      this.$emit('autoScrollRightOperationZone', {
        draggableTarget: null,
        isInCompositionZone: false,
      })
      // 如果是拖到暂存区(存入暂存区)
      if (mousePointISInElement(e, 'paiban-await-store', 'id')) {
        if (this.activePlank && isTextureAlignmentPlank(this.activePlank)) {
          this.showImageTemp(false)
          this.isDrawImage = false
          this.reRenderPlank()
          this.renderAll()
          this.hasMoved = false
          return this.$message.error(this.$translateLang('对纹板件无法移动'))
        }
        this.showImageTemp(false)
        if (this.activePlank?._isBujian) {
          this.$message({
            message: this.$translateLang('补件无法直接放入待排版库'),
            type: 'warning',
          })
          this.isDrawImage = false
          this.reRenderPlank()
          this.renderAll()
          return
        }
        this.handleAddPlankToAwaitStore(this.activePlank, this.activeBigpart)
        // 拖到待排版库后，检查是否影响复用关系
        this.emitClearReuseIfNeeded(this.activeBigpart)
        return
      }
      let imageWrap = document.querySelector(
        `.select-plank-image-wrap-${this.canvasKey}`
      )
      // 如果不在当前canvas，就直接回到原来的位置
      if (!this.imageTempIsInCanvas(imageWrap)) {
        const outOfCanvasErrorMsg =
          this.$props.currentStoreType === 'bujianStore'
            ? this.$translateLang('无法放置，请点击补件按钮将板件放入补件库')
            : this.$translateLang('无法放置, 请核对板件材质、颜色和厚度属性!')
        this.$message({
          message: outOfCanvasErrorMsg,
          type: 'error',
        })
        // 隐藏图片
        this.showImageTemp(false)
        this.isDrawImage = false
        this.reRenderPlank()
        this.renderAll()
        return
      }
      this.setMousePointOffsetImage(0, 0)
      this.resetPlankStatus()
      this.clickUpCanvas(e)
    },
    // 绘制一块小板件的图片用于拖动
    async drawOnePartImageForMove(
      oldCtx,
      part,
      bigPankStartX,
      bigPankStartY,
      bigpart
    ) {
      // 如果某个小板正处于点击按下状态，那么就直接返回，否则canvas滚动的时候，生成的图片会跳跃
      if (this.imageTempMousedownFlag) {
        return
      }
      // 转换宽高
      let width = Math.ceil(
        this.tranlateSizeFromScale(part.rect.width) + partLineWidth * 1
      )
      let height = Math.ceil(
        this.tranlateSizeFromScale(part.rect.height) + partLineWidth * 1
      )

      // 这个是测试canvas
      const canvas = document.createElement('canvas')
      canvas.style.position = 'fixed'
      canvas.style.left = '10px'
      canvas.style.top = '10px'
      canvas.style.background = '#ececec'
      canvas.style.display = 'none'
      // 为了显示完全选中的红色边框，宽高各加上 this.deviation
      canvas.width = width
      canvas.height = height
      document.body.appendChild(canvas)

      let boxWrap = document.querySelector('.box-wrap')
      if (!boxWrap) {
        boxWrap = document.createElement('div')
        boxWrap.classList.add('box-wrap')
        document.body.appendChild(boxWrap)
      }
      boxWrap.innerHTML = ''
      boxWrap.appendChild(canvas)

      const newCtx = canvas.getContext('2d')
      let togglePart = JSON.parse(JSON.stringify(part))
      togglePart.startX = 0
      togglePart.startY = 0
      // 对ctx的样式进行延续
      newCtx.strokeStyle = oldCtx.strokeStyle
      newCtx.lineWidth = oldCtx.lineWidth
      newCtx.fillStyle = oldCtx.fillStyle
      this.drawParts(
        newCtx,
        togglePart,
        partLineWidth / 2,
        partLineWidth / 2,
        bigpart
      )
      this.genClickPlankImageDom()
      const base64 = canvas.toDataURL('image/png', {
        quality: 1,
        format: 'jpeg',
      })
      let image = document.querySelector(
        `.select-plank-image-${this.canvasKey}`
      )
      if (!this.plankMapImg) {
        this.plankMapImg = {}
      }
      // 如果没有缓存，或者缩放比例发生了变化，将生成的img进行缓存（由于有旋转问题，暂时不用图片缓存）
      // if (!this.plankMapImg[plankKey] || this.scalePercent !== this.lastScale) {
      //   this.plankMapImg[plankKey] = base64
      // }

      let imageWrap = document.querySelector(
        `.select-plank-image-wrap-${this.canvasKey}`
      )

      if (!image) {
        // 没有图片就创造图片
        image = document.createElement('img')
        image.className = `select-plank-image select-plank-image-${this.canvasKey}`
        // 把拖动事件挂载wrap上
        imageWrap.appendChild(image)
        this.handleImageTempMouseUp = async (e) => {
          await this.imageTempMouseUp(e)
          // 更新蓝色余料的数据
          this.updateBlueAreaSurplusPart(bigpart)
        }

        this.handleImageTempMouseDown = (e) => {
          this.setMousePointOffsetImage(e.offsetX, e.offsetY)
          // 设置标记为true
          this.imageTempMousedownFlag = true
        }
        imageWrap.addEventListener('mouseup', this.handleImageTempMouseUp)
        imageWrap.addEventListener('mousedown', this.handleImageTempMouseDown)
      }
      image.style.display = 'block'

      // image.src = this.plankMapImg[plankKey]
      image.src = base64
      const distanceBetweenPointAndPart = this.getDistanceBetweenPointAndPart(
        part,
        bigPankStartX,
        bigPankStartY
      )
      this.setMousePointOffsetImage(
        distanceBetweenPointAndPart.x,
        distanceBetweenPointAndPart.y
      )
      // 由于有线宽的原因，所以必须减去一半的线宽
      imageWrap.style.left =
        this.clickEvent.x -
        distanceBetweenPointAndPart.x -
        partLineWidth / 2 +
        'px'
      // 由于有线宽的原因，所以必须减去一半的线宽
      imageWrap.style.top =
        this.clickEvent.y -
        distanceBetweenPointAndPart.y -
        partLineWidth / 2 +
        'px'

      // 设置图片显示标记为true
      this.imageTempMousedownFlag = true
    },
    // 获取鼠标所在位置到板件的top和left的距离
    getDistanceBetweenPointAndPart(part, bigPankStartX, bigPankStartY) {
      const pos = this.windowToCanvas(
        this.clickEvent.clientX,
        this.clickEvent.clientY
      )
      let rect = this.genPartsRect(part, bigPankStartX, bigPankStartY)
      return {
        x: pos.x - rect.x,
        y: pos.y - rect.y,
      }
    },

    // 绘制右上角的的三点
    drawAddIcon(bigpart) {
      this.ctx.fillStyle = '#ECECEC'
      let newLeft =
        bigpart.startX +
        3 * this.deviation +
        bigpart.width +
        2 * this.scalePercent
      let newTop = bigpart.startY + this.padding + this.deviation
      let long = 40 * this.scalePercent
      let r = 2.5 * this.scalePercent
      this.ctx.fillRect(newLeft, newTop, long, long)

      this.ctx.fillStyle = '#666'
      this.ctx.beginPath()
      this.ctx.arc(
        newLeft + 9 * this.scalePercent,
        newTop + 20 * this.scalePercent,
        r,
        0,
        Math.PI * 2,
        true
      )
      this.ctx.closePath()
      this.ctx.fill()

      this.ctx.beginPath()
      this.ctx.arc(
        newLeft + 18 * this.scalePercent,
        newTop + 20 * this.scalePercent,
        r,
        0,
        Math.PI * 2,
        true
      )
      this.ctx.closePath()
      this.ctx.fill()

      this.ctx.beginPath()
      this.ctx.arc(
        newLeft + 27 * this.scalePercent,
        newTop + 20 * this.scalePercent,
        r,
        0,
        Math.PI * 2,
        true
      )
      this.ctx.closePath()
      this.ctx.fill()
    },

    // 判断鼠标点击位置是否在三点上
    isMouseInThreePoint(point, bigpart) {
      // 这里说明点击外置在大板外
      if (!bigpart) return
      const { offsetX, offsetY } = point
      let { startX, startY, width } = bigpart
      // 这里减5的原因，是鼠标右键点击在这个矩形与大板之间的空隙时，不会被检测到点击在了三点上，
      // 但是原本（setActivePlank）的检测逻辑会检测在了三点上，打开原本的菜单，因此这里减少左侧判断边界，提前判断点击到三点。
      const targetMinX =
        startX + 3 * this.deviation + width + 2 * this.scalePercent - 5
      const targetMaxX = targetMinX + 40 * this.scalePercent

      const targetMinY = startY + this.padding + this.deviation
      const targetMaxY = targetMinY + 40 * this.scalePercent

      const isOnThreePoint =
        offsetX >= targetMinX &&
        offsetX <= targetMaxX &&
        offsetY >= targetMinY &&
        offsetY <= targetMaxY

      return isOnThreePoint
    },

    /**
     * 绘制大板顶部信息包括正反切换和优化率
     * @param { Object } bigpart 大板信息
     */
    drawTopInfo(bigpart) {
      let fontSize = 14 * this.scalePercent
      this.ctx.font = `bold ${fontSize}px 'PingFangSC-Regular, PingFang SC' `
      let { startX, startY } = bigpart
      let width = bigpart.width + 2 * this.deviation
      const isSurplus = bigpart.surplusInfo && !bigpart.surplusInfo.isNotSurplus
      const isLshape =
        bigpart.surplusInfo &&
        (bigpart.surplusInfo.shape == 'lshape' ||
          (bigpart.surplusInfo.path &&
            [6, 7].includes(bigpart.surplusInfo.path.length)))
      const plankSize = calcPlankSize(bigpart, isLshape)
      const bigpartMargin = bigpart.margin.toString().includes(',')
        ? bigpart.margin.split(',')[0]
        : bigpart.margin
      let usedRate =
        '【' +
        bigpart.canvasIndex +
        '】' +
        `${((bigpart.usedRate > 1 ? 1 : bigpart.usedRate) * 100).toFixed(2)}` +
        '%' +
        '-' +
        (isLshape
          ? `[${plankSize.longW}(${plankSize.shortW})X${plankSize.longH}(${plankSize.shortH})]`
          : `${bigpart.plankWidth}X${bigpart.plankHeight}`) +
        '-' +
        bigpartMargin
      const rateStr =
        '【' +
        bigpart.canvasIndex +
        '】' +
        `${((bigpart.usedRate > 1 ? 1 : bigpart.usedRate) * 100).toFixed(2)}` +
        '%' +
        '-'
      const sizeStr =
        (isLshape
          ? `${plankSize.longW}(${plankSize.shortW})X${plankSize.longH}(${plankSize.shortH})`
          : `${bigpart.plankWidth}X${bigpart.plankHeight}`) +
        '-' +
        bigpartMargin
      let surStore =
        bigpart.surplusInfo?.branch_name == '-'
          ? ''
          : bigpart.surplusInfo?.branch_name
      // 如果surStore的值为-，设置为空
      let copySurStore = bigpart.surplusInfo?.branch_name
      if (isSurplus && surStore) {
        for (let i = 0; i <= copySurStore.length; i++) {
          if (this.calcTextSize(copySurStore.slice(0, i)) >= width) {
            surStore = `${surStore.slice(0, i - 1)}...`
            break
          }
        }
      }
      if (bigpart.ableToggle) {
        if (this.isHighPlank) {
          // 绘制正
          this.ctx.fillStyle = '#18a8c7'
          this.ctx.fillRect(
            startX,
            startY + this.padding / 2,
            width / 2,
            this.padding / 2
          )
          // 绘制正字
          this.ctx.fillStyle = '#fff'
          let textWidth = this.calcTextSize(translate('common.front'))
          let padding = (width / 2 - textWidth) / 2
          this.ctx.fillText(
            translate('common.front'),
            startX + padding,
            startY + 22 * this.scalePercent + this.padding / 2
          )

          // 绘制反
          this.ctx.fillStyle = '#d7d7d7'
          this.ctx.fillRect(
            startX + width / 2,
            startY + this.padding / 2,
            width / 2,
            this.padding / 2
          )
          this.ctx.fillStyle = '#666'
          // 绘制反字
          this.ctx.fillText(
            translate('common.back'),
            startX + width / 2 + padding,
            startY + 22 * this.scalePercent + this.padding / 2
          )

          // 绘制优化率
          this.ctx.fillStyle = '#fff'
          this.ctx.fillRect(
            startX + width / 2,
            startY - 33 * this.scalePercent,
            width / 2,
            this.padding / 2
          )
          this.ctx.fillStyle = '#333'
          textWidth = this.calcTextSize(usedRate)
          this.ctx.beginPath()
          if (textWidth + (isSurplus ? 24 : 10) > width) {
            if (isSurplus) {
              this.ctx.strokeStyle = '#000'
              circleText(
                this.ctx,
                startX + 12 * this.scalePercent,
                surStore
                  ? startY - 19 * this.scalePercent
                  : startY - 5 * this.scalePercent,
                10 * this.scalePercent,
                '余',
                this.scalePercent
              )
            }
            this.ctx.fillText(
              rateStr,
              isSurplus ? startX + 24 * this.scalePercent : startX,
              isSurplus && surStore ? startY - 14 * this.scalePercent : startY
            )
            this.ctx.fillText(
              sizeStr,
              startX,
              isSurplus && surStore
                ? startY + 8 * this.scalePercent
                : startY + 24 * this.scalePercent
            )
            if (isSurplus && surStore) {
              this.ctx.fillText(
                surStore,
                startX,
                startY + 28 * this.scalePercent
              )
            }
          } else {
            padding = (width / 3 - textWidth) / 2
            // 绘制优化率文字
            if (isSurplus) {
              this.ctx.strokeStyle = '#000'
              circleText(
                this.ctx,
                startX + 12 * this.scalePercent,
                surStore
                  ? startY + 4 * this.scalePercent
                  : startY + 18 * this.scalePercent,
                10 * this.scalePercent,
                '余',
                this.scalePercent
              )
            }
            this.ctx.fillText(
              usedRate,
              isSurplus ? startX + 24 * this.scalePercent : startX,
              isSurplus && surStore
                ? startY + 8 * this.scalePercent
                : startY + 24 * this.scalePercent
            )
            if (isSurplus && surStore) {
              this.ctx.fillText(
                surStore,
                startX,
                startY + 28 * this.scalePercent
              )
            }
          }
          return
        }
        if (bigpart.sideType == 1) {
          // 绘制正
          this.ctx.fillStyle = '#18a8c7'
          this.ctx.fillRect(
            startX,
            startY + this.padding / 2,
            width / 2,
            this.padding / 2
          )
          // 绘制正字
          this.ctx.fillStyle = '#fff'
          let textWidth = this.calcTextSize(translate('common.front'))
          let padding = (width / 2 - textWidth) / 2
          this.ctx.fillText(
            translate('common.front'),
            startX + padding,
            startY + 22 * this.scalePercent + this.padding / 2
          )

          // 绘制反
          this.ctx.fillStyle = '#fff'
          this.ctx.fillRect(
            startX + width / 2,
            startY + this.padding / 2,
            width / 2,
            this.padding / 2
          )
          this.ctx.fillStyle = 'rgba(0, 0, 0, 0.6)'
          // 绘制反字
          this.ctx.fillText(
            translate('common.back'),
            startX + width / 2 + padding,
            startY + 22 * this.scalePercent + this.padding / 2
          )

          // 绘制优化率
          this.ctx.fillStyle = '#fff'
          this.ctx.fillRect(
            startX,
            startY - 33 * this.scalePercent,
            width,
            this.padding / 2
          )
          this.ctx.fillStyle = '#333'
          textWidth = this.calcTextSize(usedRate)
          this.ctx.beginPath()
          if (textWidth + (isSurplus ? 24 : 10) > width) {
            if (isSurplus) {
              this.ctx.strokeStyle = '#000'
              circleText(
                this.ctx,
                startX + 12 * this.scalePercent,
                surStore
                  ? startY - 19 * this.scalePercent
                  : startY - 5 * this.scalePercent,
                10 * this.scalePercent,
                '余',
                this.scalePercent
              )
            }
            this.ctx.fillText(
              rateStr,
              isSurplus ? startX + 24 * this.scalePercent : startX,
              isSurplus && surStore ? startY - 14 * this.scalePercent : startY
            )
            this.ctx.fillText(
              sizeStr,
              startX,
              isSurplus && surStore
                ? startY + 8 * this.scalePercent
                : startY + 24 * this.scalePercent
            )
            if (isSurplus && surStore) {
              this.ctx.fillText(
                surStore,
                startX,
                startY + 28 * this.scalePercent
              )
            }
          } else {
            padding = (width / 3 - textWidth) / 2
            // 绘制优化率文字
            if (isSurplus) {
              this.ctx.strokeStyle = '#000'
              circleText(
                this.ctx,
                startX + 12 * this.scalePercent,
                surStore
                  ? startY + 4 * this.scalePercent
                  : startY + 18 * this.scalePercent,
                10 * this.scalePercent,
                '余',
                this.scalePercent
              )
            }
            this.ctx.fillText(
              usedRate,
              isSurplus ? startX + 24 * this.scalePercent : startX,
              isSurplus && surStore
                ? startY + 8 * this.scalePercent
                : startY + 24 * this.scalePercent
            )
            if (isSurplus && surStore) {
              this.ctx.fillText(
                surStore,
                startX,
                startY + 28 * this.scalePercent
              )
            }
          }
        } else {
          // 绘制正
          this.ctx.fillStyle = '#fff'
          this.ctx.fillRect(
            startX,
            startY + this.padding / 2,
            width / 2,
            this.padding / 2
          )
          // 绘制正字
          this.ctx.fillStyle = 'rgba(0, 0, 0, 0.6)'
          let textWidth = this.calcTextSize(translate('common.front'))
          let padding = (width / 2 - textWidth) / 2
          this.ctx.fillText(
            translate('common.front'),
            startX + padding,
            startY + 22 * this.scalePercent + this.padding / 2
          )

          // 绘制反
          this.ctx.fillStyle = '#18a8c7'
          this.ctx.fillRect(
            startX + width / 2,
            startY + this.padding / 2,
            width / 2,
            this.padding / 2
          )
          this.ctx.fillStyle = '#fff'
          // 绘制反字
          this.ctx.fillText(
            translate('common.back'),
            startX + width / 2 + padding,
            startY + 22 * this.scalePercent + this.padding / 2
          )

          // 绘制优化率
          this.ctx.fillStyle = '#fff'
          this.ctx.fillRect(
            startX + width / 2,
            startY - 33 * this.scalePercent,
            width / 2,
            this.padding / 2
          )
          this.ctx.fillStyle = '#333'
          textWidth = this.calcTextSize(usedRate)
          this.ctx.beginPath()
          if (textWidth + (isSurplus ? 24 : 10) > width) {
            if (isSurplus) {
              this.ctx.strokeStyle = '#000'
              circleText(
                this.ctx,
                startX + 12 * this.scalePercent,
                surStore
                  ? startY - 19 * this.scalePercent
                  : startY - 5 * this.scalePercent,
                10 * this.scalePercent,
                '余',
                this.scalePercent
              )
            }
            this.ctx.fillText(
              rateStr,
              isSurplus ? startX + 24 * this.scalePercent : startX,
              isSurplus && surStore ? startY - 14 * this.scalePercent : startY
            )
            this.ctx.fillText(
              sizeStr,
              startX,
              isSurplus && surStore
                ? startY + 8 * this.scalePercent
                : startY + 24 * this.scalePercent
            )
            if (isSurplus && surStore) {
              this.ctx.fillText(
                surStore,
                startX,
                startY + 28 * this.scalePercent
              )
            }
          } else {
            padding = (width / 3 - textWidth) / 2
            // 绘制优化率文字
            if (isSurplus) {
              this.ctx.strokeStyle = '#000'
              circleText(
                this.ctx,
                startX + 12 * this.scalePercent,
                surStore
                  ? startY + 4 * this.scalePercent
                  : startY + 18 * this.scalePercent,
                10 * this.scalePercent,
                '余',
                this.scalePercent
              )
            }
            this.ctx.fillText(
              usedRate,
              isSurplus ? startX + 24 * this.scalePercent : startX,
              isSurplus && surStore
                ? startY + 8 * this.scalePercent
                : startY + 24 * this.scalePercent
            )
            if (isSurplus && surStore) {
              this.ctx.fillText(
                surStore,
                startX,
                startY + 28 * this.scalePercent
              )
            }
          }
        }
      } else {
        // 绘制优化率
        this.ctx.fillStyle = '#cfcfcf'
        this.ctx.fillRect(
          startX,
          startY + this.padding / 2,
          width,
          this.padding / 2
        )
        this.ctx.fillStyle = '#333'
        let headWidth = this.calcTextSize(usedRate)
        this.ctx.beginPath()
        // 如果当前大板是余料板
        if (headWidth + (isSurplus ? 24 : 10) > width) {
          if (isSurplus) {
            this.ctx.strokeStyle = '#000'
            circleText(
              this.ctx,
              startX + 12 * this.scalePercent,
              surStore
                ? startY - 19 * this.scalePercent
                : startY - 5 * this.scalePercent,
              10 * this.scalePercent,
              '余',
              this.scalePercent
            )
          }
          this.ctx.fillText(
            rateStr,
            isSurplus ? startX + 24 * this.scalePercent : startX,
            isSurplus && surStore ? startY - 14 * this.scalePercent : startY
          )
          this.ctx.fillText(
            sizeStr,
            startX,
            isSurplus && surStore
              ? startY + 8 * this.scalePercent
              : startY + 24 * this.scalePercent
          )
          if (isSurplus && surStore) {
            this.ctx.fillText(surStore, startX, startY + 28 * this.scalePercent)
          }
        } else {
          // 绘制优化率文字
          if (isSurplus) {
            this.ctx.strokeStyle = '#000'
            circleText(
              this.ctx,
              startX + 12 * this.scalePercent,
              surStore
                ? startY + 4 * this.scalePercent
                : startY + 18 * this.scalePercent,
              10 * this.scalePercent,
              '余',
              this.scalePercent
            )
          }
          this.ctx.fillText(
            usedRate,
            isSurplus ? startX + 24 * this.scalePercent : startX,
            isSurplus && surStore
              ? startY + 8 * this.scalePercent
              : startY + 24 * this.scalePercent
          )
          if (isSurplus && surStore) {
            this.ctx.fillText(surStore, startX, startY + 28 * this.scalePercent)
          }
        }

        // 绘制单面
        let textWidth = this.calcTextSize(translate('common.singlePlank'))
        let padding = (width - textWidth) / 2
        this.ctx.fillStyle = 'rgba(255, 255, 255, 0.9)'
        this.ctx.fillRect(
          startX,
          startY + this.padding / 2,
          width,
          this.padding / 2
        )
        this.ctx.fillStyle = 'rgba(0, 0, 0, 0.6)'
        // 绘制单面板文字
        this.ctx.fillText(
          translate('common.singlePlank'),
          startX + padding,
          startY + 22 * this.scalePercent + this.padding / 2
        )

        if (bigpart.noEngraving) {
          this.ctx.fillStyle = 'rgba(247, 158, 19)'
          this.ctx.strokeStyle = 'rgba(247, 158, 19)'
          /** 圆心坐标 */
          const circleX = startX + padding + textWidth + 12 * this.scalePercent
          const circleY = startY + 17 * this.scalePercent + this.padding / 2
          /** 圆半径 */
          const circleR = 10 * this.scalePercent
          circleText(
            this.ctx,
            circleX,
            circleY,
            circleR,
            '雕',
            this.scalePercent
          )
          // 记录标记位置
          this.needMarkRectArr.push({
            x: circleX - circleR,
            y: circleY - circleR,
            width: circleR * 2,
            height: circleR * 2,
            type: 'singleMark',
            bigPlank: bigpart,
          })
        }

        bigpart.fanbanCount = 0
        this.$props.calcFanbanCount()
      }
    },

    /**
     * 绘制四边修边
     * @param bigpart 大板信息
     */
    drawFourEdge(bigpart) {
      if (bigpart.margin.toString().includes(',')) {
        const marginArr = bigpart.margin.split(',')
        const leftMarginSize = this.calcTextSize(marginArr[2])
        // 左修边
        this.ctx.fillText(
          marginArr[2],
          bigpart.startX - this.deviation - leftMarginSize - 1,
          bigpart.startY + this.deviation + this.padding + bigpart.height / 2
        )
        // 下修边
        this.ctx.fillText(
          marginArr[1],
          bigpart.startX + bigpart.width / 2,
          bigpart.startY + this.deviation + this.padding + bigpart.height + 22
        )
        // 右修边
        this.ctx.fillText(
          marginArr[3],
          bigpart.startX + this.deviation + bigpart.width + 11,
          bigpart.startY + this.deviation + this.padding + bigpart.height / 2
        )
      }
    },

    // 判断大板是否可以进行正反切换
    judgeAbleFanban(bigpart) {
      // 弹框
      let toggleFlag = false
      bigpart.parts.forEach((part) => {
        ;[part.engraving_cut_curve, part.engraving_cut_curve_to_turn] = [
          part.engraving_cut_curve_to_turn,
          part.engraving_cut_curve,
        ]
      })

      /** 打穿的异形孔不考虑翻面 */
      const allNoThroughCurveHoles = bigpart.parts
        .map((part) =>
          (part.curveHoles ?? []).filter((h) => h.deep + 0.001 < part.thick)
        )
        .flat(1)
      const sideArr = bigpart.parts
        .filter((p) => p.specialType !== 'supplus')
        .map((part) => [
          ...part.slots,
          ...part.holes,
          ...(part.lineSlots ?? []),
          ...allNoThroughCurveHoles,
          ...(part.millInfo ? part.millInfo : []),
          ...(part.handleSlopes ?? []),
        ])
      const lineSlotArr = bigpart.parts
        .filter((p) => p.specialType !== 'supplus')
        .map((part) => [...(part.lineSlots ?? [])])
      // 通孔通槽双面加工，大板显示正反
      const holeArr = bigpart.parts
        .filter((p) => p.specialType !== 'supplus')
        .map((part) => [
          ...part.holes,
          // ...(part.curveHoles ? part.curveHoles : []),
        ])
      const slotArr = bigpart.parts
        .filter((p) => p.specialType !== 'supplus')
        .map((part) => [
          ...part.slots,
          ...(part.millInfo ? part.millInfo : []),
          ...(part.handleSlopes ?? []),
        ])

      //  过滤掉满足设置不生效翻面两次打穿规则的孔
      let isLockHole = false
      let rules = []
      // 如果开启翻面两次打穿孔槽，并且开启设置不生效翻面两次打穿规则的孔，则需要过滤掉满足设置不生效翻面两次打穿规则的孔
      if (
        this.ncSetting.throughTowSideToCut &&
        this.ncSetting.non_through_slot_two_side_cut?.is_open
      ) {
        // 开启设置不生效翻面两次打穿规则的孔
        const specialHoleSlotSide =
          this.ncSetting.non_through_slot_two_side_cut?.special_hole_slot_side
        if (specialHoleSlotSide.length) {
          specialHoleSlotSide.forEach((item) => {
            if (item.key === 'LockHole') {
              isLockHole = true
            } else {
              rules.push(item.rules)
            }
          })
        }
      }
      const filterHoles = holeArr.flat(1).filter((v) => {
        // 如果开启锁孔过滤，则过滤掉锁孔类型的孔
        if (isLockHole && v.symbol === 'LockHole') {
          return false
        }
        // 如果没有规则，保留该孔
        if (rules.length === 0) {
          return true
        }
        // 常规孔规则判断
        if (v.symbol !== 'LockHole') {
          // 走到这里若没有定义锁孔规则，这里会有锁孔情况，常规孔规则要过滤掉锁孔
          const diameter = Number(v.diameter)
          const isMatchRule = rules.some((rule) => {
            const ruleValue = Number(rule.value)
            const compareFn = compareMap[rule.compare]
            return compareFn ? compareFn(diameter, ruleValue) : false
          })
          return !isMatchRule
        }
        return true
      })
      let holeToggle = false
      if (filterHoles.length > 0) {
        holeToggle = filterHoles.some(
          (v) => v.deep * 1 + 0.001 >= bigpart.thick && !v.isFixedSide
        )
      }
      // const holeToggle = holeArr
      //   .flat(1)
      //   .some((v) => v.deep * 1 + 0.001 >= bigpart.thick && !v.isFixedSide)

      const slotToggle = [...slotArr, ...lineSlotArr]
        .flat(1)
        .some((v) => v.deep * 1 + 0.001 >= bigpart.thick)
      toggleFlag = sideArr.flat(1).every((v) => v.side == 1)
      /** 是否仅计算雕刻机加工的孔槽翻版 */
      const isCalTrunNumAFTshunt = this.ncSetting.cal_turn_num_aft_shunt
      /** 是否是组合设备 */
      const combinationEquip = this.ncSetting.combinationEquip
      if (isCalTrunNumAFTshunt && !combinationEquip) {
        /** 是否异形孔数据在雕刻机上加工 */
        const isEngravingCurveholes = bigpart.parts.every(
          (part) => part.process_in_engraving_to_curve
        )
        const hasEngravingCurveholeBack = bigpart.parts.some((part) => {
          return (
            part?.engraving_cut_curve &&
            part.engraving_cut_curve.includes('back')
          )
        })
        const onlyHoleSlots = bigpart.parts
          .filter((p) => p.specialType !== 'surplus')
          .map((part) => [
            ...part.slots,
            part.holes,
            ...(part.lineSlots ?? []),
            part.handleSlopes ?? [],
          ])
          .flat(Infinity)
        /** 所有分流的孔槽 */
        const shuntHoleSlotArr = onlyHoleSlots.filter(
          (it) => it.process_in_engraving || it.process_in_engraving_to_turn
        )
        /** 所有的curveHoles */
        const shuntCurveHoles = bigpart.parts
          .filter((p) => p.specialType !== 'surplus')
          .map((part) => part.curveHoles)
          .flat(Infinity)
          .filter(Boolean)
        /** 是否有在雕刻机上反面加工的孔槽 */
        const hasEngravingBackProcess =
          shuntHoleSlotArr.some(
            (it) => it.side == -1 && it.process_in_engraving
          ) ||
          (isEngravingCurveholes &&
            shuntCurveHoles.some((hole) => hole.side == -1)) ||
          hasEngravingCurveholeBack
        const hasBackHoleSlot = [...onlyHoleSlots, ...shuntCurveHoles].some(
          (it) => it.side == -1
        )
        // 没有翻面需要在雕刻机上加工的孔槽《并且》孔槽分流设置《不是》雕刻机《加工正反面孔槽》
        if (
          !hasEngravingBackProcess &&
          this.ncSetting.ncHoleSlot !== 'doubleHoleSlot'
        ) {
          bigpart.ableToggle = false
          bigpart.noEngraving = hasBackHoleSlot
        } else {
          bigpart.ableToggle = hasEngravingBackProcess
          bigpart.noEngraving = hasEngravingBackProcess
            ? false
            : hasBackHoleSlot
        }
      } else {
        // 判断了通孔/通槽分双面打穿
        // 小板存在反面（side == -1）的孔/槽/异形孔/牛角槽/拉手槽（且不包含三合一预埋孔）
        // 开启通孔双面加工（throughTowSideToCut）且存在打穿孔（深度 ≥ 板厚）(且不包含三合一预埋孔)
        // 开启通槽双面加工（through_slot_two_side_cut）且存在打穿槽（深度 ≥ 板厚）
        bigpart.ableToggle =
          !toggleFlag ||
          (this.ncSetting.throughTowSideToCut && holeToggle) ||
          (this.ncSetting.through_slot_two_side_cut && slotToggle)
      }
    },

    // 获取文字宽度, 用于中心绘制
    calcTextSize(text) {
      let span = document.createElement('span')
      let result = {}
      result.width = span.offsetWidth
      result.height = span.offsetHeight
      span.style.visibility = 'hidden'
      span.style.fontSize = `14px`
      span.style.fontFamily = 'PingFangSC-Regular, PingFang SC'
      span.style.display = 'inline-block'
      document.body.appendChild(span)
      if (typeof span.textContent != 'undefined') {
        span.textContent = text
      } else {
        span.innerText = text
      }
      result.width =
        parseFloat(window.getComputedStyle(span).width) - result.width
      // result.height = parseFloat(window.getComputedStyle(span).height) - result.height;
      document.body.removeChild(span)
      let width = result.width * this.scalePercent
      return width
    },
    /**
     * 绘制小板
     * @param { Object } part 小板数据
     * @param { Number } bigPankStartX 大板的绘制起始横坐标
     * @param { Number } bigPankStartY 大板的绘制起始纵坐标
     */
    drawParts(ctx, part, bigPankStartX, bigPankStartY, bigPart) {
      const partTemp = transformData(part, store)

      const startX =
        bigPankStartX + (partTemp.startX / defaultScale) * this.scalePercent
      const startY =
        bigPankStartY + (partTemp.startY / defaultScale) * this.scalePercent
      const plank = new Plank(
        ctx,
        partTemp,
        startX,
        startY,
        defaultScale,
        this.scalePercent,
        { plankLineWidth: this.plankLineWidth ?? 1 }
      )
      // 激活板件或者入库时需要设置板件激活颜色
      if (
        (this.$props.isBatchBujian &&
          this.bujianList.some((bujian) => isSamePart(bujian, partTemp))) ||
        (this.$props.isBatchTagging &&
          this.taggingList.some((item) => isSamePart(item, partTemp)))
      ) {
        plank.setFillStyle(DrawPlankColorJs.active)
      } else {
        if (
          this.activePlank &&
          isSamePart(this.activePlank, partTemp) &&
          !this.$props.isBatchBujian &&
          !this.$props.isBatchTagging
        ) {
          plank.setFillStyle(DrawPlankColorJs.active)
        }
        if (partTemp.plankMerge) {
          plank.setFillStyle(DrawPlankColorJs.plankMerge)
        }
      }
      // 跨材质板件使用虚线边框
      if (partTemp._isCrossMaterial) {
        plank.setDashedBorder(true)
      }

      const notDraw = []
      // 某些不绘制的实例
      if (!this.isShowPartSize) notDraw.push('plankSize')

      if (!this.isCuttingOrder) notDraw.push('cutOrder')
      if (!this.isMarkModifiedSmallBoards)
        notDraw.push('markModifiedSmallBoards')
      // this.mouseOnBlueArea为当前鼠标经过的蓝色余料的大板对象。
      // 现在需要判断当前鼠标经过的蓝色余料
      if (this.mouseOnBlueArea && !this.isShowPartSize) {
        // 将notDraw的plankSize删除
        if (partTemp.blueAreaSurplus) {
          notDraw.splice(notDraw.indexOf('plankSize'), 1)
        }
      }
      const draws = plankDrawFactory(
        ctx,
        partTemp,
        startX,
        startY,
        defaultScale,
        this.scalePercent,
        {
          dotWidth: this.dotWidth,
          textWidth: this.textWidth,
          fontSize: 14,
        },
        notDraw,
        this.mouseOnBlueArea?.bigpart,
        this.isShowPartSize
      )

      // 判断这块大板是否满足了分层切割
      const isMatched = matchLayeredCutForPalnkThick({
        matCode: bigPart.matCode,
        thick: bigPart.thick,
        is_high_gloss_plank: bigPart.highlight === '非高光' ? false : true,
      })
      // 异形板件，且开启了异形板分层切割
      if (
        partTemp.curve_layered_cutting &&
        Number(partTemp.curve_layered_cutting_deep) < partTemp.thick &&
        !isMatched
      ) {
        plank.setStrokeStyle('skyblue')
        plank.setLineWidth(3)
      }

      plank.addStrategy(Object.keys(draws).map((it) => draws[it]))
      plank.draw()
    },

    // drawClampHand
    drawClampHand(ctx, bigpart, bigPankStartX, bigPankStartY) {
      const {
        aio_fixture_setting: aioFixtureSetting,
        enable_integration_device: enableIntegrationDevice,
        xyReverse,
        startPosition,
      } = this.ncSetting
      const { aio_avoid_fixture: aioAvoidFixture } = aioFixtureSetting
      // 防止从排版历史进入，当前生产线未开启夹手会将夹手绘制出来
      if (!aioAvoidFixture || !enableIntegrationDevice) return

      let clampHandInfo = bigpart.clampHandInfo
      const plankWidth = Number(bigpart.plankWidth)
      const plankHeight = Number(bigpart.plankHeight)
      if (
        (!Array.isArray(clampHandInfo) || !clampHandInfo.length) &&
        plankWidth > 0 &&
        plankHeight > 0
      ) {
        clampHandInfo = buildClampHandInfoForPlank(
          plankWidth,
          plankHeight,
          {
            clampHandHeight: aioFixtureSetting.aio_fixture_length,
            clampHandWidth: aioFixtureSetting.aio_fixture_width,
            clampHandMargin1: aioFixtureSetting.aio_first_fixture_height,
            clampHandMargin2: aioFixtureSetting.aio_second_fixture_height,
            clampHandDirection: aioFixtureSetting.aio_fixture_direction,
          },
          { isXyReverse: xyReverse, startPosition }
        )
        this.$set(bigpart, 'clampHandInfo', clampHandInfo)
      }

      clampHandInfo?.forEach((item) => {
        const startX =
          bigPankStartX + (item.startX / defaultScale) * this.scalePercent
        const startY =
          bigPankStartY + (item.startY / defaultScale) * this.scalePercent
        this.ctx.fillStyle = DrawPlankColorJs.normal
        this.ctx.strokeStyle = DrawPlankColorJs.normal
        const plank = new Plank(
          ctx,
          item,
          startX,
          startY,
          defaultScale,
          this.scalePercent,
          { plankLineWidth: this.plankLineWidth ?? 1 }
        )
        plank.draw()
      })
    },

    /**
     * 该方法用来绘制一个有填充色的圆角矩形
     * @param cxt:canvas的上下文环境
     * @param x:左上角x轴坐标
     * @param y:左上角y轴坐标
     * @param width:矩形的宽度
     * @param height:矩形的高度
     * @param radius:圆的半径
     * @param fillColor:填充颜色
     **/
    fillRoundRect(cxt, x, y, width, height, radius, /*optional*/ fillColor) {
      //圆的直径必然要小于矩形的宽高
      if (2 * radius > width || 2 * radius > height) {
        return false
      }

      cxt.save()
      cxt.translate(x, y)
      //绘制圆角矩形的各个边
      this.drawRoundRectPath(cxt, width, height, radius)
      cxt.fillStyle = fillColor || '#000' //若是给定了值就用给定的值否则给予默认值
      cxt.fill()
      cxt.restore()
    },

    /**
     * 该方法用来绘制圆角矩形
     * @param cxt:canvas的上下文环境
     * @param x:左上角x轴坐标
     * @param y:左上角y轴坐标
     * @param width:矩形的宽度
     * @param height:矩形的高度
     * @param radius:圆的半径
     * @param lineWidth:线条粗细
     * @param strokeColor:线条颜色
     **/
    strokeRoundRect(
      cxt,
      x,
      y,
      width,
      height,
      radius,
      /*optional*/ lineWidth,
      /*optional*/ strokeColor
    ) {
      //圆的直径必然要小于矩形的宽高
      if (2 * radius > width || 2 * radius > height) {
        return false
      }

      cxt.save()
      cxt.translate(x, y)
      //绘制圆角矩形的各个边
      this.drawRoundRectPath(cxt, width, height, radius)
      cxt.lineWidth = lineWidth || 1 //若是给定了值就用给定的值否则给予默认值2
      cxt.strokeStyle = strokeColor || '#000'
      cxt.stroke()
      cxt.restore()
    },

    drawRoundRectPath(cxt, width, height, radius) {
      cxt.beginPath(0)
      //从右下角顺时针绘制，弧度从0到1/2PI
      cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2)
      //矩形下边线
      cxt.lineTo(radius, height)
      //左下角圆弧，弧度从1/2PI到PI
      cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI)
      //矩形左边线
      cxt.lineTo(0, radius)
      //左上角圆弧，弧度从PI到3/2PI
      cxt.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2)
      //上边线
      cxt.lineTo(width - radius, 0)
      //右上角圆弧
      cxt.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2)
      //右边线
      cxt.lineTo(width, height - radius)
      cxt.closePath()
    },

    /**
     * 设置激活板件
     * @param { Object } e 事件对象
     * @returns
     */
    setActivePlank(e) {
      let mousePoint = {
        x: e.offsetX,
        y: e.offsetY,
      }
      // 找到当前点击的位置属于哪一个大板, 找到起始坐标小于当前鼠标位置的所有大板, 取最后一个大板
      let arr = this.sliceDrawData.filter(
        (v) => mousePoint.x >= v.startX && mousePoint.y >= v.startY
      )
      if (arr.length == 0) return null
      // 判断鼠标位置是否在大板所处的位置
      let targetBigpart = arr[arr.length - 1]
      // 找到原数据中的bigpart
      let bigpart = this.sliceDrawData.find(
        (v) => v.stockKey == targetBigpart.stockKey
      )

      // 如果没有找到大板, 则清除之前激活的板件, return
      if (!bigpart) {
        this.setActiveBigPart(null)
        this.activePlank = null
        return null
      }
      // 判断是否点击到了三个点上
      const isOnThreePoint = this.jundgeLocationOnThreePoint(
        bigpart,
        mousePoint
      )
      // 判断是否点击到了大板
      if (isOnThreePoint) {
        let extraBtnX =
          bigpart.startX +
          2 * this.deviation +
          bigpart.width +
          2 * this.scalePercent -
          e.offsetX
        let extraBtnY =
          bigpart.startY + this.padding + this.deviation - e.offsetY
        if (this.activeBigpart && bigpart.isActive) {
          this.canvasBtn.left = e.pageX + extraBtnX
          this.canvasBtn.top = e.pageY + extraBtnY + 40 * this.scalePercent
          this.canvasBtn.data = bigpart
          return null
        }
      }
      this.canvasBtn.data = null
      // 如果找到了, 则判断点击的位置
      if (
        mousePoint.x <= bigpart.startX + bigpart.width + 2 * this.deviation &&
        mousePoint.y <=
          bigpart.startY + bigpart.height + this.padding + 2 * this.deviation
      ) {
        // 判断点击的是否为大板, 还是顶部信息
        if (
          mousePoint.y >= bigpart.startY + this.padding &&
          mousePoint.y <=
            bigpart.startY + bigpart.height + this.padding + 2 * this.deviation
        ) {
          this.setActiveBigPart(bigpart)
          // this.canvasBtn.data = bigpart
          // 当前激活大板为true其他大板为false
          const data = this.drawData.data
          // 当前激活大板为true其他大板为false
          data.forEach((item) => {
            item.isActive = item.stockKey === bigpart.stockKey
          })
          this.emptyDistance = dealCurrentPointDistance(
            bigpart,
            mousePoint,
            this.deviation,
            this.padding,
            this.scalePercent,
            defaultScale,
            'paiban'
          )
          this.mousePoint = mousePoint
          // 处理右键一个空的大板的空白处时，不会取消之前的选中的小板的问题。
          // 过滤掉含有cy字段的板件，但不影响原数据
          const filteredParts = bigpart.parts.filter(
            (part) => !part.blueAreaSurplus
          )
          if (!filteredParts.length) this.activePlank = null
          // const targetData = bigpart.parts.concat([])
          for (let i = 0; i < filteredParts.length; ++i) {
            let part = filteredParts[i]
            let rect = {
              x:
                bigpart.startX +
                this.deviation +
                this.tranlateSizeFromScale(part.startX),
              y:
                bigpart.startY +
                this.deviation +
                this.padding +
                this.tranlateSizeFromScale(part.startY),
            }
            let newPos = {
              x: this.restoreScaleSize(mousePoint.x - rect.x),
              y: this.restoreScaleSize(mousePoint.y - rect.y),
            }
            let curvePath = []
            if (part.path) {
              const curveHolesArr = part.curveHoles?.map((it) => it.path)
              curvePath = [...part.path]
              if (curveHolesArr && curveHolesArr.length && !!curveHolesArr[0]) {
                curvePath.push(...curveHolesArr)
              }
            } else {
              curvePath = [
                [
                  { x: 0, y: 0 },
                  { x: part.rect.width, y: 0 },
                  {
                    x: part.rect.width,
                    y: part.rect.height,
                  },
                  { x: 0, y: part.rect.height },
                ],
              ]
            }
            let isInpoly = curvePath
              .map((curve) => this.isInPolygon(newPos, curve))
              .filter((e) => e)
            if (isInpoly.length == 1) {
              this.emptyDistance = false
              this.activePlank = part
              this.clearConflict()
              this.renderAll()
              return part
            } else {
              this.activePlank = null
            }
          }
          this.renderAll()
          return null
        } else if (
          mousePoint.y >= bigpart.startY + 30 &&
          mousePoint.y < bigpart.startY + this.padding
        ) {
          // 需要去掉头部展示大板信息的文字部分高度 30
          this.emptyDistance = false
          this.setActiveBigPart(null)
          const holeArr = bigpart.parts
            .filter((p) => !p.blueAreaSurplus && p.specialType !== 'supplus')
            .map((part) => [
              ...part.holes,
              // ...(part.curveHoles ? part.curveHoles : []),
            ])
          const slotArr = bigpart.parts
            .filter((p) => !p.blueAreaSurplus && p.specialType !== 'supplus')
            .map((part) => [
              ...part.slots,
              ...(part.millInfo ? part.millInfo : []),
              ...(part.handleSlopes ?? []),
            ])
          const holeToggle = holeArr
            .flat(1)
            .some((v) => v.deep * 1 + 0.001 >= bigpart.thick && !v.isFixedSide)
          const slotToggle = slotArr
            .flat(1)
            .some((v) => v.deep * 1 + 0.001 >= bigpart.thick)
          const isReverePlank = bigpart.parts.some((part) => part.reverePlank)
          if (bigpart && bigpart.ableToggle) {
            if (bigpart.parts[0].is_high_gloss_plank)
              return this.$message.error('高光板禁止翻板')
            if (
              this.$store.state.ncSetting.hole_slot_engraving_process
                .engraving_plank_range.in_range_all
            ) {
              return this.$message.error(
                this.$translateLang(
                  '已开启孔槽分流开料机加工单面板，不允许翻板操作！'
                )
              )
            }
            if (
              ((this.ncSetting.throughTowSideToCut && holeToggle) ||
                (this.ncSetting.through_slot_two_side_cut && slotToggle)) &&
              !isReverePlank
            ) {
              return this.$message.error('大板上存在通孔/通槽，不建议翻版！')
            }
            if (bigpart.parts.some((part) => part.isExpanded)) {
              return this.$message.error(
                this.$translateLang(
                  '板件存在拉槽特殊工艺或特殊异形板，不支持正反面切换操作！'
                )
              )
            }
            if (
              mousePoint.x >= bigpart.startX &&
              mousePoint.x <= bigpart.startX + bigpart.width / 2
            ) {
              if (bigpart.sideType == -1) {
                bigpart.sideType = 1
                this.toggleBigpartData(bigpart)

                this.renderAll()
              }
            }
            if (
              mousePoint.x >= bigpart.startX + bigpart.width / 2 &&
              mousePoint.x <= bigpart.startX + bigpart.width
            ) {
              if (bigpart.sideType == 1) {
                bigpart.sideType = -1
                this.toggleBigpartData(bigpart)

                this.renderAll()
              }
            }
          }
          return null
        }
      } else {
        this.emptyDistance = false
        this.setActiveBigPart(null)

        this.renderAll()
        return null
      }
    },

    /**
     * 判断鼠标是否移动到了蓝色区域（带blueAreaSurplus字段的小板）
     * @param { Object } mousePoint 鼠标坐标 {x, y}
     * @returns { Object | null } 返回蓝色区域小板对象，否则返回null
     */
    checkMouseOnBlueArea(mousePoint) {
      // 找到当前鼠标位置属于哪一个大板
      let arr = this.sliceDrawData.filter(
        (v) => mousePoint.x >= v.startX && mousePoint.y >= v.startY
      )
      if (arr.length == 0) return null

      // 取最后一个大板
      let targetBigpart = arr[arr.length - 1]

      // 找到原数据中的bigpart
      let bigpart = this.sliceDrawData.find(
        (v) => v.stockKey == targetBigpart.stockKey
      )

      if (!bigpart) return null
      // 过滤出带有blueAreaSurplus字段的小板
      const blueAreaParts = bigpart.parts.filter((part) => part.blueAreaSurplus)

      // 判断鼠标是否在蓝色区域内
      for (let i = 0; i < blueAreaParts.length; ++i) {
        let part = blueAreaParts[i]
        let rect = {
          x:
            bigpart.startX +
            this.deviation +
            this.tranlateSizeFromScale(part.startX),
          y:
            bigpart.startY +
            this.deviation +
            this.padding +
            this.tranlateSizeFromScale(part.startY),
        }
        let newPos = {
          x: this.restoreScaleSize(mousePoint.x - rect.x),
          y: this.restoreScaleSize(mousePoint.y - rect.y),
        }
        let curvePath = []
        if (part.path) {
          const curveHolesArr = part.curveHoles?.map((it) => it.path)
          curvePath = [...part.path]
          if (curveHolesArr && curveHolesArr.length && !!curveHolesArr[0]) {
            curvePath.push(...curveHolesArr)
          }
        } else {
          curvePath = [
            [
              { x: 0, y: 0 },
              { x: part.rect.width, y: 0 },
              {
                x: part.rect.width,
                y: part.rect.height,
              },
              { x: 0, y: part.rect.height },
            ],
          ]
        }
        let isInpoly = curvePath
          .map((curve) => this.isInPolygon(newPos, curve))
          .filter((e) => e)
        if (isInpoly.length == 1) {
          return {
            part,
            bigpart,
          }
        }
      }
      return null
    },

    /**
     * @description 旋转板件
     * @param {number} angle - 旋转角度，支持 90、180、270
     * @returns {void}
     */
    async rotatePlank(angle = 90) {
      if (isTextureAlignmentPlank(this.activePlank)) {
        const confirmed = await showTextureConfirmModal(
          this.$translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
          getSameGroupParts(this.activePlank, this.activeBigpart.parts)
        )
        if (!confirmed) return
      }
      switch (angle) {
        case 90:
          rotatePart(this.activePlank, 'manual-rotatePlank')
          break
        case 180:
          rotate180Part(this.activePlank, 'manual-rotatePlank')
          break
        case 270:
          rotatePart(
            rotate180Part(this.activePlank, 'manual-rotatePlank'),
            'manual-rotatePlank'
          )
          break
        default:
          break
      }
      dealPlankPoly(this.activePlank)
      checkOneBigpart(this.activeBigpart)
      // 小板旋转后，检查是否影响复用关系
      this.emitClearReuseIfNeeded(this.activeBigpart)
      this.renderAll()
    },

    // 板件翻面
    async reverePlank() {
      if (this.isHighPlank) return this.$message.error('高光板禁止翻板')
      if (
        this.$store.state.ncSetting.hole_slot_engraving_process
          .engraving_plank_range.in_range_all
      ) {
        return this.$message.error(
          this.$translateLang(
            '已开启孔槽分流开料机加工单面板，不允许翻板操作！'
          )
        )
      }
      if (isTextureAlignmentPlank(this.activePlank)) {
        const confirmed = await showTextureConfirmModal(
          this.$translateLang('当前操作会清除板件对纹信息，请确认是否继续？'),
          getSameGroupParts(this.activePlank, this.activeBigpart.parts)
        )
        if (!confirmed) return
      }
      rolloverPlank(this.activePlank, true)
      dealPlankPoly(this.activePlank)
      checkOneBigpart(this.activeBigpart)
      this.judgeAbleFanban(this.activeBigpart)
      // 翻面后，检查是否影响复用关系（异形板才影响）
      if (this.activePlank.path && this.activePlank.path.length > 0) {
        this.emitClearReuseIfNeeded(this.activeBigpart)
      }
      this.renderAll()
      // 板件翻面后重新计算翻板数
      this.$props.calcFanbanCount()
    },
    // 修改大板余料信息
    changeBigpart(surplus, minX, maxY) {
      // 为什么没有处理 L 型，因为使用余料只能选用矩形余料
      let obj = {
        id: surplus.id,
        width: this.ncSetting.xyReverse
          ? Number(surplus.long)
          : Number(surplus.width),
        height: this.ncSetting.xyReverse
          ? Number(surplus.width)
          : Number(surplus.long),
        area: Number(surplus.area),
        ggid: surplus.ggid,
        is_plus: true,
        branch_name: surplus.branch_name,
        branch_no: surplus.branch_no,
        from_address: surplus.from_address,
        from_order_num: surplus.from_order_num,
        plankNum: surplus.plankNum,
        // 余料自定义修边
        surplus_trim_edge: surplus.surplus_trim_edge,
      }

      this.setActiveBigPart(this.getActiveBigPart(this.activeBigpart.stockKey))
      this.activeBigpart.surplusInfo = obj
      // 重置两个参数
      this.activeBigpart.path = null
      this.activeBigpart.rotateNum = 0
      this.activeBigpart.margin = surplus.surplus_trim_edge
        ? surplus.surplus_trim_edge
        : this.activeBigpart.margin
      // 给余料大板添加oriBigTexture
      this.activeBigpart.oriBigTexture = surplus.color
      supplementBigPlankParam(this.activeBigpart, this.ncSetting)
      let bigPlank = []
      const sawToLayout =
        this.ncSetting.sawSetting.mentaoji_enable &&
        this.ncSetting.sawSetting.sawToLayout &&
        this.ncSetting.sawSetting.processType === 'weldingPlank' &&
        isSawPaiban(store)
      const sawCutOnlyWeld = store.state.ncSetting.sawSetting.sawCutOnlyWeld
      const [texture, matCode, thick] = this.activeBigpart.stockKey.split(':')
      const stockKey = `${texture}:${matCode}:${thick}`
      const cutKnife = getPlateKnifeDiameter(stockKey, this.ncSetting)
      let useKnife = cutKnife
      if (
        sawToLayout &&
        ((sawCutOnlyWeld && this.activeBigpart.isWeldingPlank) ||
          !sawCutOnlyWeld)
      ) {
        useKnife = getSawKnife(this.ncSetting)
      } else {
        useKnife = cutKnife
      }
      // let plankOffset = this.ncSetting.panelSize.plankEdgeOff - useKnife / 2
      let plankOffsetTop, plankOffsetBottom, plankOffsetLeft, plankOffsetRight
      const margin = String(
        surplus.isUseSaw
          ? obj.surplus_trim_edge
          : this.ncSetting.panelSize.plankEdgeOff
      )
      if (margin?.includes(',')) {
        const surplusTrimEdgeArr = margin.split(',')
        plankOffsetTop = Number(surplusTrimEdgeArr[0]) - useKnife / 2
        plankOffsetBottom = Number(surplusTrimEdgeArr[1]) - useKnife / 2
        plankOffsetLeft = Number(surplusTrimEdgeArr[2]) - useKnife / 2
        plankOffsetRight = Number(surplusTrimEdgeArr[3]) - useKnife / 2
      } else {
        const trimEdge = margin
          ? Number(margin)
          : this.ncSetting.panelSize.plankEdgeOff

        const offsetValue = trimEdge - useKnife / 2

        plankOffsetTop = offsetValue
        plankOffsetBottom = offsetValue
        plankOffsetLeft = offsetValue
        plankOffsetRight = offsetValue
      }
      this.activeBigpart.bigPlank = bigPlank
      this.activeBigpart.customSurplus = true
      const [minx, miny, maxx, maxy] = getPathMinMaxPoint(
        this.activeBigpart.path
      )
      const plankWidth = maxx - minx
      const plankHeight = maxy - miny
      for (let i = 0; i < this.activeBigpart.parts.length; ++i) {
        let plank = this.activeBigpart.parts[i]
        plank.surplusInfo = obj
        if (this.ncSetting.xyReverse) {
          plank.startX -= maxY - plankOffsetLeft
          plank.startY -= minX + plankOffsetBottom - plankHeight
        } else {
          plank.startX -= minX - plankOffsetLeft
          plank.startY -= maxY + plankOffsetBottom - plankHeight
        }
        dealPlankPoly(plank)
      }
      this.activeBigpart.parts.forEach((part) => {
        part.plankWidth = plankWidth
        part.plankHeight = plankHeight
      })
      this.activeBigpart.plankWidth = plankWidth
      this.activeBigpart.plankHeight = plankHeight
      this.canvasDom.height = initBigPlanksPositionToCanvas(
        this.sliceDrawData,
        this.scalePercent,
        this.canvasDom.width
      )
      checkOneBigpart(this.activeBigpart)
      // 如果不存在小板，则需要手动重新处理大板轮廓，存在小板的情况下，判断冲突函数内部自动调用
      if (this.activeBigpart.parts.length === 0) {
        dealBigPlank(this.activeBigpart)
      }
      this.emitClearReuseIfNeeded(this.activeBigpart)
      this.renderAll()
      this.$emit('closeSurplusDialog')
      this.$message({
        type: 'success',
        message: '使用余料成功!',
      })
      this.canvasBtn.data = null
    },

    toggleBigpartData(bigpart) {
      for (let i = 0; i < bigpart.parts.length; ++i) {
        let plank = bigpart.parts[i]
        rolloverPlank(plank)
        dealPlankPoly(plank)
        checkOneBigpart(bigpart)
        this.judgeAbleFanban(bigpart)
      }
      // 正反面切换后，检查是否影响复用关系
      this.emitClearReuseIfNeeded(bigpart)
      this.renderAll()
    },

    // 判断点是否在多边形内部
    isInPolygon(checkPoint, polygonPoints) {
      let counter = 0
      let i
      let xinters
      let p1, p2
      let pointCount = polygonPoints.length
      p1 = polygonPoints[0]

      for (i = 1; i <= pointCount; i++) {
        p2 = polygonPoints[i % pointCount]
        if (
          checkPoint.x > Math.min(p1.x, p2.x) &&
          checkPoint.x <= Math.max(p1.x, p2.x)
        ) {
          if (checkPoint.y <= Math.max(p1.y, p2.y)) {
            if (p1.x != p2.x) {
              xinters =
                ((checkPoint.x - p1.x) * (p2.y - p1.y)) / (p2.x - p1.x) + p1.y
              if (p1.y == p2.y || checkPoint.y <= xinters) {
                counter++
              }
            }
          }
        }
        p1 = p2
      }
      if (counter % 2 == 0) {
        return false
      } else {
        return true
      }
    },

    // 清除之前选中的板件样式
    clearLastStyle(activePlank) {
      this.activePlank = activePlank
      for (let item of this.sliceDrawData) {
        this.drawOneBigpart(item)
      }
    },

    // 清除上一次激活板件的绘制
    clearLastActive() {
      // 重新上一个激活板件所在的大板
      if (!this.activePlank) return
      let lastActive = this.sliceDrawData.find(
        (v) => v.stockKey == this.activePlank.stockKey
      )
      if (lastActive) {
        this.ctx.clearRect(
          this.startLeft,
          this.startTop - this.scaleHeight - this.padding,
          this.canvasMaxWidth + this.scaleWidth + 2 * this.padding,
          this.canvasMaxHeight + this.scaleHeight + this.padding
        )
        this.activePlank = null
        const vxMin = this.startLeft - this.scaleWidth - 2 * this.padding
        const vxMax = this.canvasMaxWidth + this.startLeft
        const vyMin = this.startTop - this.scaleHeight - 4 * this.padding
        const vyMax = this.canvasMaxHeight + this.startTop
        // 记录最后绘制的大板, 解决层级问题
        let finalData = {}
        for (let i = 0; i < this.sliceDrawData.length; ++i) {
          let data = this.sliceDrawData[i]
          if (!this.isBigpartOverlappingView(data, vxMin, vyMin, vxMax, vyMax))
            continue
          if (lastActive.stockKey == data.stockKey) {
            finalData = data
            continue
          }
          this.drawOneBigpart(data)
        }

        this.drawOneBigpart(finalData)
      }
    },

    // 搜索过后选中板件
    setNewActivePlank(plank) {
      this.activePlank = plank
      this.activePartUniqueId = plank.partUniqueId
      this.activePlankIDChangeFunc(plank.plankID)
      this.renderAll()
      this.startDraw()
      this.$nextTick(() => {
        this.$emit('getBigPlankH', this.activeBigpart?.startY)
      })
    },
    // 选中大板
    setNewActiveBigpart(bigPart) {
      // let bigpart = this.sliceDrawData.find(
      //   (v) => v.stockKey == bigPart.stockKey
      // )
      this.isShowPaiban = true
      this.setActiveBigPart(bigPart)
      const index = this.drawData.data.findIndex(
        (plank) =>
          plank.canvasIndex === this.activeBigpart.canvasIndex &&
          plank.stockNum === this.activeBigpart.stockNum
      )
      this.currentPape = Math.ceil((index + 1) / this.countPerPage)
      this.renderAll()
      this.startDraw()
      this.$nextTick(() => {
        this.$emit('getBigPlankH', this.activeBigpart?.startY)
      })
    },
    /**
     * 滚动时, 重新绘制
     * @param { Object } scrollOff 滚动条的滚动偏移量
     */
    scrollDraw(scrollOff) {
      // 清除可视范围里的所有绘制, 包括超出可视区域绘制的大板
      this.ctx.clearRect(
        this.startLeft,
        this.startTop - this.scaleHeight - this.padding,
        this.canvasMaxWidth + this.scaleWidth + 2 * this.padding,
        this.canvasMaxHeight + this.scaleHeight + this.padding
      )
      const vxMin = scrollOff.x - this.scaleWidth - 2 * this.padding
      const vxMax = this.canvasMaxWidth + scrollOff.x
      const vyMin = scrollOff.y - this.scaleHeight - 4 * this.padding
      const vyMax = this.canvasMaxHeight + scrollOff.y
      for (let i = 0; i < this.sliceDrawData.length; ++i) {
        let data = this.sliceDrawData[i]
        if (!this.isBigpartOverlappingView(data, vxMin, vyMin, vxMax, vyMax)) {
          continue
        }
        this.drawOneBigpart(data)
      }
    },

    /**
     * 滚轮缩放事件
     * @param { Object } event 事件对象
     */
    scaleCanvas(event, toolScale, isReset = false) {
      // 判断滚轮方向
      // let direction = true
      if (isReset) this.scale = this.oriScale = 6
      else {
        if (event.wheelDelta > 0) {
          if (toolScale) {
            this.scale += this.oriScale * toolScale
          } else {
            this.scale += this.oriScale * 0.1
          }
        } else {
          if (this.scale - this.oriScale * 0.5 < 0.0001) return

          if (toolScale) {
            this.scale += this.oriScale * toolScale
          } else {
            this.scale -= this.oriScale * 0.1
          }

          // direction = false
        }
      }

      this.ctx.clearRect(
        this.startLeft,
        this.startTop - this.scaleHeight - this.padding,
        this.canvasMaxWidth + this.scaleWidth + 2 * this.padding,
        this.canvasMaxHeight + this.scaleHeight + this.padding
      )
      // 记录上一次缩放的比例
      this.lastScale = this.scalePercent
      // 计算缩放的比例
      this.scalePercent = this.scale / defaultScale
      this.$emit('scaleChange', { defaultScale, scale: this.scalePercent })
      // 计算各种间距和大板宽度缩放后的值
      this.scaleWidth = this.tranlateSizeFromScale(this.plankWidth)
      this.scaleHeight = this.tranlateSizeFromScale(this.plankHeight)
      // 只需要通过 this.scalePercent 进行缩放，因为这些默认值都是手动设置的
      this.padding = defaultPadding * this.scalePercent
      this.deviation = defaultDeviation * this.scalePercent
      this.dotWidth = defaultDotWidth * this.scalePercent
      this.textWidth = defaultTextWidth * this.scalePercent
      // 计算可视区域
      let viewWidth = this.canvasMaxWidth + this.startLeft
      let viewHeight = this.canvasMaxHeight + this.startTop
      const vxMin = this.startLeft - this.scaleWidth - 2 * this.padding
      const vxMax = viewWidth
      const vyMin = this.startTop - this.scaleHeight - 4 * this.padding
      const vyMax = viewHeight
      // 抄的网上的, 看不懂(我好菜, 给我答案都看不懂)(现在懂了)

      // 这儿是缩放逻辑,pos记录的鼠标位置到canvas左边和上面的距离
      let pos = this.windowToCanvas(event.clientX, event.clientY)
      for (let i = 0; i < this.sliceDrawData.length; ++i) {
        let data = this.sliceDrawData[i]

        let recordHeight = 0
        let recordWidth = 0
        if (data.surplusInfo) {
          let surplusWidth = data.surplusInfo.width
          let surplusHeight = data.surplusInfo.height
          recordHeight = this.tranlateSizeFromScale(Number(surplusHeight))
          recordWidth = this.tranlateSizeFromScale(Number(surplusWidth))
        } else if (data.specialInfo) {
          recordHeight = this.tranlateSizeFromScale(data.specialInfo.outHeight)
          recordWidth = this.tranlateSizeFromScale(data.specialInfo.outWidth)
        } else {
          recordHeight = this.tranlateSizeFromScale(Number(this.plankHeight))
          recordWidth = this.tranlateSizeFromScale(Number(this.plankWidth))
        }
        // 设置大板的宽高
        data.height = recordHeight
        data.width = recordWidth

        let newPos = {
          // 把鼠标到大板的距离变成缩放前的大小
          x: ((pos.x - data.startX) / this.lastScale).toFixed(2),
          y: ((pos.y - data.startY) / this.lastScale).toFixed(2),
        }
        // this.scalePercent * newPos.x 是指把鼠标打大板的距离按照新的缩放比例重新进行计算
        // pos.x - this.scalePercent * newPos.x 就是大板相对于canvas新的起始坐标（因为缩放是以鼠标所在的位置为基准的）
        data.startX = pos.x - this.scalePercent * newPos.x
        data.startY = pos.y - this.scalePercent * newPos.y
        // 如果超出试图范围，就不用绘制了
        if (!this.isBigpartOverlappingView(data, vxMin, vyMin, vxMax, vyMax)) {
          continue
        }
        this.drawOneBigpart(data)
      }
    },

    /*坐标转换*/
    windowToCanvas(x, y) {
      let box = this.canvasDom.getBoundingClientRect() //这个方法返回一个矩形对象，包含四个属性：left、top、right和bottom。分别表示元素各边与页面上边和左边的距离
      // box.width - this.canvasDom.width 不是等于0吗？？？
      return {
        x: x - box.left - (box.width - this.canvasDom.width) / 2,
        y: y - box.top - (box.height - this.canvasDom.height) / 2,
      }
    },

    // 重新绘制
    renderAll() {
      this.edgeOverlayCanvasOrigin = null
      const clearX = this.startLeft
      const clearY = this.startTop - this.scaleHeight - this.padding
      const clearWidth =
        this.canvasMaxWidth + this.scaleWidth + 2 * this.padding
      const clearHeight = this.canvasMaxHeight + this.scaleHeight + this.padding
      this.ctx.clearRect(clearX, clearY, clearWidth, clearHeight)
      const vxMin = this.startLeft - this.scaleWidth - 2 * this.padding
      const vxMax = this.canvasMaxWidth + this.startLeft
      const vyMin = this.startTop - this.scaleHeight - 4 * this.padding
      const vyMax = this.canvasMaxHeight + this.startTop
      let finalData = null
      this.needMarkRectArr = []
      for (let i = 0; i < this.sliceDrawData.length; ++i) {
        let data = this.sliceDrawData[i]
        if (!this.isBigpartOverlappingView(data, vxMin, vyMin, vxMax, vyMax))
          continue
        if (this.activePlank && this.activePlank.stockKey == data.stockKey) {
          finalData = data
          continue
        }
        this.drawOneBigpart(data)
      }
      if (finalData) {
        this.drawOneBigpart(finalData)
      }
      // 绘制空白位置距离 TODO
      drawPlankEmptyDistance(this.ctx, this.emptyDistance, this.mousePoint)
      // 绘制孔槽详细信息
      drawPlankHSDetailInfo(this.ctx, this.hsDetailInfoList, this.mousePoint)
      // 绘制余料库名称tooltip
      drawPlankHSDetailInfo(this.ctx, this.surStoreTooltip, this.mousePoint)
      // 绘制标记说明
      if (this.markRectTip) {
        drawMarkRectTip(
          this.ctx,
          this.markRectTip.x,
          this.markRectTip.y,
          this.markRect
        )
      }
      // 在四边距离线绘制前再计算：与 drawOneBigpart 写入的 edgeOverlayCanvasOrigin、parts 位置同一帧，避免仅移动后数值与锚点不一致
      this.updateEdgeCenterDistances()
      this.drawEdgeCenterOverlayLast()
    },

    // 判断哪些是需要进行距离计算的选段
    judgeDirectionLine(
      activeArr,
      partArr,
      activePath,
      activePlank,
      part,
      direction,
      stripMeasureActiveBbox = false
    ) {
      // 记录板件间隙
      let distanceArr = []
      let gap =
        this.ncSetting.sawSetting.mentaoji_enable &&
        this.ncSetting.sawSetting.processType == 'doorFrame'
          ? 0
          : this.ncSetting.panelSize.layoutGap
      let { activeTop, activeBottom, activeLeft, activeRight } = activeArr
      let { partTop, partBottom, partLeft, partRight } = partArr
      let maxNum = 0
      let minNum = 0
      const epsStrip = 0.5
      if (direction == 'up' || direction == 'down') {
        if (stripMeasureActiveBbox) {
          const cxActive = (activeLeft + activeRight) / 2
          maxNum = Math.max(partLeft, cxActive - epsStrip)
          minNum = Math.min(partRight, cxActive + epsStrip)
        } else {
          maxNum = Math.max(partLeft, activeLeft)
          minNum = Math.min(partRight, activeRight)
        }
      } else {
        if (stripMeasureActiveBbox) {
          const cyActive = (activeTop + activeBottom) / 2
          maxNum = Math.max(partTop, cyActive - epsStrip)
          minNum = Math.min(partBottom, cyActive + epsStrip)
        } else {
          maxNum = Math.max(partTop, activeTop)
          minNum = Math.min(partBottom, activeBottom)
        }
      }
      // 判断交集的方法, 取两个区间(a, b)(c, d), 如果a和c的最大值小于b和d的最小值, 说明存在交集
      // 注意精度问题
      // 当最大的坐标小于最小的坐标且不相等时, 才会进入判断
      if (maxNum < minNum && Math.abs(maxNum - minNum) > 0.0001) {
        // 如果记录板件与选中板件都为矩形, 则直接求两个板件之间的距离
        if (!activePlank.path && !part.path) {
          if (direction == 'up') {
            // 如果比较板件的顶部小于选中板件的底部, 则在按上的时候不需要继续计算距离
            if (activeBottom < partTop) return { msg: 'continue' }
            // 如果是已经贴合了, 则直接记录最小的板件间隙的值, 当前不可移动, 直接跳出循环
            if (Math.abs(activeTop - partBottom + gap) < 0.001) {
              distanceArr.push(gap)
              return {
                msg: 'break',
                data: distanceArr,
              }
            }
            let distance = activeTop - partBottom
            distanceArr.push(distance)
            return {
              msg: 'continue',
              data: distanceArr,
            }
          }
          if (direction == 'down') {
            // 如果比较板件的底部小于选中板件的顶部, 则在按下的时候不需要继续计算距离
            if (partBottom < activeTop) return { msg: 'continue' }
            // 如果是已经贴合了, 则直接记录最小的板件间隙的值, 当前不可移动, 直接跳出循环
            if (Math.abs(partTop - activeBottom + gap) < 0.001) {
              distanceArr.push(gap)
              return {
                msg: 'break',
                data: distanceArr,
              }
            }
            let distance = partTop - activeBottom
            distanceArr.push(distance)
            return {
              msg: 'continue',
              data: distanceArr,
            }
          }
          if (direction == 'left') {
            // 如果比较板件的
            if (activeLeft < partRight) return { msg: 'continue' }
            if (Math.abs(activeLeft - partRight + gap) < 0.001) {
              distanceArr.push(gap)
              return {
                msg: 'break',
                data: distanceArr,
              }
            }
            let distance = activeLeft - partRight
            distanceArr.push(distance)
            return {
              msg: 'continue',
              data: distanceArr,
            }
          }
          if (direction == 'right') {
            if (activeRight > partLeft) return { msg: 'continue' }
            if (Math.abs(partLeft - activeRight + gap) < 0.001) {
              distanceArr.push(gap)
              return {
                msg: 'break',
                data: distanceArr,
              }
            }
            let distance = partLeft - activeRight
            distanceArr.push(distance)
            return {
              msg: 'continue',
              data: distanceArr,
            }
          }
        }
        // 记录交集
        let range = {}
        if (direction == 'up' || direction == 'down') {
          range.x1 = maxNum
          range.x2 = minNum
        } else {
          range.y1 = maxNum
          range.y2 = minNum
        }

        // 记录比较板件的边框点位
        let partPath = []
        if (part.path) {
          // 先判断小板是否处于比较板件的内部
          if (part.path.length > 1) {
            // 如果是在内部, 则判断是否存在挖洞, 则循环判断每一个选中的板件是否在某一个挖洞内部
            let flag = polyContain([part.polyArr[0]], [activePlank.polyArr[0]])
            if (flag) {
              for (let i = 0; i < part.path.length; ++i) {
                if (i == 0) continue
                let newFlag = polyContain(
                  [part.polyArr[i]],
                  [activePlank.polyArr[0]]
                )
                if (newFlag) {
                  partPath = part.path[i]
                  break
                }
              }
            } else {
              partPath = part.path[0]
            }
          } else {
            partPath = part.path[0]
          }
        } else {
          partPath = [
            { x: 0, y: 0 },
            { x: part.rect.width, y: 0 },
            {
              x: part.rect.width,
              y: part.rect.height,
            },
            { x: 0, y: part.rect.height },
          ]
        }

        // 记录比较板件的所有在交集范围内的横线线段
        let partLineArr = this.getPlankLine(
          partPath,
          part.startX,
          part.startY,
          direction,
          range
        )
        // 根据方向获取选中板件的线段
        // 如果选中的板件是有挖洞的, 则需要重新计算选中板件的点位, 判断和其他板件是否有包含关系
        if (
          !stripMeasureActiveBbox &&
          activePlank.path &&
          activePlank.path.length > 1
        ) {
          // 如果是在内部, 则判断是否存在挖洞, 则循环判断每一个选中的板件是否在某一个挖洞内部
          let flag = polyContain([activePlank.polyArr[0]], [part.polyArr[0]])
          if (flag) {
            for (let i = 0; i < activePlank.path.length; ++i) {
              if (i == 0) continue
              let newFlag = polyContain(
                [activePlank.polyArr[i]],
                [part.polyArr[0]]
              )
              if (newFlag) {
                activePath = activePlank.path[i]
                break
              }
            }
          }
        }
        this.isActivePlankLine = true
        let activeLineArr = this.getPlankLine(
          activePath,
          activePlank.startX,
          activePlank.startY,
          direction,
          range
        )
        this.isActivePlankLine = false
        distanceArr = this.calcDistance(
          activeLineArr,
          partLineArr,
          direction,
          true
        )
        return {
          msg: 'finish',
          data: distanceArr,
          activeLineArr: activeLineArr,
        }
      }
      return { msg: 'continue' }
    },

    // 键盘按下事件
    keyDownFuncs() {
      return async (e) => {
        if (e.ctrlKey) {
          if (!(e.keyCode == 67 || e.keyCode == 86)) {
            e.preventDefault()
            this.isScaling = true
          }
        }
        if (
          (e.code == 'ArrowUp' ||
            e.code == 'ArrowDown' ||
            e.code == 'ArrowLeft' ||
            e.code == 'ArrowRight') &&
          this.isMovingPlank
        ) {
          e.preventDefault()
          return
        }
        if (
          this.activePlank &&
          (e.code == 'ArrowUp' ||
            e.code == 'ArrowDown' ||
            e.code == 'ArrowLeft' ||
            e.code == 'ArrowRight')
        ) {
          const oriActivePlank = JSON.parse(JSON.stringify(this.activePlank))
          e.preventDefault()
          if (this.activeBigpart && this.activeBigpart.isLocked) {
            return this.$message.error(
              this.$translateLang('板件被锁定，无法编辑')
            )
          } else {
            if (this.ncSetting.glass_setting) {
              return this.$message.error(
                this.$translateLang('生产线为玻璃切割机时，板件无法被移动')
              )
            }
            if (this.activePlank.isExpanded) {
              return this.$message.error(
                this.$translateLang('板件存在拉槽特殊工艺，不支持编辑操作！')
              )
            }
            const sameWidthPlank =
              this.ncSetting.sawSetting.mentaoji_enable &&
              ((this.ncSetting.sawSetting.sawToLayout &&
                (!this.ncSetting.sawSetting.sawCutOnlyWeld ||
                  oriActivePlank.isWeldingPlank)) ||
                this.ncSetting.sawSetting.processType === 'doorFrame')
            if (sameWidthPlank) {
              return this.$message.error(
                this.$translateLang('开启了锯片排版,板件无法移动')
              )
            }
            if (isTextureAlignmentPlank(this.activePlank)) {
              return this.$message.error(
                this.$translateLang('对纹板件无法移动')
              )
              // if (this.isTextureConfirming) return
              // this.isTextureConfirming = true
              // const confirmed = await showTextureConfirmModal(
              //   this.$translateLang(
              //     '当前操作会清除板件对纹信息，请确认是否继续？'
              //   ),
              //   getSameGroupParts(this.activePlank, this.activeBigpart.parts)
              // )
              // this.isTextureConfirming = false
              // if (!confirmed) return
            }
          }
          let direction = ''
          switch (e.code) {
            case 'ArrowUp':
              direction = 'up'
              break
            case 'ArrowDown':
              direction = 'down'
              break
            case 'ArrowLeft':
              direction = 'left'
              break
            case 'ArrowRight':
              direction = 'right'
              break
          }
          // 记录移动前的位置
          const { startX, startY } = this.activePlank
          const bigpart = this.findBigpartForEdgeOverlay()
          if (!bigpart) return
          const filteredParts = bigpart.parts.filter(
            (part) => !part.blueAreaSurplus
          )
          const ap = this.resolveLiveActivePart(bigpart)
          if (!ap) return
          if (ap !== this.activePlank) {
            this.activePlank = ap
          }
          const distance = this.calcKeyboardMoveDistance(
            ap,
            bigpart,
            filteredParts,
            direction
          )
          const moved = this.applyKeyboardPlankMove(
            this.activePlank,
            bigpart,
            direction,
            distance,
            startX,
            startY
          )
          if (moved) {
            // 更新蓝色余料的数据
            this.updateBlueAreaSurplusPart(bigpart)
            this.$emit('recordPlankMove', {
              key: '键盘移动小板',
              dataArr: [
                {
                  type: 'form',
                  current: {
                    partName: this.activePlank.partName,
                    startX: this.activePlank.startX,
                    startY: this.activePlank.startY,
                  }, // 当前表单数据
                  ori: {
                    partName: oriActivePlank.partName,
                    startX: oriActivePlank.startX,
                    startY: oriActivePlank.startY,
                  }, // 原始表单数据
                  compareMsg: [
                    {
                      title: this.activePlank.partName,
                      keys: ['canvasIndex', 'startX', 'startY'],
                    },
                  ], // 要比较的内容
                  formTextObj: {
                    partName: '板件名称',
                    canvasIndex: '大板序号',
                    startX: '横坐标',
                    startY: '纵坐标',
                  }, // key对应的意思
                  formValueObj: {}, // value对应的意思
                },
              ],
            })
            if (!this.$props.isBatchBujian) {
              this.setBatchTaggingList([])
            }
            // 键盘移动完成后，检查是否影响复用关系
            this.emitClearReuseIfNeeded(bigpart)
          }
          this.renderAll()
        }
      }
    },
    dealBigPlankLine(path) {
      let arr = []
      for (let i = 0; i < path.length; ++i) {
        let point = path[i]
        let nextPoint = i == path.length - 1 ? path[0] : path[i + 1]
        if (point.X == nextPoint.X && point.Y == nextPoint.Y) continue
        let pathLine = {
          x1: point.X,
          y1: point.Y,
          x2: nextPoint.X,
          y2: nextPoint.Y,
        }
        arr.push(pathLine)
      }
      return arr
    },
    // 计算板件和大板的距离
    calcBigPlankDistance(activeLineArr, bigPartLineArr, direction) {
      let distanceArr = []
      const isHorizontalSeg = (ln) =>
        compareTowNum(ln.y1, ln.y2, '=') || Math.abs(ln.y1 - ln.y2) < 0.001
      const isVerticalSeg = (ln) =>
        compareTowNum(ln.x1, ln.x2, '=') || Math.abs(ln.x1 - ln.x2) < 0.001
      for (let i = 0; i < activeLineArr.length; ++i) {
        let line1 = activeLineArr[i]
        for (let k = 0; k < bigPartLineArr.length; ++k) {
          let line2 = bigPartLineArr[k]
          // 左右净空只与大板竖边比；上下净空只与大板横边比。否则竖边会与上下横边在「纵坐标重叠」误判，误用横边端点 x 算出数百毫米假间距
          if (direction === 'left' || direction === 'right') {
            if (isHorizontalSeg(line2)) continue
          } else if (direction === 'up' || direction === 'down') {
            if (isVerticalSeg(line2)) continue
          }
          if (this.checkRangeIntersect(line1, line2, direction)) {
            if (direction == 'up') {
              if (compareTowNum(line1.y1, line1.y2, '>=')) {
                let distance = line1.y2 - line2.y1
                if (compareTowNum(distance, 0, '>=')) {
                  distanceArr.push(distance)
                }
              } else {
                let distance = line1.y1 - line2.y1
                if (compareTowNum(distance, 0, '>=')) {
                  distanceArr.push(distance)
                }
              }
            }
            if (direction == 'down') {
              if (compareTowNum(line1.y1, line1.y2, '>=')) {
                let distance = line1.y1 - line2.y1
                if (compareTowNum(distance, 0, '<=')) {
                  distanceArr.push(-distance)
                }
              } else {
                let distance = line1.y2 - line2.y1
                if (compareTowNum(distance, 0, '<=')) {
                  distanceArr.push(-distance)
                }
              }
            }
            if (direction == 'left') {
              if (compareTowNum(line1.x1, line1.x2, '>=')) {
                let distance = line1.x2 - line2.x1
                if (compareTowNum(distance, 0, '>=')) {
                  distanceArr.push(distance)
                }
              } else {
                let distance = line1.x1 - line2.x1
                if (compareTowNum(distance, 0, '>=')) {
                  distanceArr.push(distance)
                }
              }
            }
            if (direction == 'right') {
              if (compareTowNum(line1.x1, line1.x2, '>=')) {
                let distance = line1.x1 - line2.x1
                if (compareTowNum(distance, 0, '<=')) {
                  distanceArr.push(-distance)
                }
              } else {
                let distance = line1.x2 - line2.x1
                if (compareTowNum(distance, 0, '<=')) {
                  distanceArr.push(-distance)
                }
              }
            }
          }
        }
      }
      return distanceArr
    },
    // 获取大板边框
    getBigPlankPath(bigpart) {
      // 计算大板修边
      let plankOffset = Math.abs(
        this.ncSetting.knife.diameter / 2 -
          this.ncSetting.panelSize.plankEdgeOff
      )
      let bigPartsPath = []
      let plankWidth = 0
      let plankHeight = 0
      if (
        bigpart.isLocked &&
        bigpart.surplusInfo &&
        Object.keys(bigpart.surplusInfo).length > 0
      ) {
        let surplusInfo = bigpart.surplusInfo
        // 如果为L形余料
        if (surplusInfo.shape && surplusInfo.shape == 'lshape') {
          let x3 = this.ncSetting.xyReverse
            ? Number(surplusInfo.y5)
            : Number(surplusInfo.x3)
          let y3 = this.ncSetting.xyReverse
            ? Number(surplusInfo.x5)
            : Number(surplusInfo.y3)
          let x4 = this.ncSetting.xyReverse
            ? Number(surplusInfo.y4)
            : Number(surplusInfo.x4)
          let y4 = this.ncSetting.xyReverse
            ? Number(surplusInfo.x4)
            : Number(surplusInfo.y4)
          let x5 = this.ncSetting.xyReverse
            ? Number(surplusInfo.y3)
            : Number(surplusInfo.x5)
          let y5 = this.ncSetting.xyReverse
            ? Number(surplusInfo.x3)
            : Number(surplusInfo.y5)
          let newWidth = surplusInfo.width
          let newHeight = surplusInfo.height
          plankWidth = newWidth
          plankHeight = newHeight
          if (
            this.ncSetting.xyReverse &&
            (this.ncSetting.startPosition == '右下角' ||
              this.ncSetting.startPosition == '左上角')
          ) {
            x3 = newWidth - x3
            x4 = newWidth - x4
            x5 = newWidth - x5

            bigPartsPath = [
              {
                x: -plankOffset,
                y: -plankOffset,
              },
              {
                x: newWidth + plankOffset,
                y: -plankOffset,
              },
              {
                x: newWidth + plankOffset,
                y: newHeight + plankOffset,
              },
              {
                x: x3 - plankOffset,
                y: y3 + plankOffset,
              },
              {
                x: x4 - plankOffset,
                y: y4 + plankOffset,
              },
              {
                x: x5 - plankOffset,
                y: y5 + plankOffset,
              },
            ]
          } else {
            bigPartsPath = [
              {
                x: -plankOffset,
                y: -plankOffset,
              },
              {
                x: x3 + plankOffset,
                y: y3 - plankOffset,
              },
              {
                x: x4 + plankOffset,
                y: y4 - plankOffset,
              },
              {
                x: x5 + plankOffset,
                y: y5 + plankOffset,
              },
              {
                x: newWidth + plankOffset,
                y: newHeight + plankOffset,
              },
              {
                x: -plankOffset,
                y: newHeight + plankOffset,
              },
            ]
          }
        } else if (surplusInfo.shape && surplusInfo.shape == 'specialShape') {
          const basePath = dealPathToBasePoint(surplusInfo.path)
          const expandDis = Math.abs(plankOffset)
          const exPath = expandPath(expandDis, toUpperCasePoint(basePath))
          bigPartsPath = exPath[0]
          plankWidth = surplusInfo.width
          plankHeight = surplusInfo.height
        } else {
          bigPartsPath = [
            { x: -plankOffset, y: -plankOffset },
            {
              x: Number(surplusInfo.width) + plankOffset,
              y: -plankOffset,
            },
            {
              x: Number(surplusInfo.width) + plankOffset,
              y: Number(surplusInfo.height) + plankOffset,
            },
            {
              x: -plankOffset,
              y: Number(surplusInfo.height) + plankOffset,
            },
          ]
          plankWidth = surplusInfo.width
          plankHeight = surplusInfo.height
        }
      } else {
        bigPartsPath = [
          { x: -plankOffset, y: -plankOffset },
          {
            x: this.plankWidth + plankOffset,
            y: -plankOffset,
          },
          {
            x: this.plankWidth + plankOffset,
            y: this.plankHeight + plankOffset,
          },
          {
            x: -plankOffset,
            y: this.plankHeight + plankOffset,
          },
        ]
        plankWidth = this.plankWidth
        plankHeight = this.plankHeight
      }
      return {
        bigPartsPath,
        bigPartArr: {
          bigpartTop: -plankOffset,
          bigpartLeft: -plankOffset,
          bigpartRight: plankOffset + plankWidth,
          bigpartBottom: plankOffset + plankHeight,
        },
      }
    },
    // 获取一个板件的所有线段
    getPlankLine(path, startX, startY, direction, range) {
      // 将点位处理成顺时针点位, 然后求相邻两点的垂直向量
      // 判断点位是否是顺时针点位, 通过clipper判断面积, 面积为正数则为逆时针点位, 但是由于canvas原点在左上角, 所以要反过来判断顺逆时针
      let area = ClipperLib.JS.AreaOfPolygon(path)
      if (area < 0) {
        path.reverse()
      }
      // 求垂直的单位向量
      let lineArr = []
      let pathLen = path.length
      for (let k = 0; k < pathLen; ++k) {
        let pathLine = {}
        let point = path[k]
        let nextPoint = k == pathLen - 1 ? path[0] : path[k + 1]
        if (point.x == nextPoint.x && point.y == nextPoint.y) continue
        let a = {
          x: point.x + startX,
          y: point.y + startY,
        }
        let b = {
          x: nextPoint.x + startX,
          y: nextPoint.y + startY,
        }
        // 计算当前线段向量的垂直单位向量
        let c = {
          x: b.x - a.x,
          y: b.y - a.y,
        }
        // 计算方式, 已知向量(x, y) 设要求的单位垂直向量为(a, b)单位向量的摸长为1, 也就是a² + b² = 1, 然后和已知向量垂直就有x * a + y * b = 0, 解二元方程
        // 则a = Math.sqrt( Math.pow(y, 2) / ( Math.pow(x, 2) + Math.pow(y, 2) ) )
        // b = Math.sqrt( 1 - Math.pow(a, 2) )
        let aa = Math.sqrt(
          Math.pow(c.y, 2) / (Math.pow(c.x, 2) + Math.pow(c.y, 2))
        )
        let bb = Math.sqrt(1 - Math.pow(aa, 2))
        if (c.x > 0 && c.y < 0) {
          aa = -aa
          bb = -bb
        }
        if (c.x < 0 && c.y < 0) {
          aa = -aa
        }
        if (c.x > 0 && c.y > 0) {
          bb = -bb
        }
        if (c.x > 0 && c.y == 0) {
          bb = -bb
        }
        if (c.x == 0 && c.y < 0) {
          aa = -aa
        }
        let cd = {}
        if (direction == 'up') {
          cd = { x: 0, y: -1 }
        }
        if (direction == 'down') {
          cd = { x: 0, y: 1 }
        }
        if (direction == 'left') {
          cd = { x: -1, y: 0 }
        }
        if (direction == 'right') {
          cd = { x: 1, y: 0 }
        }
        let cos =
          (aa * cd.x + bb * cd.y) /
          (Math.sqrt(aa * aa + bb * bb) * Math.sqrt(cd.x * cd.x + cd.y * cd.y))
        let angle = (180 * Math.acos(cos)) / Math.PI
        if (
          (compareTowNum(angle, 0, '>=') && compareTowNum(angle, 90, '<=')) ||
          !this.isActivePlankLine
        ) {
          pathLine = {
            x1: a.x,
            y1: a.y,
            x2: b.x,
            y2: b.y,
          }
          // 将pathLine的值按照区间从小到大正常排列之后再进行判断
          if (direction == 'up' || direction == 'down') {
            if (range) {
              if (this.checkRangeIntersect(pathLine, range, direction)) {
                if (pathLine.x1 != pathLine.x2) lineArr.push(pathLine)
              }
            } else {
              if (pathLine.x1 != pathLine.x2) lineArr.push(pathLine)
            }
          }
          if (direction == 'left' || direction == 'right') {
            if (range) {
              if (this.checkRangeIntersect(pathLine, range, direction)) {
                if (pathLine.y1 != pathLine.y2) lineArr.push(pathLine)
              }
            } else {
              if (pathLine.y1 != pathLine.y2) lineArr.push(pathLine)
            }
          }
        }
      }
      return lineArr
    },
    // 计算两条线段的距离
    calcDistance(activeLineArr, partLineArr, direction) {
      let distanceArr = []
      for (let i = 0; i < activeLineArr.length; ++i) {
        let line1 = activeLineArr[i]

        for (let k = 0; k < partLineArr.length; ++k) {
          let line2 = partLineArr[k]
          if (direction == 'up' || direction == 'down') {
            // 先判断点是否在另外一条线段上的区间内, 如果再, 才去求距离
            let a,
              b,
              c,
              d = {}
            let startY = 0
            // 判断line1和line2是否平行
            let isPingxing =
              (line1.x2 - line1.x1) * (line2.y2 - line2.y1) -
              (line2.x2 - line2.x1) * (line1.y2 - line1.y1)
            // 如果两条线段平行, 则直接求任意一点到另一条线段的距离
            if (isPingxing == 0) {
              // 如果是水平的横线, 则直接计算纵坐标的差值
              // 计算直线斜率, 由于平行, 计算任意一条线段的斜率即可, 以line1为准
              let k = (line1.y2 - line1.y1) / (line1.x2 - line1.x1)
              // line1对应的直线则为 y - line1.y1 = k * (x - line1.x1)
              // line2对应的直线则为 y - line2.y1 = k * (x - line2.x1)
              // 化为一般式则是 -kx + y - line1.y1 + k * line1.x1 = 0和-kx + y - line2.y1 + k * line2.x1 = 0
              // 平行线之间的距离则为
              let distance =
                Math.abs(
                  -line1.y1 + k * line1.x1 - (-line2.y1 + k * line2.x1)
                ) / Math.sqrt(Math.pow(k, 2) + 1)
              distanceArr.push(distance)
              continue
            }
            // point.x1在另一条point2内部
            let isInRange = false
            // 将两条线段的横坐标从小到大排列
            let newLine1 = JSON.parse(JSON.stringify(line1))
            if (line1.x1 > line1.x2) {
              newLine1.y1 = line1.y2
              newLine1.y2 = line1.y1
              newLine1.x1 = line1.x2
              newLine1.x2 = line1.x1
            }
            let newLine2 = JSON.parse(JSON.stringify(line2))
            if (line2.x1 > line2.x2) {
              newLine2.y1 = line2.y2
              newLine2.y2 = line2.y1
              newLine2.x1 = line2.x2
              newLine2.x2 = line2.x1
            }
            if (newLine1.x1 > newLine2.x1 && newLine1.x1 < newLine2.x2) {
              // 由该点延伸出一条直线, 求与另一条线段的交点, 然后纵坐标相减求出距离
              // 该点为(x1, y1), 上下移动时延伸出向量, 也就是(0, y1), 和另一条线段的向量(x2 - x1, y2 - y1), 求得交点(x, y), 距离则为|y - y1|
              a = {
                x: newLine1.x1,
                y: newLine1.y1,
              }
              b = { x: newLine1.x1, y: 0 }
              c = {
                x: newLine2.x1,
                y: newLine2.y1,
              }
              d = {
                x: newLine2.x2,
                y: newLine2.y2,
              }
              startY = newLine1.y1
              isInRange = true
            }
            // newLine1.x2在另一条point2内部
            if (newLine1.x2 > newLine2.x1 && newLine1.x2 < newLine2.x2) {
              a = {
                x: newLine1.x2,
                y: newLine1.y2,
              }
              b = { x: newLine1.x2, y: 0 }
              c = {
                x: newLine2.x1,
                y: newLine2.y1,
              }
              d = {
                x: newLine2.x2,
                y: newLine2.y2,
              }
              startY = newLine1.y2
              isInRange = true
            }
            // newLine2.x1在point1内部
            if (newLine2.x1 > newLine1.x1 && newLine2.x1 < newLine1.x2) {
              a = {
                x: newLine2.x1,
                y: newLine2.y1,
              }
              b = { x: newLine2.x1, y: 0 }
              c = {
                x: newLine1.x1,
                y: newLine1.y1,
              }
              d = {
                x: newLine1.x2,
                y: newLine1.y2,
              }
              startY = newLine2.y1
              isInRange = true
            }
            if (newLine2.x2 > newLine1.x1 && newLine2.x2 < newLine1.x2) {
              a = {
                x: newLine2.x2,
                y: newLine2.y2,
              }
              b = { x: newLine2.x2, y: 0 }
              c = {
                x: newLine1.x1,
                y: newLine1.y1,
              }
              d = {
                x: newLine1.x2,
                y: newLine1.y2,
              }
              startY = newLine2.y2
              isInRange = true
            }
            if (!isInRange) continue
            let denominator =
              (b.x - a.x) * (d.y - c.y) - (d.x - c.x) * (b.y - a.y)
            if (denominator == 0) continue
            // 如果平行, 则直接求两条线段的纵坐标距离
            let b1 = (b.y - a.y) * a.x + (a.x - b.x) * a.y
            let b2 = (d.y - c.y) * c.x + (c.x - d.x) * c.y
            let y = (b2 * (b.y - a.y) - b1 * (d.y - c.y)) / denominator
            let distance = Math.abs(y - startY)
            distanceArr.push(distance)
          }
          if (direction == 'left' || direction == 'right') {
            // 先判断点是否在另外一条线段上的区间内, 如果再, 才去求距离
            let a,
              b,
              c,
              d = {}
            let startX = 0
            // 判断line1和line2是否平行
            let isPingxing =
              (line1.x2 - line1.x1) * (line2.y2 - line2.y1) -
              (line2.x2 - line2.x1) * (line1.y2 - line1.y1)
            // 如果两条线段平行, 则直接求任意一点到另一条线段的距离
            if (isPingxing == 0) {
              // 如果为垂直的竖线, 则直接计算横坐标的差值
              if (line1.x1 == line1.x2) {
                let distance = Math.abs(line1.x1 - line2.x1)
                distanceArr.push(distance)
                continue
              } else {
                // 计算直线斜率, 由于平行, 计算任意一条线段的斜率即可, 以line1为准
                let k = (line1.y2 - line1.y1) / (line1.x2 - line1.x1)
                // line1对应的直线则为 y - line1.y1 = k * (x - line1.x1)
                // line2对应的直线则为 y - line2.y1 = k * (x - line2.x1)
                // 化为一般式则是 -kx + y - line1.y1 + k * line1.x1 = 0和-kx + y - line2.y1 + k * line2.x1 = 0
                // 平行线之间的距离则为
                let distance =
                  Math.abs(
                    -line1.y1 + k * line1.x1 - (-line2.y1 + k * line2.x1)
                  ) / Math.sqrt(Math.pow(k, 2) + 1)
                distanceArr.push(distance)
                continue
              }
            }
            // point.x1在另一条point2内部
            let isInRange = false
            // 将两条线段的纵坐标从小到大排列
            let newLine1 = JSON.parse(JSON.stringify(line1))
            if (line1.y1 > line1.y2) {
              newLine1.y1 = line1.y2
              newLine1.y2 = line1.y1
              newLine1.x1 = line1.x2
              newLine1.x2 = line1.x1
            }
            let newLine2 = JSON.parse(JSON.stringify(line2))
            if (line2.y1 > line2.y2) {
              newLine2.y1 = line2.y2
              newLine2.y2 = line2.y1
              newLine2.x1 = line2.x2
              newLine2.x2 = line2.x1
            }
            if (newLine1.y1 > newLine2.y1 && newLine1.y1 < newLine2.y2) {
              // 由该点延伸出一条直线, 求与另一条线段的交点, 然后纵坐标相减求出距离
              // 该点为(x1, y1), 上下移动时延伸出向量, 也就是(0, y1), 和另一条线段的向量(x2 - x1, y2 - y1), 求得交点(x, y), 距离则为|y - y1|
              a = {
                x: newLine1.x1,
                y: newLine1.y1,
              }
              b = { x: 0, y: newLine1.y1 }
              c = {
                x: newLine2.x1,
                y: newLine2.y1,
              }
              d = {
                x: newLine2.x2,
                y: newLine2.y2,
              }
              startX = newLine1.x1
              isInRange = true
            }
            // newLine1.x2在另一条point2内部
            if (newLine1.y2 > newLine2.y1 && newLine1.y2 < newLine2.y2) {
              a = {
                x: newLine1.x2,
                y: newLine1.y2,
              }
              b = { x: 0, y: newLine1.y2 }
              c = {
                x: newLine2.x1,
                y: newLine2.y1,
              }
              d = {
                x: newLine2.x2,
                y: newLine2.y2,
              }
              startX = newLine1.x2
              isInRange = true
            }
            // newLine2.x1在point1内部
            if (newLine2.y1 > newLine1.y1 && newLine2.y1 < newLine1.y2) {
              a = {
                x: newLine2.x1,
                y: newLine2.y1,
              }
              b = { x: 0, y: newLine2.y1 }
              c = {
                x: newLine1.x1,
                y: newLine1.y1,
              }
              d = {
                x: newLine1.x2,
                y: newLine1.y2,
              }
              startX = newLine2.x1
              isInRange = true
            }
            if (newLine2.y2 > newLine1.y1 && newLine2.y2 < newLine1.y2) {
              a = {
                x: newLine2.x2,
                y: newLine2.y2,
              }
              b = { x: 0, y: newLine2.y2 }
              c = {
                x: newLine1.x1,
                y: newLine1.y1,
              }
              d = {
                x: newLine1.x2,
                y: newLine1.y2,
              }
              startX = newLine2.x2
              isInRange = true
            }
            if (!isInRange) continue
            let denominator =
              (b.x - a.x) * (d.y - c.y) - (d.x - c.x) * (b.y - a.y)
            if (denominator == 0) continue
            let b1 = (b.y - a.y) * a.x + (a.x - b.x) * a.y
            let b2 = (d.y - c.y) * c.x + (c.x - d.x) * c.y
            let x = (b2 * (b.x - a.x) - b1 * (d.x - c.x)) / denominator
            let distance = Math.abs(x - startX)
            distanceArr.push(distance)
          }
        }
      }
      return distanceArr
    },
    // 判断两个线段是否横坐标是否有交叉位置, 或者纵坐标有交叉位置
    checkRangeIntersect(line1, line2, direction) {
      // direction为up或者down时, 判断横坐标是否有交集
      if (direction == 'up' || direction == 'down') {
        let newLine1 = {}
        let newLine2 = {}
        if (line1.x1 > line1.x2) {
          newLine1.x1 = line1.x2
          newLine1.x2 = line1.x1
        } else {
          newLine1.x1 = line1.x1
          newLine1.x2 = line1.x2
        }
        if (line2.x1 > line2.x2) {
          newLine2.x1 = line2.x2
          newLine2.x2 = line2.x1
        } else {
          newLine2.x1 = line2.x1
          newLine2.x2 = line2.x2
        }
        if (
          Math.max(newLine1.x1, newLine2.x1) <
          Math.min(newLine1.x2, newLine2.x2)
        ) {
          return true
        } else {
          return false
        }
      } else {
        // direction为left或者right时, 判断纵坐标是否有交集
        let newLine1 = {}
        let newLine2 = {}
        if (line1.y1 > line1.y2) {
          newLine1.y1 = line1.y2
          newLine1.y2 = line1.y1
        } else {
          newLine1.y1 = line1.y1
          newLine1.y2 = line1.y2
        }
        if (line2.y1 > line2.y2) {
          newLine2.y1 = line2.y2
          newLine2.y2 = line2.y1
        } else {
          newLine2.y1 = line2.y1
          newLine2.y2 = line2.y2
        }
        if (
          Math.max(newLine1.y1, newLine2.y1) <
          Math.min(newLine1.y2, newLine2.y2)
        ) {
          return true
        } else {
          return false
        }
      }
    },
    // 键盘松开事件
    keyUpFuncs() {
      return () => {
        this.isScaling = false
      }
    },
    mouseWheelFuncs() {
      return (e) => {
        if (e.ctrlKey) {
          // 取消元素的默认行为，这里指的是滑动滚轮浏览器自页面放大
          e.preventDefault()
        }
      }
    },
    // 鼠标松开事件（这儿针对把板件拖动到暂存区、把图片从暂存区拖动到canvas的情况）
    mouseUpFuncs() {
      return async (e) => {
        if (e.button === 0) {
          this.isDrawImage = false
        }
        // 把图片拖动到 canvas 里面,需先判断是否是可拖动状态/是否目标是一个图片/只对当前数据在内部的canvas元素做以下处理
        if (
          this.isDragingPlank &&
          e.target.tagName == 'IMG' &&
          mousePointISInElement(e, `canvas${this.$props.canvasKey}`, 'id')
        ) {
          buryPointApi('layout', 'plate_staged')
          let pos = this.windowToCanvas(e.clientX, e.clientY)
          const dragData = await checkCurrentDragPlankDataIsLoad(
            this.getCurrentStoreDragPlank()
          )
          const parts = this.drawData.data.map((item) => item.parts).flat(1)
          // 使用锯切时 禁止拖动待排库异形

          if (!dragData?.plank) return
          // 门套切割 不支持异形板件排版
          const isDoorFrame =
            this.ncSetting.sawSetting.mentaoji_enable &&
            this.ncSetting.sawSetting.processType === 'doorFrame' &&
            isSawPaiban(store)
          if (isDoorFrame && dragData.plank.path) {
            this.$message.error(
              this.$translateLang(
                '您已开启“锯切雕刻机-门套切割”功能，该功能暂不支持异形板件排版！'
              )
            )
            return
          }
          if (
            dragData.plank.path &&
            parts.length &&
            parts.every((part) => part.isUseSaw)
          ) {
            // 启用锯片切割后不支持直接在排版添加异形板件，如需添加请前往开料清单添加并排版
            this.$message.warning(
              translate('cuttingDock.sawEngraving.tempPaiabanTip')
            )
            return
          }
          let plank = dragData.plank
          this.activePlank = plank
          let { offsetX, offsetY } = this.getOffsetBetweenPointAndCanvas(
            e,
            null,
            true
          )
          // 给板件设置新的index顺序参数
          this.activePlank.index = getPlankMaxIndexByFinalDrawData()
          // 找到当前点击的位置属于哪一个大板, 找到起始坐标小于当前鼠标位置的所有大板, 取最后一个大板
          let arr = this.sliceDrawData.filter(
            (v) => pos.x >= v.startX && pos.y >= v.startY
          )
          // 判断鼠标位置是否在大板所处的位置
          // 如果点到了第一块大板之前的区域, 是没有大板信息的, 所以直接弹回原位置重新绘制
          if (arr.length == 0) {
            this.$message({
              message: translate('arrangedPage.dragWarning'),
              type: 'info',
            })
            this.changeDragingPlank(false)
            this.setActivePlankData(null)
            return
          }
          // 找到原数据中的bigpart
          // 找到当前鼠标位置的最后一个大板
          let targetBigpart = arr[arr.length - 1]
          let bigpart = this.sliceDrawData.find(
            (v) => v.stockKey == targetBigpart.stockKey
          )
          // // 如果找到了大板则继续执行后面的逻辑, 否则弹回原位置重新绘制
          if (bigpart) {
            // 如果鼠标位置在大板上, 则继续执行后面的逻辑, 否则弹回原位置重新绘制
            if (
              pos.x <= bigpart.startX + bigpart.width + 2 * this.deviation &&
              pos.y <=
                bigpart.startY +
                  bigpart.height +
                  this.padding +
                  2 * this.deviation
            ) {
              if (
                bigpart.thick != plank.thick ||
                isHighBigPlank(bigpart) !== !!plank.is_high_gloss_plank ||
                bigpart.isWeldingPlank
              ) {
                this.$message({
                  message: translate('arrangedPage.dragErrTip'),
                  type: 'error',
                })
                this.setActivePlankData(null)
                this.changeDragingPlank(false)
                return
              }
              const brandDragErrTipKey = getBrandDragErrorTipKey(plank, bigpart)
              if (brandDragErrTipKey) {
                this.$message({
                  message: translate(brandDragErrTipKey),
                  type: 'error',
                })
                this.setActivePlankData(null)
                this.changeDragingPlank(false)
                return
              }
              // 同大板内移动 → 不需要扩版，直接走原流程
              const isSameBigpart = bigpart.stockKey === plank.stockKey
              if (isSameBigpart) {
                this.dealCanvasPlankMsg({ offsetX, offsetY }, true)
                if (this.$props.isBatchBujian) {
                  this.setBatchTaggingList([])
                }
                return
              }
              // 目标大板与板件当前材质颜色一致 → 同材质移动，不需要重新扩版
              const sameAsCurrent =
                bigpart.matCode === plank.matCode &&
                (bigpart.texture === plank.texture ||
                  bigpart.allColors.includes(plank.texture))

              if (sameAsCurrent) {
                this.dealCanvasPlankMsg({ offsetX, offsetY }, true)
                if (this.$props.isBatchBujian) {
                  this.setBatchTaggingList([])
                }
              } else {
                // 材质颜色不同（含回到原始材质）→ 需要重新扩版
                this.handleCrossMaterialDrop(bigpart, plank, offsetX, offsetY)
              }
            }
          } else {
            this.$message({
              message: translate('arrangedPage.dragWarning'),
              type: 'info',
            })
            this.setActivePlankData(null)
            this.changeDragingPlank(false)
          }
        }
        // 如果是左键
        if (e.button == 0) {
          // 不要放到上面
          this.resetImageTempFlag()
        }
      }
    },
    // 截取板件生成图片
    cuttingPlank() {
      // 计算当前激活板件的位置
      this.activePlankOff = null
      let imageTempDom = document.querySelector(
        `.select-plank-image-wrap-${this.canvasKey} img`
      )
      let imgUrl = imageTempDom.src
      let title = `${this.activePlank.thick}${this.activePlank.matCode}(${this.activePlank.texture})`
      let obj = {
        imgUrl: imgUrl,
        title: title,
        data: this.activePlank,
      }
      let img = new Image()
      img.src = imgUrl
      let that = this
      img.onload = function () {
        let scaleW = Number(this.width) / 138
        let scaleH = Number(this.height) / 140
        if (this.width <= 138 && this.height <= 140) {
          if (scaleW >= scaleH) {
            obj.width = '100%'
          } else {
            obj.height = '100%'
          }
        }
        if (this.width > 138 && this.height > 140) {
          if (scaleW >= scaleH) {
            obj.width = Number(this.width) / scaleW + 'px'
            obj.height = Number(this.height) / scaleW + 'px'
          } else {
            obj.width = Number(this.width) / scaleH + 'px'
            obj.height = Number(this.height) / scaleH + 'px'
          }
        }
        if (this.width <= 138 && this.height > 140) {
          obj.width = Number(this.width) / scaleH + 'px'
          obj.height = Number(this.height) / scaleH + 'px'
        }
        if (this.width > 138 && this.height <= 140) {
          obj.width = Number(this.width) / scaleW + 'px'
          obj.height = Number(this.height) / scaleW + 'px'
        }
        // 从精细排版返回排版时如果没有保存, 在返回排版时会把暂存区板件释放出来
        that.addTempStorage(obj)
        that.changeTempStorage()
      }
    },
    // 打开精细页面或离开页面时, 移除window上的监听事件
    clearEvent() {
      window.removeEventListener('keydown', this.keyDownEvent)
      window.removeEventListener('keyup', this.keyUpEvent)
      window.removeEventListener('mouseup', this.mouseupEvent)
      window.removeEventListener('mousemove', this.windowMouseMove)
      // 此时移除了鼠标的滚轮事件，需要在退出精细排版的时候给全局页面加上，否则因为事件已经被移除不能阻止到鼠标滚轮的默认事件
      window.removeEventListener('mousewheel', this.mouseWheelEvent, {
        passive: false,
      })
      EventBus.$off('handleChangePaibanWay', this.handleChangePaibanWay)
      EventBus.$off(EventBusKey.TRANSLATE, this.renderAll)
    },
    // window里面的mouse移动
    windowMouseMove(e) {
      if (this.imageTempMousedownFlag) {
        this.hasMoved = true
        // 只有鼠标点下的时候才设置image的位置
        const imageWrap = document.querySelector(
          `.select-plank-image-wrap-${this.canvasKey}`
        )
        imageWrap.style.left =
          e.x - this.mousePointOffsetImage.x - partLineWidth / 2 + 'px'
        imageWrap.style.top =
          e.y - this.mousePointOffsetImage.y - partLineWidth / 2 + 'px'
        this.$emit('autoScrollRightOperationZone', {
          draggableTarget: imageWrap,
          isInCompositionZone: mousePointISInElement(
            e,
            'paiban-await-store',
            'id'
          ),
        })
      }
    },
    // 退出精细排版时, 重新设置监听事件
    addEvent() {
      // 监听键盘ctrl键和上下左右键位
      this.keyDownEvent = this.keyDownFuncs()
      window.addEventListener('keydown', this.keyDownEvent)
      // 监听键盘按键松开事件
      this.keyUpEvent = this.keyUpFuncs()
      window.addEventListener('keyup', this.keyUpEvent)
      this.mouseupEvent = this.mouseUpFuncs()
      // 监听鼠标松开事件
      window.addEventListener('mouseup', this.mouseupEvent)
      window.addEventListener('mousemove', this.windowMouseMove)
      // 监听鼠标滚轮事件
      this.mouseWheelEvent = this.mouseWheelFuncs()
      window.addEventListener('mousewheel', this.mouseWheelEvent, {
        passive: false,
      })
      // 接受全局排版重新排版事件
      EventBus.$on('handleChangePaibanWay', this.handleChangePaibanWay)
      EventBus.$on(EventBusKey.TRANSLATE, this.renderAll)
    },
    // 重置图片标记（在各种mouseup的事件里面调用）
    resetImageTempFlag() {
      this.imageTempMousedownFlag = false
    },
    // 设置图片temp的显隐
    showImageTemp(bool) {
      let wrap = document.querySelector(
        `.select-plank-image-wrap-${this.canvasKey}`
      )
      if (!wrap) {
        return
      }
      if (bool) {
        wrap.style.display = 'block'
      } else {
        wrap.style.display = 'none'
      }
    },
    clearImageTempEvent() {
      const imageWrap = document.querySelector(
        `.select-plank-image-wrap-${this.canvasKey}`
      )
      if (!imageWrap) {
        return
      }
      imageWrap.removeEventListener('mouseup', this.handleImageTempMouseUp)
      imageWrap.removeEventListener('mousedown', this.handleImageTempMouseDown)
      document.body.removeChild(imageWrap)
    },
    getActivePlank() {
      return this.activePlank
    },
    // 初始化预加载锁的logo解决图片闪烁 todo
    // async initPlankLock() {
    //   this.UnLockedImgInstance = await this.loadImageAsync(UnLockedImg)
    //   this.LockedImgInstance = await this.loadImageAsync(LockedImg)
    // },
    // 异步加载图片
    async loadImageAsync(src) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = src
        img.onload = () => resolve(img)
        img.onerror = (error) => reject(error)
      })
    },
    // // 加载读取锁定大板图片
    // loadLockedImg(ctx, x, y, isLocked, lockWidthHeight) {
    //   let lockedImgInstance
    //   lockedImgInstance = isLocked
    //     ? this.UnLockedImgInstance
    //     : this.LockedImgInstance
    //   ctx.drawImage(lockedImgInstance, x, y, lockWidthHeight, lockWidthHeight)
    // },
    // 判断位置
    jundgeLocation(mousePoint, path) {
      if (mousePoint && path) {
        let point = new ClipperLib.IntPoint(mousePoint.x, mousePoint.y)
        const result = ClipperLib.Clipper.PointInPolygon(point, path)
        return result
      }
    },
    // 判断是否点击到了三个点上
    jundgeLocationOnThreePoint(bigpart, mousePoint) {
      if (!bigpart) return false
      const { x, y } = mousePoint
      const minX =
        bigpart.startX +
        2 * this.deviation +
        bigpart.width +
        2 * this.scalePercent
      const maxX =
        bigpart.startX +
        2 * this.deviation +
        bigpart.width +
        42 * this.scalePercent
      const minY = bigpart.startY + this.padding + this.deviation
      const maxY =
        bigpart.startY + this.padding + this.deviation + 40 * this.scalePercent
      if (x >= minX && x <= maxX && y >= minY && y <= maxY) return true
      return false
    },
    //获取当前大板
    getCurrentBigPart(mousePoint) {
      let arr = this.sliceDrawData.filter(
        (v) => mousePoint.x >= v.startX && mousePoint.y >= v.startY
      )
      if (arr.length == 0) return null
      // 判断鼠标位置是否在大板所处的位置
      let targetBigpart = arr[arr.length - 1]
      // 找到原数据中的bigpart
      let bigpart = this.sliceDrawData.find(
        (v) => v.stockKey == targetBigpart.stockKey
      )
      return bigpart
    },
    // 更改锁的hover效果
    changeLockHover(e, bigPart, result) {
      if (result) {
        this.lockHoverInfo.isShow = true
        this.lockHoverInfo.top = e.pageY + 24 * this.scalePercent
        this.lockHoverInfo.left = e.pageX - 94
        this.lockHoverInfo.isLocked = bigPart.isLocked
      } else {
        this.lockHoverInfo.isShow = false
      }
    },
    syncStockKey(plank) {
      if (!plank) return
      // 检查大板和小板的stockNum是否一致，不一致将大板stockNum赋值给小板
      const plankStockKey = plank.stockKey
      plank.parts.forEach((part) => {
        const partStockKey = part.stockKey
        if (partStockKey != plankStockKey) {
          part.stockKey = plankStockKey
        }
      })
      return plank
    },
    handleChangePaibanWay() {
      this.sliceDrawData.forEach((item) => {
        if (item.ableToggle && item.sideType == -1) {
          item.sideType = 1
          this.toggleBigpartData(item)
        }
      })
    },
    activePlankIDChangeFunc(val) {
      this.activePlank = this.drawData.data
        .map((e) => e.parts)
        .flat(1)
        .find(
          (part) =>
            part.plankID === val &&
            part.index == this.activePlankIndex &&
            part.partUniqueId == this.activePartUniqueId
        )
      if (!this.activePlank) return
      const activeBigPlank = this.drawData.data.find((plank) => {
        const idArr = plank.parts.map((part) => part.plankID)
        const indexArr = plank.parts.map((part) => part.index)
        return plank.parts.some(
          (part) =>
            part.plankID == this.activePlank.plankID &&
            part.index == this.activePlank.index &&
            part.partUniqueId == this.activePlank.partUniqueId
        )
      })
      this.setActiveBigPart(activeBigPlank)
      if (this.activeBigpart) {
        this.isShowPaiban = true
        const index = this.drawData.data.findIndex(
          (plank) =>
            plank.canvasIndex == this.activeBigpart.canvasIndex &&
            plank.stockNum == this.activeBigpart.stockNum
        )
        this.currentPape = Math.ceil((index + 1) / this.countPerPage)
      }
    },
    /** 点击整个画布容器 */
    handleCanvasContainer() {
      this.$emit('scaleChange', { defaultScale, scale: this.scalePercent })
    },
    /** 设置活跃大板 */
    setActiveBigPart(val) {
      this.activeBigpart = val
      this.$emit('setActiveBigPart', val)
    },
    /** 设置活跃小板的值 */
    setActivePlankData(val) {
      this.activePlank = val
    },
    translateLang(key) {
      return translate(key)
    },
    /**
     * @description 为什么会有这个函数，因为在其他的页面可能会存在将store中的数据重置的问题，虽然数据还是那些数据但是对象引用丢失了
     * @param stockKey
     */
    getActiveBigPart(stockKey) {
      return this.drawData.data.find((item) => item.stockKey === stockKey)
    },
    /** 操作画布的显示 */
    collapseCanvas(op) {
      if (op) {
        // 收起画布
        this.isShowPaiban = false
      } else {
        // 展开画布
        this.isShowPaiban = true
      }
    },
    /** 旋转大板 */
    handleRotateBigPlank(bigPlank, angle) {
      if (bigPlank.isLocked) {
        return this.$message.error(this.$translateLang('板件被锁定，无法编辑'))
      }
      // 记录旋转圈数：始终以当前姿态为基准，仅统计360°内的实际旋转
      const prevRotateQuarter = bigPlank['plankRotateNum'] ?? 0
      const totalAngle = (((prevRotateQuarter * 90 + angle) % 360) + 360) % 360
      bigPlank['plankRotateNum'] = totalAngle / 90
      rotateBigPlank(bigPlank, angle)
      this.canvasDom.height = initBigPlanksPositionToCanvas(
        this.sliceDrawData,
        this.scalePercent,
        this.canvasDom.width
      )
      // 生成当前的旋转操作数据
      const operateObject = {
        key: `第${bigPlank.canvasIndex}张大板手动旋转`,
        dataArr: [
          {
            type: 'form',
            current: {
              angle,
            }, // 当前表单数据
            ori: {
              angle: 0,
            }, // 原始表单数据
            compareMsg: [
              {
                title: '',
                keys: ['angle'],
              },
            ], // 要比较的内容
            formTextObj: {
              angle: '旋转角度',
            }, // key对应的意思
            formValueObj: {}, // value对应的意思
          },
        ],
      }
      this.updateBlueAreaSurplusPart(bigPlank)
      this.$emit('onAddDataToOperateArr', operateObject)
      // 大板旋转后，检查是否影响复用关系
      this.emitClearReuseIfNeeded(bigPlank)
      this.renderAll()
    },
    // 收起板件列表
    handleFoldCanvas() {
      // 关闭菜单
      this.canvasBtn.data = null
      this.$emit('leftClick')
      this.isShowPaiban = !this.isShowPaiban
    },
    matchHighlightBoardName(matcode) {
      return matchHighlightBoardName(matcode)
    },
    restoreOriginalMatcode(matcode) {
      return restoreOriginalMatcode(matcode)
    },
  },
  async mounted() {
    EventBus.$on(EventBusKey.TRANSLATE, this.renderAll)
    this.startDraw()
    this.refKey = this.canvasKey

    this.addEvent()
  },
  watch: {
    batchBujianList: {
      handler(val) {
        this.bujianList = val
        this.ctx.clearRect && this.renderAll()
      },
      deep: true,
      immediate: true,
    },
    batchTaggingList: {
      handler(val) {
        this.taggingList = val
        this.ctx.clearRect && this.renderAll()
      },
      deep: true,
      immediate: true,
    },
    isCuttingOrder: {
      handler() {
        this.renderAll()
      },
    },
    activePlankID: {
      handler(val) {
        this.activePlankIDChangeFunc(val)
        this.renderAll()
        this.startDraw()
        this.$nextTick(() => {
          this.$emit('getBigPlankH', this.activeBigpart?.startY)
        })
      },
    },
    activePlankIndex: {
      handler(val) {
        this.activePlank = this.drawData.data
          .map((e) => e.parts)
          .flat(1)
          .find(
            (part) =>
              part.plankID === this.activePlankID &&
              part.index == val &&
              part.partUniqueId == this.activePartUniqueId
          )
        if (!this.activePlank) return
        const activeBigPlank = this.drawData.data.find((plank) => {
          const idArr = plank.parts.map((part) => part.plankID)
          const indexArr = plank.parts.map((part) => part.index)
          return plank.parts.some(
            (part) =>
              part.plankID == this.activePlank.plankID &&
              part.index == this.activePlank.index &&
              part.partUniqueId == this.activePlank.partUniqueId
          )
        })

        this.setActiveBigPart(activeBigPlank)
        if (this.activeBigpart) {
          this.isShowPaiban = true
          const index = this.drawData.data.findIndex(
            (plank) =>
              plank.canvasIndex == this.activeBigpart.canvasIndex &&
              plank.stockNum == this.activeBigpart.stockNum
          )
          this.currentPape = Math.ceil((index + 1) / this.countPerPage)
        }
        this.renderAll()
        this.startDraw()
        this.$nextTick(() => {
          this.$emit('getBigPlankH', this.activeBigpart?.startY)
        })
      },
    },
    canvasMaxWidth: {
      handler(val) {
        if (this.canvasTime) {
          clearTimeout(this.canvasTime)
        }
        this.canvasTime = setTimeout(() => {
          this.renderAll()
          this.startDraw()
        }, 500)
      },
    },
    currentPape: {
      handler(val) {
        this.startDraw()
        this.$emit('handleChangePage', val)
      },
    },
    imageTempMousedownFlag(val) {
      this.$emit('handleChangeImageTempMousedownFlag', val)
      if (val) {
        // 显示图片
        this.showImageTemp(true)
      }
    },
    isShowPartSize: {
      handler() {
        this.renderAll()
      },
    },
    isDrawPartCollapsed: {
      handler(val) {
        this.isShowPaiban = !val
      },
      immediate: true,
    },
    isMarkModifiedSmallBoards: {
      handler() {
        this.renderAll()
      },
    },
  },
  beforeDestroy() {
    this.clearEvent()
    this.changeDragingPlank(false)
    this.clearImageTempEvent()
  },
}
</script>

<style scoped lang="less">
.draw-part {
  min-width: 988px;
  margin-bottom: 16px;
  background-color: #fff;

  span {
    font-family: PingFangSC-Regular, 'PingFang SC';
  }

  .bigpart-category {
    min-width: 988px;
    padding: 10px 16px;
    color: #000;
    font-size: 14px;
    background-color: #e7e7e7;
    cursor: pointer;
    user-select: none;
    position: relative;
    display: flex;
    align-items: center;
    text-wrap: nowrap;
    // justify-content: space-between;
    .high-plank {
      display: inline-block;
      box-sizing: border-box;
      height: 25px;
      padding: 0 10px;
      color: #18a8c7;
      font-weight: 600;
      font-size: 12px;
      font-family: 'Helvetica Neue', Helvetica, 'PingFang SC',
        'Hiragino Sans GB', 'Microsoft YaHei', SimSun, sans-serif;
      line-height: 22px;
      border: 2px solid #18a8c7;
      border-radius: 5px;
    }
    .mix-plan {
      display: inline-block;
      box-sizing: border-box;
      height: 25px;
      padding: 0 10px;
      font-weight: 600;
      font-size: 12px;
      font-family: 'Helvetica Neue', Helvetica, 'PingFang SC',
        'Hiragino Sans GB', 'Microsoft YaHei', SimSun, sans-serif;
      line-height: 22px;
      border: 2px solid rgba(107, 33, 182, 0.5);
      border-radius: 5px;
      margin-left: 8px;
      background: linear-gradient(
        90deg,
        #c084d8,
        #a046c0,
        #7b1fa2,
        #6200ea 100%
      );
      background-size: 400% 400%;
      animation: mix-plan-gradient 3s ease-in-out infinite;
      color: transparent;
      -webkit-background-clip: text;
      background-clip: text;
    }

    @keyframes mix-plan-gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
    .specular-selection-tips {
      top: 0px;
      right: -330px;
      width: 320px;
      height: 50px;
    }

    .no-page {
      flex-direction: row-reverse;
    }
  }
  .pageable {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    // background-color: #fff;
    width: 220px;

    .pre-btn,
    .next-btn {
      padding: 0 4px;
    }

    .tex-dir-select {
      width: 200px;
    }

    .fold-canvas:hover {
      color: #18a8c7;
    }
  }
  .unfolder-btn {
    transform: rotate(180deg) !important;
  }
  .left-btn {
    transform: rotate(90deg) !important;
  }
  .right-btn {
    transform: rotate(270deg) !important;
  }
  /** 实现粘性布局 */
  .category-sticky {
    position: -webkit-sticky;
    position: sticky;
    top: -3px;
  }

  .bigpart-info-title {
    margin-right: 24px;
    color: rgba(0, 0, 0, 0.6);
    user-select: none;
  }

  .bigpart-info {
    // color: #fb4444;
  }

  .fold-canvas {
    cursor: pointer;
    &:hover span {
      color: #18a8c7;
    }
    transition: all 0.5s;
  }

  .bigpart-operation {
    position: fixed;
    width: 126px;
    padding: 8px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 4px 8px 0 rgba(190, 190, 190, 0.31);

    > div {
      display: flex;
      align-items: center;
      width: 110px;
      height: 32px;
      margin: 0 auto;
      color: #333;
      line-height: 32px;
      text-align: center;
      cursor: pointer;

      &:hover {
        background: #edeff3;
      }

      .iconfont {
        margin: 0 9px;
      }
    }

    .disabled-btn {
      color: #999;

      &:hover {
        color: #999;
        background: #fff;
      }
    }
  }
}
</style>

<style lang="less">
.select-plank-image,
.select-plank-image-wrap {
  user-select: none !important;
  -webkit-user-drag: none !important;
}
canvas {
  image-rendering: pixelated;
}
</style>
